import * as $protobuf from 'protobufjs/minimal';
import Long__default from 'long';

/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/

$protobuf.util.Long = Long__default;
$protobuf.configure();

const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

const im_proto = $root.im_proto = (() => {

    const im_proto = {};

    im_proto.Frame = (function() {

        function Frame(p) {
            this.headers = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Frame.prototype.seqid = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        Frame.prototype.logid = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        Frame.prototype.service = 0;
        Frame.prototype.method = 0;
        Frame.prototype.headers = $util.emptyArray;
        Frame.prototype.payload_encoding = "";
        Frame.prototype.payload_type = "";
        Frame.prototype.payload = $util.newBuffer([]);

        Frame.create = function create(properties) {
            return new Frame(properties);
        };

        Frame.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            w.uint32(8).uint64(m.seqid);
            w.uint32(16).uint64(m.logid);
            w.uint32(24).int32(m.service);
            w.uint32(32).int32(m.method);
            if (m.headers != null && m.headers.length) {
                for (var i = 0; i < m.headers.length; ++i)
                    $root.im_proto.Frame.ExtendedEntry.encode(m.headers[i], w.uint32(42).fork()).ldelim();
            }
            if (m.payload_encoding != null && Object.hasOwnProperty.call(m, "payload_encoding"))
                w.uint32(50).string(m.payload_encoding);
            if (m.payload_type != null && Object.hasOwnProperty.call(m, "payload_type"))
                w.uint32(58).string(m.payload_type);
            if (m.payload != null && Object.hasOwnProperty.call(m, "payload"))
                w.uint32(66).bytes(m.payload);
            return w;
        };

        Frame.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.Frame();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.seqid = r.uint64();
                    break;
                case 2:
                    m.logid = r.uint64();
                    break;
                case 3:
                    m.service = r.int32();
                    break;
                case 4:
                    m.method = r.int32();
                    break;
                case 5:
                    if (!(m.headers && m.headers.length))
                        m.headers = [];
                    m.headers.push($root.im_proto.Frame.ExtendedEntry.decode(r, r.uint32()));
                    break;
                case 6:
                    m.payload_encoding = r.string();
                    break;
                case 7:
                    m.payload_type = r.string();
                    break;
                case 8:
                    m.payload = r.bytes();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            if (!m.hasOwnProperty("seqid"))
                throw $util.ProtocolError("missing required 'seqid'", { instance: m });
            if (!m.hasOwnProperty("logid"))
                throw $util.ProtocolError("missing required 'logid'", { instance: m });
            if (!m.hasOwnProperty("service"))
                throw $util.ProtocolError("missing required 'service'", { instance: m });
            if (!m.hasOwnProperty("method"))
                throw $util.ProtocolError("missing required 'method'", { instance: m });
            return m;
        };

        Frame.ExtendedEntry = (function() {

            function ExtendedEntry(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            ExtendedEntry.prototype.key = "";
            ExtendedEntry.prototype.value = "";

            ExtendedEntry.create = function create(properties) {
                return new ExtendedEntry(properties);
            };

            ExtendedEntry.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                w.uint32(10).string(m.key);
                w.uint32(18).string(m.value);
                return w;
            };

            ExtendedEntry.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.Frame.ExtendedEntry();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.key = r.string();
                        break;
                    case 2:
                        m.value = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                if (!m.hasOwnProperty("key"))
                    throw $util.ProtocolError("missing required 'key'", { instance: m });
                if (!m.hasOwnProperty("value"))
                    throw $util.ProtocolError("missing required 'value'", { instance: m });
                return m;
            };

            return ExtendedEntry;
        })();

        return Frame;
    })();

    im_proto.IMCMD = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[100] = "SEND_MESSAGE"] = 100;
        values[valuesById[200] = "GET_MESSAGES_BY_USER"] = 200;
        values[valuesById[203] = "GET_MESSAGES_BY_USER_INIT_V2"] = 203;
        values[valuesById[211] = "GET_MESSAGE_INFO_BY_SERVER_ID"] = 211;
        values[valuesById[301] = "GET_MESSAGES_BY_CONVERSATION"] = 301;
        values[valuesById[302] = "GET_MESSAGES_CHECKINFO_IN_CONVERSATION"] = 302;
        values[valuesById[410] = "SEND_USER_ACTION"] = 410;
        values[valuesById[411] = "SEND_INPUT_STATUS"] = 411;
        values[valuesById[500] = "NEW_MSG_NOTIFY"] = 500;
        values[valuesById[504] = "NEW_P2P_MSG_NOTIFY"] = 504;
        values[valuesById[505] = "NEW_BROADCAST_MSG_NOTIFY"] = 505;
        values[valuesById[603] = "MARK_CONVERSATION_DELETE"] = 603;
        values[valuesById[609] = "CREATE_CONVERSATION_V2"] = 609;
        values[valuesById[610] = "GET_CONVERSATION_INFO_LIST_V2"] = 610;
        values[valuesById[611] = "GET_CONVERSATION_INFO_LIST_BY_FAVORITE_V2"] = 611;
        values[valuesById[612] = "GET_CONVERSATION_INFO_LIST_BY_TOP_V2"] = 612;
        values[valuesById[614] = "DISSOLVE_CONVERSATION"] = 614;
        values[valuesById[615] = "GET_CONVERSATIONS_CHECKINFO"] = 615;
        values[valuesById[605] = "CONVERSATION_PARTICIPANTS_LIST"] = 605;
        values[valuesById[650] = "ADD_CONVERSATION_PARTICIPANTS"] = 650;
        values[valuesById[651] = "REMOVE_CONVERSATION_PARTICIPANTS"] = 651;
        values[valuesById[652] = "LEAVE_CONVERSATION"] = 652;
        values[valuesById[654] = "MGET_CONVERSATION_PARTICIPANTS"] = 654;
        values[valuesById[655] = "UPDATE_CONVERSATION_PARTICIPANT"] = 655;
        values[valuesById[701] = "DELETE_MESSAGE"] = 701;
        values[valuesById[702] = "RECALL_MESSAGE"] = 702;
        values[valuesById[705] = "SET_MESSAGE_PROPERTY"] = 705;
        values[valuesById[901] = "GET_CONVERSATION_CORE_INFO"] = 901;
        values[valuesById[902] = "SET_CONVERSATION_CORE_INFO"] = 902;
        values[valuesById[904] = "UPSERT_CONVERSATION_CORE_EXT_INFO"] = 904;
        values[valuesById[921] = "SET_CONVERSATION_SETTING_INFO"] = 921;
        values[valuesById[922] = "UPSERT_CONVERSATION_SETTING_EXT_INFO"] = 922;
        values[valuesById[1001] = "GET_STRANGER_CONVERSATION_LIST"] = 1001;
        values[valuesById[1002] = "GET_STRANGER_MESSAGES_IN_CONVERSATION"] = 1002;
        values[valuesById[1003] = "DELETE_STRANGER_MESSAGE"] = 1003;
        values[valuesById[1004] = "DELETE_STRANGER_CONVERSATION"] = 1004;
        values[valuesById[1005] = "DELETE_ALL_STRANGER_CONVERSATIONS"] = 1005;
        values[valuesById[1006] = "MARK_STRANGER_CONVERSATION_READ"] = 1006;
        values[valuesById[1007] = "MARK_ALL_STRANGER_CONVERSATIONS_READ"] = 1007;
        values[valuesById[1099] = "STRANGER_NEW_MSG_NOTIFY"] = 1099;
        values[valuesById[2000] = "GET_CONVERSATION_PARTICIPANTS_READ_INDEX_V3"] = 2000;
        values[valuesById[2001] = "GET_CONVERSATION_PARTICIPANTS_MIN_INDEX_V3"] = 2001;
        values[valuesById[2002] = "MARK_CONVERSATION_READ_V3"] = 2002;
        values[valuesById[2003] = "GET_MEDIA_UPLOAD_TOKEN"] = 2003;
        values[valuesById[2004] = "GET_MEDIA_URLS"] = 2004;
        values[valuesById[2005] = "GET_TICKET"] = 2005;
        values[valuesById[2006] = "GET_USER_CONVERSATION_LIST"] = 2006;
        values[valuesById[2007] = "BROADCAST_SEND_MESSAGE"] = 2007;
        values[valuesById[2008] = "BROADCAST_RECV_MESSAGE"] = 2008;
        values[valuesById[2009] = "BROADCAST_USER_COUNTER"] = 2009;
        values[valuesById[2010] = "CLIENT_ACK"] = 2010;
        values[valuesById[2011] = "CREATE_VOIP"] = 2011;
        values[valuesById[2012] = "CALL_VOIP"] = 2012;
        values[valuesById[2013] = "UPDATE_VOIP"] = 2013;
        values[valuesById[2014] = "HEARTBEAT_CHANNEL"] = 2014;
        values[valuesById[2015] = "PROFILE_GET_INFO"] = 2015;
        values[valuesById[2016] = "REPORT_CLIENT_METRICS"] = 2016;
        values[valuesById[2017] = "GET_CONFIGS"] = 2017;
        values[valuesById[2021] = "MODIFY_MESSAGE_EXT"] = 2021;
        values[valuesById[2018] = "UNREAD_COUNT_REPORT"] = 2018;
        values[valuesById[2019] = "BLOCK_MEMBERS"] = 2019;
        values[valuesById[2020] = "BLOCK_CONVERSATION"] = 2020;
        values[valuesById[2030] = "GET_UNREAD_COUNT"] = 2030;
        values[valuesById[2031] = "SEND_MESSAGE_P2P"] = 2031;
        values[valuesById[2032] = "GET_BLOCKLIST"] = 2032;
        values[valuesById[2033] = "SET_BLOCKLIST"] = 2033;
        values[valuesById[2034] = "CHECK_IN_BLOCKLIST"] = 2034;
        values[valuesById[2036] = "MARK_MESSAGE"] = 2036;
        values[valuesById[2037] = "PULL_MARK_MESSAGE"] = 2037;
        values[valuesById[2038] = "BATCH_GAT_CONVERSATION_PARTICIPANTS_READINDEX"] = 2038;
        values[valuesById[2043] = "GET_MESSAGE_BY_INIT"] = 2043;
        values[valuesById[2054] = "MARK_MSG_UNREAD_COUNT_REPORT"] = 2054;
        values[valuesById[2055] = "MARK_MSG_GET_UNREAD_COUNT"] = 2055;
        values[valuesById[2056] = "BATCH_UNMARK_MESSAGE"] = 2056;
        values[valuesById[2057] = "CLIENT_BATCH_ACK"] = 2057;
        values[valuesById[2059] = "AUDIO_RECOGNITION"] = 2059;
        return values;
    })();

    im_proto.StatusCode = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OK"] = 0;
        values[valuesById[1] = "INVALID_TOKEN"] = 1;
        values[valuesById[100] = "EXPIRED_TOKEN"] = 100;
        values[valuesById[2] = "INVALID_TICKET"] = 2;
        values[valuesById[4] = "INVALID_REQUEST"] = 4;
        values[valuesById[5] = "INVALID_CMD"] = 5;
        values[valuesById[6] = "SERVER_ERR"] = 6;
        values[valuesById[11] = "USER_FORBIDDEN"] = 11;
        values[valuesById[500] = "INTERNAL_ERROR"] = 500;
        values[valuesById[15] = "MESSAGE_TARGET_CONVERSATION_NOT_EXIST"] = 15;
        values[valuesById[16] = "DEGRADATION_ERROR"] = 16;
        values[valuesById[17] = "RECALL_TIMEOUT"] = 17;
        values[valuesById[19] = "CALLBACK_DENY"] = 19;
        return values;
    })();

    im_proto.SendMessageStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SEND_SUCCEED"] = 0;
        values[valuesById[1] = "USER_NOT_IN_CONVERSATION"] = 1;
        values[valuesById[2] = "CHECK_CONV_NOT_PASS"] = 2;
        values[valuesById[3] = "CHECK_MSG_NOT_PASS"] = 3;
        values[valuesById[4] = "CHECK_MSG_NOT_PASS_BUT_SELF_VISIBLE"] = 4;
        return values;
    })();

    im_proto.Refer = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "ANDROID"] = 1;
        values[valuesById[2] = "IOS"] = 2;
        values[valuesById[3] = "PC"] = 3;
        values[valuesById[4] = "SERVER"] = 4;
        return values;
    })();

    im_proto.ConversationType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "ONE_TO_ONE_CHAT"] = 1;
        values[valuesById[2] = "GROUP_CHAT"] = 2;
        values[valuesById[3] = "LIVE_CHAT"] = 3;
        values[valuesById[4] = "BROADCAST_CHAT"] = 4;
        return values;
    })();

    im_proto.MessageType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "LEGACY_MESSAGE_TYPE_SYSTEM"] = 1;
        values[valuesById[2] = "LEGACY_MESSAGE_TYPE_IMAGE"] = 2;
        values[valuesById[3] = "LEGACY_MESSAGE_TYPE_AUDIO"] = 3;
        values[valuesById[4] = "LEGACY_MESSAGE_TYPE_VIDEO"] = 4;
        values[valuesById[5] = "LEGACY_MESSAGE_TYPE_EMOJI"] = 5;
        values[valuesById[6] = "LEGACY_MESSAGE_TYPE_FILE"] = 6;
        values[valuesById[7] = "LEGACY_MESSAGE_TYPE_TEXT"] = 7;
        values[valuesById[8] = "LEGACY_MESSAGE_TYPE_USER_CARD"] = 8;
        values[valuesById[9] = "LEGACY_MESSAGE_TYPE_TOAST"] = 9;
        values[valuesById[10] = "LEGACY_MESSAGE_TYPE_GROUP_CARD"] = 10;
        values[valuesById[10001] = "MESSAGE_TYPE_TEXT"] = 10001;
        values[valuesById[10002] = "MESSAGE_TYPE_STICKER"] = 10002;
        values[valuesById[10003] = "MESSAGE_TYPE_IMAGE"] = 10003;
        values[valuesById[10004] = "MESSAGE_TYPE_VIDEO"] = 10004;
        values[valuesById[10005] = "MESSAGE_TYPE_FILE"] = 10005;
        values[valuesById[10006] = "MESSAGE_TYPE_AUDIO"] = 10006;
        values[valuesById[10007] = "MESSAGE_TYPE_LOCATION"] = 10007;
        values[valuesById[10008] = "MESSAGE_TYPE_SYSTEM"] = 10008;
        values[valuesById[10009] = "MESSAGE_TYPE_LINK"] = 10009;
        values[valuesById[50001] = "MESSAGE_TYPE_COMMAND"] = 50001;
        values[valuesById[50002] = "MESSAGE_TYPE_UPDATE_MESSAGE_EXT"] = 50002;
        values[valuesById[50010] = "MESSAGE_TYPE_MODE_CHANGE"] = 50010;
        values[valuesById[50003] = "MESSAGE_TYPE_UPDATE_MIN_INDEX"] = 50003;
        values[valuesById[50004] = "MESSAGE_TYPE_USER_ACTION"] = 50004;
        values[valuesById[50005] = "MESSAGE_TYPE_CONVERSATION_DESTROY"] = 50005;
        values[valuesById[50011] = "MESSAGE_TYPE_BLOCK_COMMAND"] = 50011;
        values[valuesById[50012] = "MESSAGE_TYPE_MARK_COMMAND"] = 50012;
        values[valuesById[50013] = "MESSAGE_TYPE_READ_COMMAND"] = 50013;
        values[valuesById[50016] = "MESSAGE_TYPE_BATCH_UNMARK_COMMAND"] = 50016;
        values[valuesById[60001] = "MESSAGE_TYPE_NOTIFY_COMMAND"] = 60001;
        values[valuesById[70001] = "MESSAGE_TYPE_MESSAGE_PROPERTY"] = 70001;
        values[valuesById[70002] = "MESSAGE_TYPE_UPDATE_MESSAGE_PROPERTY"] = 70002;
        values[valuesById[80001] = "MESSAGE_TYPE_VOIP_COMMAND"] = 80001;
        values[valuesById[80002] = "MESSAGE_TYPE_VOIP_CARD_COMMAND"] = 80002;
        values[valuesById[80003] = "MESSAGE_TYPE_VOIP_SINGLE_CHAT_STATUS_COMMAND"] = 80003;
        values[valuesById[80004] = "MESSAGE_TYPE_VOIP_CALLEE_LIST_UPDATE_NOTIFY"] = 80004;
        return values;
    })();

    im_proto.GroupRole = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ORDINARY"] = 0;
        values[valuesById[1] = "OWNER"] = 1;
        values[valuesById[2] = "MANAGER"] = 2;
        values[valuesById[3] = "VISITOR"] = 3;
        return values;
    })();

    im_proto.TicketType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "TICKET_TYPE_APP"] = 1;
        values[valuesById[2] = "TICKET_TYPE_PC"] = 2;
        values[valuesById[3] = "TICKET_TYPE_WEB"] = 3;
        return values;
    })();

    im_proto.MuteMessageType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "TYPE_MENTION"] = 1;
        values[valuesById[2] = "TYPE_SEND_BY_GROUP_OWNER"] = 2;
        values[valuesById[3] = "TYPE_AUTO_SEND_BY_SERVER"] = 3;
        values[valuesById[4] = "TYPE_MENTION_AND_SEND_BY_GROUP_OWNER"] = 4;
        return values;
    })();

    im_proto.MuteBadgeCountInfo = (function() {

        function MuteBadgeCountInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MuteBadgeCountInfo.prototype.message_type = 1;
        MuteBadgeCountInfo.prototype.badge_count = 0;

        MuteBadgeCountInfo.create = function create(properties) {
            return new MuteBadgeCountInfo(properties);
        };

        MuteBadgeCountInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            w.uint32(8).int32(m.message_type);
            w.uint32(16).int32(m.badge_count);
            return w;
        };

        MuteBadgeCountInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MuteBadgeCountInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.message_type = r.int32();
                    break;
                case 2:
                    m.badge_count = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            if (!m.hasOwnProperty("message_type"))
                throw $util.ProtocolError("missing required 'message_type'", { instance: m });
            if (!m.hasOwnProperty("badge_count"))
                throw $util.ProtocolError("missing required 'badge_count'", { instance: m });
            return m;
        };

        return MuteBadgeCountInfo;
    })();

    im_proto.PropertyItem = (function() {

        function PropertyItem(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PropertyItem.prototype.uid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        PropertyItem.prototype.sec_uid = "";
        PropertyItem.prototype.create_time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        PropertyItem.prototype.idempotent_id = "";
        PropertyItem.prototype.value = "";

        PropertyItem.create = function create(properties) {
            return new PropertyItem(properties);
        };

        PropertyItem.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.uid != null && Object.hasOwnProperty.call(m, "uid"))
                w.uint32(8).int64(m.uid);
            if (m.sec_uid != null && Object.hasOwnProperty.call(m, "sec_uid"))
                w.uint32(18).string(m.sec_uid);
            if (m.create_time != null && Object.hasOwnProperty.call(m, "create_time"))
                w.uint32(24).int64(m.create_time);
            if (m.idempotent_id != null && Object.hasOwnProperty.call(m, "idempotent_id"))
                w.uint32(34).string(m.idempotent_id);
            if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                w.uint32(42).string(m.value);
            return w;
        };

        PropertyItem.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.PropertyItem();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.uid = r.int64();
                    break;
                case 2:
                    m.sec_uid = r.string();
                    break;
                case 3:
                    m.create_time = r.int64();
                    break;
                case 4:
                    m.idempotent_id = r.string();
                    break;
                case 5:
                    m.value = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyItem;
    })();

    im_proto.PropertyItemList = (function() {

        function PropertyItemList(p) {
            this.Items = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PropertyItemList.prototype.Items = $util.emptyArray;

        PropertyItemList.create = function create(properties) {
            return new PropertyItemList(properties);
        };

        PropertyItemList.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Items != null && m.Items.length) {
                for (var i = 0; i < m.Items.length; ++i)
                    $root.im_proto.PropertyItem.encode(m.Items[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        PropertyItemList.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.PropertyItemList();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.Items && m.Items.length))
                        m.Items = [];
                    m.Items.push($root.im_proto.PropertyItem.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PropertyItemList;
    })();

    im_proto.MessageBody = (function() {

        function MessageBody(p) {
            this.ext = {};
            this.property_list = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MessageBody.prototype.conversation_id = "";
        MessageBody.prototype.conversation_type = 0;
        MessageBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessageBody.prototype.index_in_conversation = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessageBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessageBody.prototype.message_type = 0;
        MessageBody.prototype.sender = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessageBody.prototype.content = "";
        MessageBody.prototype.ext = $util.emptyObject;
        MessageBody.prototype.create_time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessageBody.prototype.version = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessageBody.prototype.status = 0;
        MessageBody.prototype.order_in_conversation = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessageBody.prototype.sec_sender = "";
        MessageBody.prototype.property_list = $util.emptyObject;
        MessageBody.prototype.reference_info = null;

        MessageBody.create = function create(properties) {
            return new MessageBody(properties);
        };

        MessageBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.server_message_id != null && Object.hasOwnProperty.call(m, "server_message_id"))
                w.uint32(24).int64(m.server_message_id);
            if (m.index_in_conversation != null && Object.hasOwnProperty.call(m, "index_in_conversation"))
                w.uint32(32).int64(m.index_in_conversation);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(40).int64(m.conversation_short_id);
            if (m.message_type != null && Object.hasOwnProperty.call(m, "message_type"))
                w.uint32(48).int32(m.message_type);
            if (m.sender != null && Object.hasOwnProperty.call(m, "sender"))
                w.uint32(56).int64(m.sender);
            if (m.content != null && Object.hasOwnProperty.call(m, "content"))
                w.uint32(66).string(m.content);
            if (m.ext != null && Object.hasOwnProperty.call(m, "ext")) {
                for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
                    w.uint32(74).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
                }
            }
            if (m.create_time != null && Object.hasOwnProperty.call(m, "create_time"))
                w.uint32(80).int64(m.create_time);
            if (m.version != null && Object.hasOwnProperty.call(m, "version"))
                w.uint32(88).int64(m.version);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(96).int32(m.status);
            if (m.order_in_conversation != null && Object.hasOwnProperty.call(m, "order_in_conversation"))
                w.uint32(104).int64(m.order_in_conversation);
            if (m.sec_sender != null && Object.hasOwnProperty.call(m, "sec_sender"))
                w.uint32(114).string(m.sec_sender);
            if (m.property_list != null && Object.hasOwnProperty.call(m, "property_list")) {
                for (var ks = Object.keys(m.property_list), i = 0; i < ks.length; ++i) {
                    w.uint32(122).fork().uint32(10).string(ks[i]);
                    $root.im_proto.PropertyItemList.encode(m.property_list[ks[i]], w.uint32(18).fork()).ldelim().ldelim();
                }
            }
            if (m.reference_info != null && Object.hasOwnProperty.call(m, "reference_info"))
                $root.im_proto.ReferenceInfo.encode(m.reference_info, w.uint32(146).fork()).ldelim();
            return w;
        };

        MessageBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MessageBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.server_message_id = r.int64();
                    break;
                case 4:
                    m.index_in_conversation = r.int64();
                    break;
                case 5:
                    m.conversation_short_id = r.int64();
                    break;
                case 6:
                    m.message_type = r.int32();
                    break;
                case 7:
                    m.sender = r.int64();
                    break;
                case 8:
                    m.content = r.string();
                    break;
                case 9:
                    if (m.ext === $util.emptyObject)
                        m.ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.ext[k] = value;
                    break;
                case 10:
                    m.create_time = r.int64();
                    break;
                case 11:
                    m.version = r.int64();
                    break;
                case 12:
                    m.status = r.int32();
                    break;
                case 13:
                    m.order_in_conversation = r.int64();
                    break;
                case 14:
                    m.sec_sender = r.string();
                    break;
                case 15:
                    if (m.property_list === $util.emptyObject)
                        m.property_list = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = null;
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = $root.im_proto.PropertyItemList.decode(r, r.uint32());
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.property_list[k] = value;
                    break;
                case 18:
                    m.reference_info = $root.im_proto.ReferenceInfo.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MessageBody;
    })();

    im_proto.ReferenceInfo = (function() {

        function ReferenceInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ReferenceInfo.prototype.referenced_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ReferenceInfo.prototype.hint = "";
        ReferenceInfo.prototype.ref_message_type = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ReferenceInfo.prototype.referenced_message_status = 0;
        ReferenceInfo.prototype.root_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ReferenceInfo.prototype.root_message_conv_index = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        ReferenceInfo.create = function create(properties) {
            return new ReferenceInfo(properties);
        };

        ReferenceInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            w.uint32(8).int64(m.referenced_message_id);
            w.uint32(18).string(m.hint);
            w.uint32(24).int64(m.ref_message_type);
            w.uint32(32).int32(m.referenced_message_status);
            if (m.root_message_id != null && Object.hasOwnProperty.call(m, "root_message_id"))
                w.uint32(40).int64(m.root_message_id);
            if (m.root_message_conv_index != null && Object.hasOwnProperty.call(m, "root_message_conv_index"))
                w.uint32(48).int64(m.root_message_conv_index);
            return w;
        };

        ReferenceInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ReferenceInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.referenced_message_id = r.int64();
                    break;
                case 2:
                    m.hint = r.string();
                    break;
                case 3:
                    m.ref_message_type = r.int64();
                    break;
                case 4:
                    m.referenced_message_status = r.int32();
                    break;
                case 5:
                    m.root_message_id = r.int64();
                    break;
                case 6:
                    m.root_message_conv_index = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            if (!m.hasOwnProperty("referenced_message_id"))
                throw $util.ProtocolError("missing required 'referenced_message_id'", { instance: m });
            if (!m.hasOwnProperty("hint"))
                throw $util.ProtocolError("missing required 'hint'", { instance: m });
            if (!m.hasOwnProperty("ref_message_type"))
                throw $util.ProtocolError("missing required 'ref_message_type'", { instance: m });
            if (!m.hasOwnProperty("referenced_message_status"))
                throw $util.ProtocolError("missing required 'referenced_message_status'", { instance: m });
            return m;
        };

        return ReferenceInfo;
    })();

    im_proto.ParticipantRole = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PARTICIPANT_ROLE_NORMAL"] = 0;
        values[valuesById[1] = "PARTICIPANT_ROLE_OWNER"] = 1;
        values[valuesById[2] = "PARTICIPANT_ROLE_ADMIN"] = 2;
        values[valuesById[3] = "PARTICIPANT_ROLE_VISITOR"] = 3;
        return values;
    })();

    im_proto.Participant = (function() {

        function Participant(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Participant.prototype.user_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        Participant.prototype.sort_order = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        Participant.prototype.role = 0;
        Participant.prototype.alias = "";
        Participant.prototype.sec_uid = "";
        Participant.prototype.blocked = 0;
        Participant.prototype.left_block_time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        Participant.create = function create(properties) {
            return new Participant(properties);
        };

        Participant.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.user_id != null && Object.hasOwnProperty.call(m, "user_id"))
                w.uint32(8).int64(m.user_id);
            if (m.sort_order != null && Object.hasOwnProperty.call(m, "sort_order"))
                w.uint32(16).int64(m.sort_order);
            if (m.role != null && Object.hasOwnProperty.call(m, "role"))
                w.uint32(24).int32(m.role);
            if (m.alias != null && Object.hasOwnProperty.call(m, "alias"))
                w.uint32(34).string(m.alias);
            if (m.sec_uid != null && Object.hasOwnProperty.call(m, "sec_uid"))
                w.uint32(42).string(m.sec_uid);
            if (m.blocked != null && Object.hasOwnProperty.call(m, "blocked"))
                w.uint32(48).int32(m.blocked);
            if (m.left_block_time != null && Object.hasOwnProperty.call(m, "left_block_time"))
                w.uint32(56).int64(m.left_block_time);
            return w;
        };

        Participant.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.Participant();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.user_id = r.int64();
                    break;
                case 2:
                    m.sort_order = r.int64();
                    break;
                case 3:
                    m.role = r.int32();
                    break;
                case 4:
                    m.alias = r.string();
                    break;
                case 5:
                    m.sec_uid = r.string();
                    break;
                case 6:
                    m.blocked = r.int32();
                    break;
                case 7:
                    m.left_block_time = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Participant;
    })();

    im_proto.ParticipantsPage = (function() {

        function ParticipantsPage(p) {
            this.participants = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ParticipantsPage.prototype.participants = $util.emptyArray;
        ParticipantsPage.prototype.has_more = false;
        ParticipantsPage.prototype.cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        ParticipantsPage.create = function create(properties) {
            return new ParticipantsPage(properties);
        };

        ParticipantsPage.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.participants != null && m.participants.length) {
                for (var i = 0; i < m.participants.length; ++i)
                    $root.im_proto.Participant.encode(m.participants[i], w.uint32(10).fork()).ldelim();
            }
            if (m.has_more != null && Object.hasOwnProperty.call(m, "has_more"))
                w.uint32(16).bool(m.has_more);
            if (m.cursor != null && Object.hasOwnProperty.call(m, "cursor"))
                w.uint32(24).int64(m.cursor);
            return w;
        };

        ParticipantsPage.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ParticipantsPage();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.participants && m.participants.length))
                        m.participants = [];
                    m.participants.push($root.im_proto.Participant.decode(r, r.uint32()));
                    break;
                case 2:
                    m.has_more = r.bool();
                    break;
                case 3:
                    m.cursor = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ParticipantsPage;
    })();

    im_proto.ConversationInfoV2 = (function() {

        function ConversationInfoV2(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationInfoV2.prototype.conversation_id = "";
        ConversationInfoV2.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationInfoV2.prototype.conversation_type = 0;
        ConversationInfoV2.prototype.ticket = "";
        ConversationInfoV2.prototype.first_page_participants = null;
        ConversationInfoV2.prototype.participants_count = 0;
        ConversationInfoV2.prototype.is_participant = false;
        ConversationInfoV2.prototype.inbox_type = 0;
        ConversationInfoV2.prototype.user_info = null;
        ConversationInfoV2.prototype.conversation_core_info = null;
        ConversationInfoV2.prototype.conversation_setting_info = null;

        ConversationInfoV2.create = function create(properties) {
            return new ConversationInfoV2(properties);
        };

        ConversationInfoV2.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.ticket != null && Object.hasOwnProperty.call(m, "ticket"))
                w.uint32(34).string(m.ticket);
            if (m.first_page_participants != null && Object.hasOwnProperty.call(m, "first_page_participants"))
                $root.im_proto.ParticipantsPage.encode(m.first_page_participants, w.uint32(50).fork()).ldelim();
            if (m.participants_count != null && Object.hasOwnProperty.call(m, "participants_count"))
                w.uint32(56).int32(m.participants_count);
            if (m.is_participant != null && Object.hasOwnProperty.call(m, "is_participant"))
                w.uint32(64).bool(m.is_participant);
            if (m.inbox_type != null && Object.hasOwnProperty.call(m, "inbox_type"))
                w.uint32(72).int32(m.inbox_type);
            if (m.user_info != null && Object.hasOwnProperty.call(m, "user_info"))
                $root.im_proto.Participant.encode(m.user_info, w.uint32(162).fork()).ldelim();
            if (m.conversation_core_info != null && Object.hasOwnProperty.call(m, "conversation_core_info"))
                $root.im_proto.ConversationCoreInfo.encode(m.conversation_core_info, w.uint32(402).fork()).ldelim();
            if (m.conversation_setting_info != null && Object.hasOwnProperty.call(m, "conversation_setting_info"))
                $root.im_proto.ConversationSettingInfo.encode(m.conversation_setting_info, w.uint32(410).fork()).ldelim();
            return w;
        };

        ConversationInfoV2.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationInfoV2();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    m.ticket = r.string();
                    break;
                case 6:
                    m.first_page_participants = $root.im_proto.ParticipantsPage.decode(r, r.uint32());
                    break;
                case 7:
                    m.participants_count = r.int32();
                    break;
                case 8:
                    m.is_participant = r.bool();
                    break;
                case 9:
                    m.inbox_type = r.int32();
                    break;
                case 20:
                    m.user_info = $root.im_proto.Participant.decode(r, r.uint32());
                    break;
                case 50:
                    m.conversation_core_info = $root.im_proto.ConversationCoreInfo.decode(r, r.uint32());
                    break;
                case 51:
                    m.conversation_setting_info = $root.im_proto.ConversationSettingInfo.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ConversationInfoV2;
    })();

    im_proto.ConversationCoreInfo = (function() {

        function ConversationCoreInfo(p) {
            this.ext = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationCoreInfo.prototype.conversation_id = "";
        ConversationCoreInfo.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationCoreInfo.prototype.conversation_type = 0;
        ConversationCoreInfo.prototype.info_version = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationCoreInfo.prototype.name = "";
        ConversationCoreInfo.prototype.desc = "";
        ConversationCoreInfo.prototype.icon = "";
        ConversationCoreInfo.prototype.inbox_type = 0;
        ConversationCoreInfo.prototype.notice = "";
        ConversationCoreInfo.prototype.ext = $util.emptyObject;
        ConversationCoreInfo.prototype.owner = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationCoreInfo.prototype.sec_owner = "";

        ConversationCoreInfo.create = function create(properties) {
            return new ConversationCoreInfo(properties);
        };

        ConversationCoreInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.info_version != null && Object.hasOwnProperty.call(m, "info_version"))
                w.uint32(32).int64(m.info_version);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(42).string(m.name);
            if (m.desc != null && Object.hasOwnProperty.call(m, "desc"))
                w.uint32(50).string(m.desc);
            if (m.icon != null && Object.hasOwnProperty.call(m, "icon"))
                w.uint32(58).string(m.icon);
            if (m.inbox_type != null && Object.hasOwnProperty.call(m, "inbox_type"))
                w.uint32(64).int32(m.inbox_type);
            if (m.notice != null && Object.hasOwnProperty.call(m, "notice"))
                w.uint32(74).string(m.notice);
            if (m.ext != null && Object.hasOwnProperty.call(m, "ext")) {
                for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
                    w.uint32(90).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
                }
            }
            if (m.owner != null && Object.hasOwnProperty.call(m, "owner"))
                w.uint32(96).int64(m.owner);
            if (m.sec_owner != null && Object.hasOwnProperty.call(m, "sec_owner"))
                w.uint32(106).string(m.sec_owner);
            return w;
        };

        ConversationCoreInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationCoreInfo(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    m.info_version = r.int64();
                    break;
                case 5:
                    m.name = r.string();
                    break;
                case 6:
                    m.desc = r.string();
                    break;
                case 7:
                    m.icon = r.string();
                    break;
                case 8:
                    m.inbox_type = r.int32();
                    break;
                case 9:
                    m.notice = r.string();
                    break;
                case 11:
                    if (m.ext === $util.emptyObject)
                        m.ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.ext[k] = value;
                    break;
                case 12:
                    m.owner = r.int64();
                    break;
                case 13:
                    m.sec_owner = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ConversationCoreInfo;
    })();

    im_proto.ConversationSettingInfo = (function() {

        function ConversationSettingInfo(p) {
            this.ext = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationSettingInfo.prototype.conversation_id = "";
        ConversationSettingInfo.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationSettingInfo.prototype.conversation_type = 0;
        ConversationSettingInfo.prototype.min_index = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationSettingInfo.prototype.read_index = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationSettingInfo.prototype.mute = 0;
        ConversationSettingInfo.prototype.stick_on_top = 0;
        ConversationSettingInfo.prototype.inbox_type = 0;
        ConversationSettingInfo.prototype.ext = $util.emptyObject;
        ConversationSettingInfo.prototype.setting_version = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationSettingInfo.prototype.favorite = 0;
        ConversationSettingInfo.prototype.set_top_time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationSettingInfo.prototype.set_favorite_time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationSettingInfo.prototype.push_status = 0;

        ConversationSettingInfo.create = function create(properties) {
            return new ConversationSettingInfo(properties);
        };

        ConversationSettingInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.min_index != null && Object.hasOwnProperty.call(m, "min_index"))
                w.uint32(32).int64(m.min_index);
            if (m.read_index != null && Object.hasOwnProperty.call(m, "read_index"))
                w.uint32(40).int64(m.read_index);
            if (m.mute != null && Object.hasOwnProperty.call(m, "mute"))
                w.uint32(48).int32(m.mute);
            if (m.stick_on_top != null && Object.hasOwnProperty.call(m, "stick_on_top"))
                w.uint32(56).int32(m.stick_on_top);
            if (m.inbox_type != null && Object.hasOwnProperty.call(m, "inbox_type"))
                w.uint32(64).int32(m.inbox_type);
            if (m.ext != null && Object.hasOwnProperty.call(m, "ext")) {
                for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
                    w.uint32(74).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
                }
            }
            if (m.setting_version != null && Object.hasOwnProperty.call(m, "setting_version"))
                w.uint32(80).int64(m.setting_version);
            if (m.favorite != null && Object.hasOwnProperty.call(m, "favorite"))
                w.uint32(88).int32(m.favorite);
            if (m.set_top_time != null && Object.hasOwnProperty.call(m, "set_top_time"))
                w.uint32(96).int64(m.set_top_time);
            if (m.set_favorite_time != null && Object.hasOwnProperty.call(m, "set_favorite_time"))
                w.uint32(104).int64(m.set_favorite_time);
            if (m.push_status != null && Object.hasOwnProperty.call(m, "push_status"))
                w.uint32(240).int32(m.push_status);
            return w;
        };

        ConversationSettingInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationSettingInfo(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    m.min_index = r.int64();
                    break;
                case 5:
                    m.read_index = r.int64();
                    break;
                case 6:
                    m.mute = r.int32();
                    break;
                case 7:
                    m.stick_on_top = r.int32();
                    break;
                case 8:
                    m.inbox_type = r.int32();
                    break;
                case 9:
                    if (m.ext === $util.emptyObject)
                        m.ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.ext[k] = value;
                    break;
                case 10:
                    m.setting_version = r.int64();
                    break;
                case 11:
                    m.favorite = r.int32();
                    break;
                case 12:
                    m.set_top_time = r.int64();
                    break;
                case 13:
                    m.set_favorite_time = r.int64();
                    break;
                case 30:
                    m.push_status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ConversationSettingInfo;
    })();

    im_proto.MessagesPerUserRequestBody = (function() {

        function MessagesPerUserRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MessagesPerUserRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessagesPerUserRequestBody.prototype.limit = 50;

        MessagesPerUserRequestBody.create = function create(properties) {
            return new MessagesPerUserRequestBody(properties);
        };

        MessagesPerUserRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.cursor != null && Object.hasOwnProperty.call(m, "cursor"))
                w.uint32(8).int64(m.cursor);
            if (m.limit != null && Object.hasOwnProperty.call(m, "limit"))
                w.uint32(16).int32(m.limit);
            return w;
        };

        MessagesPerUserRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MessagesPerUserRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.cursor = r.int64();
                    break;
                case 2:
                    m.limit = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MessagesPerUserRequestBody;
    })();

    im_proto.MessagesPerUserResponseBody = (function() {

        function MessagesPerUserResponseBody(p) {
            this.messages = [];
            this.conversation_badge_count = [];
            this.hasmore_message_conv_list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MessagesPerUserResponseBody.prototype.messages = $util.emptyArray;
        MessagesPerUserResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessagesPerUserResponseBody.prototype.has_more = false;
        MessagesPerUserResponseBody.prototype.next_interval = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessagesPerUserResponseBody.prototype.next_conversation_version = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessagesPerUserResponseBody.prototype.conversation_badge_count = $util.emptyArray;
        MessagesPerUserResponseBody.prototype.next_cmd_index = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessagesPerUserResponseBody.prototype.hasmore_message_conv_list = $util.emptyArray;

        MessagesPerUserResponseBody.create = function create(properties) {
            return new MessagesPerUserResponseBody(properties);
        };

        MessagesPerUserResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.messages != null && m.messages.length) {
                for (var i = 0; i < m.messages.length; ++i)
                    $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(10).fork()).ldelim();
            }
            if (m.next_cursor != null && Object.hasOwnProperty.call(m, "next_cursor"))
                w.uint32(16).int64(m.next_cursor);
            if (m.has_more != null && Object.hasOwnProperty.call(m, "has_more"))
                w.uint32(24).bool(m.has_more);
            if (m.next_interval != null && Object.hasOwnProperty.call(m, "next_interval"))
                w.uint32(32).int64(m.next_interval);
            if (m.next_conversation_version != null && Object.hasOwnProperty.call(m, "next_conversation_version"))
                w.uint32(40).int64(m.next_conversation_version);
            if (m.conversation_badge_count != null && m.conversation_badge_count.length) {
                for (var i = 0; i < m.conversation_badge_count.length; ++i)
                    $root.im_proto.ConversationBadgeCountInfo.encode(m.conversation_badge_count[i], w.uint32(50).fork()).ldelim();
            }
            if (m.next_cmd_index != null && Object.hasOwnProperty.call(m, "next_cmd_index"))
                w.uint32(56).int64(m.next_cmd_index);
            if (m.hasmore_message_conv_list != null && m.hasmore_message_conv_list.length) {
                for (var i = 0; i < m.hasmore_message_conv_list.length; ++i)
                    w.uint32(64).int64(m.hasmore_message_conv_list[i]);
            }
            return w;
        };

        MessagesPerUserResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MessagesPerUserResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.messages && m.messages.length))
                        m.messages = [];
                    m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
                    break;
                case 2:
                    m.next_cursor = r.int64();
                    break;
                case 3:
                    m.has_more = r.bool();
                    break;
                case 4:
                    m.next_interval = r.int64();
                    break;
                case 5:
                    m.next_conversation_version = r.int64();
                    break;
                case 6:
                    if (!(m.conversation_badge_count && m.conversation_badge_count.length))
                        m.conversation_badge_count = [];
                    m.conversation_badge_count.push($root.im_proto.ConversationBadgeCountInfo.decode(r, r.uint32()));
                    break;
                case 7:
                    m.next_cmd_index = r.int64();
                    break;
                case 8:
                    if (!(m.hasmore_message_conv_list && m.hasmore_message_conv_list.length))
                        m.hasmore_message_conv_list = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.hasmore_message_conv_list.push(r.int64());
                    } else
                        m.hasmore_message_conv_list.push(r.int64());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MessagesPerUserResponseBody;
    })();

    im_proto.ConversationBadgeCountInfo = (function() {

        function ConversationBadgeCountInfo(p) {
            this.mute_badge_count_infos = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationBadgeCountInfo.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationBadgeCountInfo.prototype.badge_count = 0;
        ConversationBadgeCountInfo.prototype.conversation_index_v2 = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationBadgeCountInfo.prototype.conversation_id = "";
        ConversationBadgeCountInfo.prototype.mute_badge_count_infos = $util.emptyArray;

        ConversationBadgeCountInfo.create = function create(properties) {
            return new ConversationBadgeCountInfo(properties);
        };

        ConversationBadgeCountInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            w.uint32(8).int64(m.conversation_short_id);
            w.uint32(16).int32(m.badge_count);
            w.uint32(24).int64(m.conversation_index_v2);
            w.uint32(34).string(m.conversation_id);
            if (m.mute_badge_count_infos != null && m.mute_badge_count_infos.length) {
                for (var i = 0; i < m.mute_badge_count_infos.length; ++i)
                    $root.im_proto.MuteBadgeCountInfo.encode(m.mute_badge_count_infos[i], w.uint32(42).fork()).ldelim();
            }
            return w;
        };

        ConversationBadgeCountInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationBadgeCountInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_short_id = r.int64();
                    break;
                case 2:
                    m.badge_count = r.int32();
                    break;
                case 3:
                    m.conversation_index_v2 = r.int64();
                    break;
                case 4:
                    m.conversation_id = r.string();
                    break;
                case 5:
                    if (!(m.mute_badge_count_infos && m.mute_badge_count_infos.length))
                        m.mute_badge_count_infos = [];
                    m.mute_badge_count_infos.push($root.im_proto.MuteBadgeCountInfo.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            if (!m.hasOwnProperty("conversation_short_id"))
                throw $util.ProtocolError("missing required 'conversation_short_id'", { instance: m });
            if (!m.hasOwnProperty("badge_count"))
                throw $util.ProtocolError("missing required 'badge_count'", { instance: m });
            if (!m.hasOwnProperty("conversation_index_v2"))
                throw $util.ProtocolError("missing required 'conversation_index_v2'", { instance: m });
            if (!m.hasOwnProperty("conversation_id"))
                throw $util.ProtocolError("missing required 'conversation_id'", { instance: m });
            return m;
        };

        return ConversationBadgeCountInfo;
    })();

    im_proto.MessagesPerUserInitV2RequestBody = (function() {

        function MessagesPerUserInitV2RequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MessagesPerUserInitV2RequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessagesPerUserInitV2RequestBody.prototype.new_user = 0;
        MessagesPerUserInitV2RequestBody.prototype.init_sub_type = 0;
        MessagesPerUserInitV2RequestBody.prototype.conv_limit = 0;
        MessagesPerUserInitV2RequestBody.prototype.msg_limit = 0;

        MessagesPerUserInitV2RequestBody.create = function create(properties) {
            return new MessagesPerUserInitV2RequestBody(properties);
        };

        MessagesPerUserInitV2RequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.cursor != null && Object.hasOwnProperty.call(m, "cursor"))
                w.uint32(8).int64(m.cursor);
            if (m.new_user != null && Object.hasOwnProperty.call(m, "new_user"))
                w.uint32(16).int32(m.new_user);
            if (m.init_sub_type != null && Object.hasOwnProperty.call(m, "init_sub_type"))
                w.uint32(24).int32(m.init_sub_type);
            if (m.conv_limit != null && Object.hasOwnProperty.call(m, "conv_limit"))
                w.uint32(32).int32(m.conv_limit);
            if (m.msg_limit != null && Object.hasOwnProperty.call(m, "msg_limit"))
                w.uint32(40).int32(m.msg_limit);
            return w;
        };

        MessagesPerUserInitV2RequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MessagesPerUserInitV2RequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.cursor = r.int64();
                    break;
                case 2:
                    m.new_user = r.int32();
                    break;
                case 3:
                    m.init_sub_type = r.int32();
                    break;
                case 4:
                    m.conv_limit = r.int32();
                    break;
                case 5:
                    m.msg_limit = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MessagesPerUserInitV2RequestBody;
    })();

    im_proto.MessagesPerUserInitV2ResponseBody = (function() {

        function MessagesPerUserInitV2ResponseBody(p) {
            this.messages = [];
            this.conversations = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MessagesPerUserInitV2ResponseBody.prototype.messages = $util.emptyArray;
        MessagesPerUserInitV2ResponseBody.prototype.conversations = $util.emptyArray;
        MessagesPerUserInitV2ResponseBody.prototype.per_user_cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessagesPerUserInitV2ResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessagesPerUserInitV2ResponseBody.prototype.has_more = false;

        MessagesPerUserInitV2ResponseBody.create = function create(properties) {
            return new MessagesPerUserInitV2ResponseBody(properties);
        };

        MessagesPerUserInitV2ResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.messages != null && m.messages.length) {
                for (var i = 0; i < m.messages.length; ++i)
                    $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(10).fork()).ldelim();
            }
            if (m.conversations != null && m.conversations.length) {
                for (var i = 0; i < m.conversations.length; ++i)
                    $root.im_proto.ConversationInfoV2.encode(m.conversations[i], w.uint32(18).fork()).ldelim();
            }
            if (m.per_user_cursor != null && Object.hasOwnProperty.call(m, "per_user_cursor"))
                w.uint32(24).int64(m.per_user_cursor);
            if (m.next_cursor != null && Object.hasOwnProperty.call(m, "next_cursor"))
                w.uint32(32).int64(m.next_cursor);
            if (m.has_more != null && Object.hasOwnProperty.call(m, "has_more"))
                w.uint32(40).bool(m.has_more);
            return w;
        };

        MessagesPerUserInitV2ResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MessagesPerUserInitV2ResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.messages && m.messages.length))
                        m.messages = [];
                    m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
                    break;
                case 2:
                    if (!(m.conversations && m.conversations.length))
                        m.conversations = [];
                    m.conversations.push($root.im_proto.ConversationInfoV2.decode(r, r.uint32()));
                    break;
                case 3:
                    m.per_user_cursor = r.int64();
                    break;
                case 4:
                    m.next_cursor = r.int64();
                    break;
                case 5:
                    m.has_more = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MessagesPerUserInitV2ResponseBody;
    })();

    im_proto.MessageDirection = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "OLDER"] = 1;
        values[valuesById[2] = "NEWER"] = 2;
        values[valuesById[3] = "FROM_LATEST"] = 3;
        return values;
    })();

    im_proto.MessagesInConversationRequestBody = (function() {

        function MessagesInConversationRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MessagesInConversationRequestBody.prototype.conversation_id = "";
        MessagesInConversationRequestBody.prototype.conversation_type = 0;
        MessagesInConversationRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessagesInConversationRequestBody.prototype.direction = 1;
        MessagesInConversationRequestBody.prototype.anchor_index = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessagesInConversationRequestBody.prototype.limit = 50;

        MessagesInConversationRequestBody.create = function create(properties) {
            return new MessagesInConversationRequestBody(properties);
        };

        MessagesInConversationRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(24).int64(m.conversation_short_id);
            if (m.direction != null && Object.hasOwnProperty.call(m, "direction"))
                w.uint32(32).int32(m.direction);
            if (m.anchor_index != null && Object.hasOwnProperty.call(m, "anchor_index"))
                w.uint32(40).int64(m.anchor_index);
            if (m.limit != null && Object.hasOwnProperty.call(m, "limit"))
                w.uint32(48).int32(m.limit);
            return w;
        };

        MessagesInConversationRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MessagesInConversationRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.conversation_short_id = r.int64();
                    break;
                case 4:
                    m.direction = r.int32();
                    break;
                case 5:
                    m.anchor_index = r.int64();
                    break;
                case 6:
                    m.limit = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MessagesInConversationRequestBody;
    })();

    im_proto.MessagesInConversationResponseBody = (function() {

        function MessagesInConversationResponseBody(p) {
            this.messages = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MessagesInConversationResponseBody.prototype.messages = $util.emptyArray;
        MessagesInConversationResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessagesInConversationResponseBody.prototype.has_more = false;

        MessagesInConversationResponseBody.create = function create(properties) {
            return new MessagesInConversationResponseBody(properties);
        };

        MessagesInConversationResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.messages != null && m.messages.length) {
                for (var i = 0; i < m.messages.length; ++i)
                    $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(10).fork()).ldelim();
            }
            if (m.next_cursor != null && Object.hasOwnProperty.call(m, "next_cursor"))
                w.uint32(16).int64(m.next_cursor);
            if (m.has_more != null && Object.hasOwnProperty.call(m, "has_more"))
                w.uint32(24).bool(m.has_more);
            return w;
        };

        MessagesInConversationResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MessagesInConversationResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.messages && m.messages.length))
                        m.messages = [];
                    m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
                    break;
                case 2:
                    m.next_cursor = r.int64();
                    break;
                case 3:
                    m.has_more = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MessagesInConversationResponseBody;
    })();

    im_proto.CreateConversationV2RequestBody = (function() {

        function CreateConversationV2RequestBody(p) {
            this.participants = [];
            this.biz_ext = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CreateConversationV2RequestBody.prototype.conversation_type = 0;
        CreateConversationV2RequestBody.prototype.participants = $util.emptyArray;
        CreateConversationV2RequestBody.prototype.persistent = false;
        CreateConversationV2RequestBody.prototype.idempotent_id = "";
        CreateConversationV2RequestBody.prototype.name = "";
        CreateConversationV2RequestBody.prototype.avatar_url = "";
        CreateConversationV2RequestBody.prototype.description = "";
        CreateConversationV2RequestBody.prototype.biz_ext = $util.emptyObject;

        CreateConversationV2RequestBody.create = function create(properties) {
            return new CreateConversationV2RequestBody(properties);
        };

        CreateConversationV2RequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(8).int32(m.conversation_type);
            if (m.participants != null && m.participants.length) {
                for (var i = 0; i < m.participants.length; ++i)
                    w.uint32(16).int64(m.participants[i]);
            }
            if (m.persistent != null && Object.hasOwnProperty.call(m, "persistent"))
                w.uint32(24).bool(m.persistent);
            if (m.idempotent_id != null && Object.hasOwnProperty.call(m, "idempotent_id"))
                w.uint32(34).string(m.idempotent_id);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(50).string(m.name);
            if (m.avatar_url != null && Object.hasOwnProperty.call(m, "avatar_url"))
                w.uint32(58).string(m.avatar_url);
            if (m.description != null && Object.hasOwnProperty.call(m, "description"))
                w.uint32(66).string(m.description);
            if (m.biz_ext != null && Object.hasOwnProperty.call(m, "biz_ext")) {
                for (var ks = Object.keys(m.biz_ext), i = 0; i < ks.length; ++i) {
                    w.uint32(90).fork().uint32(10).string(ks[i]).uint32(18).string(m.biz_ext[ks[i]]).ldelim();
                }
            }
            return w;
        };

        CreateConversationV2RequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.CreateConversationV2RequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_type = r.int32();
                    break;
                case 2:
                    if (!(m.participants && m.participants.length))
                        m.participants = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.participants.push(r.int64());
                    } else
                        m.participants.push(r.int64());
                    break;
                case 3:
                    m.persistent = r.bool();
                    break;
                case 4:
                    m.idempotent_id = r.string();
                    break;
                case 6:
                    m.name = r.string();
                    break;
                case 7:
                    m.avatar_url = r.string();
                    break;
                case 8:
                    m.description = r.string();
                    break;
                case 11:
                    if (m.biz_ext === $util.emptyObject)
                        m.biz_ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.biz_ext[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateConversationV2RequestBody;
    })();

    im_proto.CreateConversationV2ResponseBody = (function() {

        function CreateConversationV2ResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CreateConversationV2ResponseBody.prototype.conversation = null;
        CreateConversationV2ResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        CreateConversationV2ResponseBody.prototype.check_message = "";
        CreateConversationV2ResponseBody.prototype.extra_info = "";
        CreateConversationV2ResponseBody.prototype.status = 0;

        CreateConversationV2ResponseBody.create = function create(properties) {
            return new CreateConversationV2ResponseBody(properties);
        };

        CreateConversationV2ResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation != null && Object.hasOwnProperty.call(m, "conversation"))
                $root.im_proto.ConversationInfoV2.encode(m.conversation, w.uint32(10).fork()).ldelim();
            if (m.check_code != null && Object.hasOwnProperty.call(m, "check_code"))
                w.uint32(16).int64(m.check_code);
            if (m.check_message != null && Object.hasOwnProperty.call(m, "check_message"))
                w.uint32(26).string(m.check_message);
            if (m.extra_info != null && Object.hasOwnProperty.call(m, "extra_info"))
                w.uint32(34).string(m.extra_info);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(40).int32(m.status);
            return w;
        };

        CreateConversationV2ResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.CreateConversationV2ResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation = $root.im_proto.ConversationInfoV2.decode(r, r.uint32());
                    break;
                case 2:
                    m.check_code = r.int64();
                    break;
                case 3:
                    m.check_message = r.string();
                    break;
                case 4:
                    m.extra_info = r.string();
                    break;
                case 5:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateConversationV2ResponseBody;
    })();

    im_proto.UserActionType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "ENTER_CONVERSATION"] = 1;
        values[valuesById[2] = "EXIT_CONVERSATION"] = 2;
        return values;
    })();

    im_proto.SendUserActionRequestBody = (function() {

        function SendUserActionRequestBody(p) {
            this.extra = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SendUserActionRequestBody.prototype.conversation_id = "";
        SendUserActionRequestBody.prototype.conversation_type = 0;
        SendUserActionRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        SendUserActionRequestBody.prototype.action_type = 1;
        SendUserActionRequestBody.prototype.extra = $util.emptyObject;

        SendUserActionRequestBody.create = function create(properties) {
            return new SendUserActionRequestBody(properties);
        };

        SendUserActionRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(24).int64(m.conversation_short_id);
            if (m.action_type != null && Object.hasOwnProperty.call(m, "action_type"))
                w.uint32(32).int32(m.action_type);
            if (m.extra != null && Object.hasOwnProperty.call(m, "extra")) {
                for (var ks = Object.keys(m.extra), i = 0; i < ks.length; ++i) {
                    w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.extra[ks[i]]).ldelim();
                }
            }
            return w;
        };

        SendUserActionRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.SendUserActionRequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.conversation_short_id = r.int64();
                    break;
                case 4:
                    m.action_type = r.int32();
                    break;
                case 5:
                    if (m.extra === $util.emptyObject)
                        m.extra = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.extra[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SendUserActionRequestBody;
    })();

    im_proto.InputStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[3] = "TYPING"] = 3;
        values[valuesById[4] = "CLEAR_INPUT"] = 4;
        return values;
    })();

    im_proto.SendInputStatusRequestBody = (function() {

        function SendInputStatusRequestBody(p) {
            this.extra = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SendInputStatusRequestBody.prototype.conversation_id = "";
        SendInputStatusRequestBody.prototype.conversation_type = 0;
        SendInputStatusRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        SendInputStatusRequestBody.prototype.status = 3;
        SendInputStatusRequestBody.prototype.extra = $util.emptyObject;

        SendInputStatusRequestBody.create = function create(properties) {
            return new SendInputStatusRequestBody(properties);
        };

        SendInputStatusRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(24).int64(m.conversation_short_id);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(32).int32(m.status);
            if (m.extra != null && Object.hasOwnProperty.call(m, "extra")) {
                for (var ks = Object.keys(m.extra), i = 0; i < ks.length; ++i) {
                    w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.extra[ks[i]]).ldelim();
                }
            }
            return w;
        };

        SendInputStatusRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.SendInputStatusRequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.conversation_short_id = r.int64();
                    break;
                case 4:
                    m.status = r.int32();
                    break;
                case 5:
                    if (m.extra === $util.emptyObject)
                        m.extra = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.extra[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SendInputStatusRequestBody;
    })();

    im_proto.DeleteConversationRequestBody = (function() {

        function DeleteConversationRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        DeleteConversationRequestBody.prototype.conversation_id = "";
        DeleteConversationRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        DeleteConversationRequestBody.prototype.conversation_type = 0;
        DeleteConversationRequestBody.prototype.last_message_index = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        DeleteConversationRequestBody.create = function create(properties) {
            return new DeleteConversationRequestBody(properties);
        };

        DeleteConversationRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.last_message_index != null && Object.hasOwnProperty.call(m, "last_message_index"))
                w.uint32(32).int64(m.last_message_index);
            return w;
        };

        DeleteConversationRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.DeleteConversationRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    m.last_message_index = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DeleteConversationRequestBody;
    })();

    im_proto.DissolveConversationRequestBody = (function() {

        function DissolveConversationRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        DissolveConversationRequestBody.prototype.conversation_id = "";
        DissolveConversationRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        DissolveConversationRequestBody.prototype.conversation_type = 0;

        DissolveConversationRequestBody.create = function create(properties) {
            return new DissolveConversationRequestBody(properties);
        };

        DissolveConversationRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            return w;
        };

        DissolveConversationRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.DissolveConversationRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DissolveConversationRequestBody;
    })();

    im_proto.DeleteMessageRequestBody = (function() {

        function DeleteMessageRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        DeleteMessageRequestBody.prototype.conversation_id = "";
        DeleteMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        DeleteMessageRequestBody.prototype.conversation_type = 0;
        DeleteMessageRequestBody.prototype.message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        DeleteMessageRequestBody.create = function create(properties) {
            return new DeleteMessageRequestBody(properties);
        };

        DeleteMessageRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.message_id != null && Object.hasOwnProperty.call(m, "message_id"))
                w.uint32(32).int64(m.message_id);
            return w;
        };

        DeleteMessageRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.DeleteMessageRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    m.message_id = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DeleteMessageRequestBody;
    })();

    im_proto.MarkConversationReadRequestBody = (function() {

        function MarkConversationReadRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MarkConversationReadRequestBody.prototype.conversation_id = "";
        MarkConversationReadRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MarkConversationReadRequestBody.prototype.conversation_type = 0;
        MarkConversationReadRequestBody.prototype.read_message_index = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MarkConversationReadRequestBody.prototype.conv_unread_count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MarkConversationReadRequestBody.prototype.total_unread_count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        MarkConversationReadRequestBody.create = function create(properties) {
            return new MarkConversationReadRequestBody(properties);
        };

        MarkConversationReadRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.read_message_index != null && Object.hasOwnProperty.call(m, "read_message_index"))
                w.uint32(32).int64(m.read_message_index);
            if (m.conv_unread_count != null && Object.hasOwnProperty.call(m, "conv_unread_count"))
                w.uint32(40).int64(m.conv_unread_count);
            if (m.total_unread_count != null && Object.hasOwnProperty.call(m, "total_unread_count"))
                w.uint32(48).int64(m.total_unread_count);
            return w;
        };

        MarkConversationReadRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MarkConversationReadRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    m.read_message_index = r.int64();
                    break;
                case 5:
                    m.conv_unread_count = r.int64();
                    break;
                case 6:
                    m.total_unread_count = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MarkConversationReadRequestBody;
    })();

    im_proto.GetConversationParticipantsReadIndexV3RequestBody = (function() {

        function GetConversationParticipantsReadIndexV3RequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetConversationParticipantsReadIndexV3RequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetConversationParticipantsReadIndexV3RequestBody.prototype.conversation_type = 0;
        GetConversationParticipantsReadIndexV3RequestBody.prototype.conversation_id = "";

        GetConversationParticipantsReadIndexV3RequestBody.create = function create(properties) {
            return new GetConversationParticipantsReadIndexV3RequestBody(properties);
        };

        GetConversationParticipantsReadIndexV3RequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(8).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(26).string(m.conversation_id);
            return w;
        };

        GetConversationParticipantsReadIndexV3RequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetConversationParticipantsReadIndexV3RequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_short_id = r.int64();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.conversation_id = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetConversationParticipantsReadIndexV3RequestBody;
    })();

    im_proto.GetConversationParticipantsReadIndexV3ResponseBody = (function() {

        function GetConversationParticipantsReadIndexV3ResponseBody(p) {
            this.indexes = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetConversationParticipantsReadIndexV3ResponseBody.prototype.indexes = $util.emptyArray;

        GetConversationParticipantsReadIndexV3ResponseBody.create = function create(properties) {
            return new GetConversationParticipantsReadIndexV3ResponseBody(properties);
        };

        GetConversationParticipantsReadIndexV3ResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.indexes != null && m.indexes.length) {
                for (var i = 0; i < m.indexes.length; ++i)
                    $root.im_proto.ParticipantReadIndex.encode(m.indexes[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        GetConversationParticipantsReadIndexV3ResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetConversationParticipantsReadIndexV3ResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.indexes && m.indexes.length))
                        m.indexes = [];
                    m.indexes.push($root.im_proto.ParticipantReadIndex.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetConversationParticipantsReadIndexV3ResponseBody;
    })();

    im_proto.ParticipantReadIndex = (function() {

        function ParticipantReadIndex(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ParticipantReadIndex.prototype.user_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ParticipantReadIndex.prototype.sec_uid = "";
        ParticipantReadIndex.prototype.index = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ParticipantReadIndex.prototype.index_v2 = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ParticipantReadIndex.prototype.index_min = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        ParticipantReadIndex.create = function create(properties) {
            return new ParticipantReadIndex(properties);
        };

        ParticipantReadIndex.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.user_id != null && Object.hasOwnProperty.call(m, "user_id"))
                w.uint32(8).int64(m.user_id);
            if (m.sec_uid != null && Object.hasOwnProperty.call(m, "sec_uid"))
                w.uint32(18).string(m.sec_uid);
            if (m.index != null && Object.hasOwnProperty.call(m, "index"))
                w.uint32(24).int64(m.index);
            if (m.index_v2 != null && Object.hasOwnProperty.call(m, "index_v2"))
                w.uint32(32).int64(m.index_v2);
            if (m.index_min != null && Object.hasOwnProperty.call(m, "index_min"))
                w.uint32(40).int64(m.index_min);
            return w;
        };

        ParticipantReadIndex.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ParticipantReadIndex();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.user_id = r.int64();
                    break;
                case 2:
                    m.sec_uid = r.string();
                    break;
                case 3:
                    m.index = r.int64();
                    break;
                case 4:
                    m.index_v2 = r.int64();
                    break;
                case 5:
                    m.index_min = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ParticipantReadIndex;
    })();

    im_proto.BatchGetConversationParticipantsReadIndexRequestBody = (function() {

        function BatchGetConversationParticipantsReadIndexRequestBody(p) {
            this.conversation_id = [];
            this.conversation_short_id = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BatchGetConversationParticipantsReadIndexRequestBody.prototype.conversation_id = $util.emptyArray;
        BatchGetConversationParticipantsReadIndexRequestBody.prototype.conversation_short_id = $util.emptyArray;
        BatchGetConversationParticipantsReadIndexRequestBody.prototype.request_from = "";
        BatchGetConversationParticipantsReadIndexRequestBody.prototype.min_index_required = false;

        BatchGetConversationParticipantsReadIndexRequestBody.create = function create(properties) {
            return new BatchGetConversationParticipantsReadIndexRequestBody(properties);
        };

        BatchGetConversationParticipantsReadIndexRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && m.conversation_id.length) {
                for (var i = 0; i < m.conversation_id.length; ++i)
                    w.uint32(10).string(m.conversation_id[i]);
            }
            if (m.conversation_short_id != null && m.conversation_short_id.length) {
                for (var i = 0; i < m.conversation_short_id.length; ++i)
                    w.uint32(16).int64(m.conversation_short_id[i]);
            }
            if (m.request_from != null && Object.hasOwnProperty.call(m, "request_from"))
                w.uint32(26).string(m.request_from);
            if (m.min_index_required != null && Object.hasOwnProperty.call(m, "min_index_required"))
                w.uint32(32).bool(m.min_index_required);
            return w;
        };

        BatchGetConversationParticipantsReadIndexRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.BatchGetConversationParticipantsReadIndexRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.conversation_id && m.conversation_id.length))
                        m.conversation_id = [];
                    m.conversation_id.push(r.string());
                    break;
                case 2:
                    if (!(m.conversation_short_id && m.conversation_short_id.length))
                        m.conversation_short_id = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.conversation_short_id.push(r.int64());
                    } else
                        m.conversation_short_id.push(r.int64());
                    break;
                case 3:
                    m.request_from = r.string();
                    break;
                case 4:
                    m.min_index_required = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BatchGetConversationParticipantsReadIndexRequestBody;
    })();

    im_proto.BatchGetConversationParticipantsReadIndexResponseBody = (function() {

        function BatchGetConversationParticipantsReadIndexResponseBody(p) {
            this.conversationParticipantsReadIndex = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BatchGetConversationParticipantsReadIndexResponseBody.prototype.conversationParticipantsReadIndex = $util.emptyArray;

        BatchGetConversationParticipantsReadIndexResponseBody.create = function create(properties) {
            return new BatchGetConversationParticipantsReadIndexResponseBody(properties);
        };

        BatchGetConversationParticipantsReadIndexResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversationParticipantsReadIndex != null && m.conversationParticipantsReadIndex.length) {
                for (var i = 0; i < m.conversationParticipantsReadIndex.length; ++i)
                    $root.im_proto.ConversationParticipantReadIndex.encode(m.conversationParticipantsReadIndex[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        BatchGetConversationParticipantsReadIndexResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.BatchGetConversationParticipantsReadIndexResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.conversationParticipantsReadIndex && m.conversationParticipantsReadIndex.length))
                        m.conversationParticipantsReadIndex = [];
                    m.conversationParticipantsReadIndex.push($root.im_proto.ConversationParticipantReadIndex.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BatchGetConversationParticipantsReadIndexResponseBody;
    })();

    im_proto.ConversationParticipantReadIndex = (function() {

        function ConversationParticipantReadIndex(p) {
            this.participantReadIndex = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationParticipantReadIndex.prototype.conversation_id = "";
        ConversationParticipantReadIndex.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationParticipantReadIndex.prototype.participantReadIndex = $util.emptyArray;

        ConversationParticipantReadIndex.create = function create(properties) {
            return new ConversationParticipantReadIndex(properties);
        };

        ConversationParticipantReadIndex.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.participantReadIndex != null && m.participantReadIndex.length) {
                for (var i = 0; i < m.participantReadIndex.length; ++i)
                    $root.im_proto.ParticipantReadIndex.encode(m.participantReadIndex[i], w.uint32(26).fork()).ldelim();
            }
            return w;
        };

        ConversationParticipantReadIndex.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationParticipantReadIndex();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    if (!(m.participantReadIndex && m.participantReadIndex.length))
                        m.participantReadIndex = [];
                    m.participantReadIndex.push($root.im_proto.ParticipantReadIndex.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ConversationParticipantReadIndex;
    })();

    im_proto.GetConversationParticipantsMinIndexV3RequestBody = (function() {

        function GetConversationParticipantsMinIndexV3RequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetConversationParticipantsMinIndexV3RequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetConversationParticipantsMinIndexV3RequestBody.prototype.conversation_type = 0;
        GetConversationParticipantsMinIndexV3RequestBody.prototype.conversation_id = "";

        GetConversationParticipantsMinIndexV3RequestBody.create = function create(properties) {
            return new GetConversationParticipantsMinIndexV3RequestBody(properties);
        };

        GetConversationParticipantsMinIndexV3RequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(8).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(26).string(m.conversation_id);
            return w;
        };

        GetConversationParticipantsMinIndexV3RequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetConversationParticipantsMinIndexV3RequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_short_id = r.int64();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.conversation_id = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetConversationParticipantsMinIndexV3RequestBody;
    })();

    im_proto.GetConversationParticipantsMinIndexV3ResponseBody = (function() {

        function GetConversationParticipantsMinIndexV3ResponseBody(p) {
            this.indexes = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetConversationParticipantsMinIndexV3ResponseBody.prototype.indexes = $util.emptyArray;

        GetConversationParticipantsMinIndexV3ResponseBody.create = function create(properties) {
            return new GetConversationParticipantsMinIndexV3ResponseBody(properties);
        };

        GetConversationParticipantsMinIndexV3ResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.indexes != null && m.indexes.length) {
                for (var i = 0; i < m.indexes.length; ++i)
                    $root.im_proto.ParticipantMinIndex.encode(m.indexes[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        GetConversationParticipantsMinIndexV3ResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetConversationParticipantsMinIndexV3ResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.indexes && m.indexes.length))
                        m.indexes = [];
                    m.indexes.push($root.im_proto.ParticipantMinIndex.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetConversationParticipantsMinIndexV3ResponseBody;
    })();

    im_proto.ParticipantMinIndex = (function() {

        function ParticipantMinIndex(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ParticipantMinIndex.prototype.user_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ParticipantMinIndex.prototype.sec_uid = "";
        ParticipantMinIndex.prototype.index = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        ParticipantMinIndex.create = function create(properties) {
            return new ParticipantMinIndex(properties);
        };

        ParticipantMinIndex.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.user_id != null && Object.hasOwnProperty.call(m, "user_id"))
                w.uint32(8).int64(m.user_id);
            if (m.sec_uid != null && Object.hasOwnProperty.call(m, "sec_uid"))
                w.uint32(18).string(m.sec_uid);
            if (m.index != null && Object.hasOwnProperty.call(m, "index"))
                w.uint32(24).int64(m.index);
            return w;
        };

        ParticipantMinIndex.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ParticipantMinIndex();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.user_id = r.int64();
                    break;
                case 2:
                    m.sec_uid = r.string();
                    break;
                case 3:
                    m.index = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ParticipantMinIndex;
    })();

    im_proto.SendMessageRequestBody = (function() {

        function SendMessageRequestBody(p) {
            this.ext = {};
            this.mentioned_users = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SendMessageRequestBody.prototype.conversation_id = "";
        SendMessageRequestBody.prototype.conversation_type = 0;
        SendMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        SendMessageRequestBody.prototype.content = "";
        SendMessageRequestBody.prototype.ext = $util.emptyObject;
        SendMessageRequestBody.prototype.message_type = 0;
        SendMessageRequestBody.prototype.ticket = "";
        SendMessageRequestBody.prototype.client_message_id = "";
        SendMessageRequestBody.prototype.mentioned_users = $util.emptyArray;
        SendMessageRequestBody.prototype.ref_msg_info = null;

        SendMessageRequestBody.create = function create(properties) {
            return new SendMessageRequestBody(properties);
        };

        SendMessageRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(24).int64(m.conversation_short_id);
            if (m.content != null && Object.hasOwnProperty.call(m, "content"))
                w.uint32(34).string(m.content);
            if (m.ext != null && Object.hasOwnProperty.call(m, "ext")) {
                for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
                    w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
                }
            }
            if (m.message_type != null && Object.hasOwnProperty.call(m, "message_type"))
                w.uint32(48).int32(m.message_type);
            if (m.ticket != null && Object.hasOwnProperty.call(m, "ticket"))
                w.uint32(58).string(m.ticket);
            if (m.client_message_id != null && Object.hasOwnProperty.call(m, "client_message_id"))
                w.uint32(66).string(m.client_message_id);
            if (m.mentioned_users != null && m.mentioned_users.length) {
                for (var i = 0; i < m.mentioned_users.length; ++i)
                    w.uint32(72).int64(m.mentioned_users[i]);
            }
            if (m.ref_msg_info != null && Object.hasOwnProperty.call(m, "ref_msg_info"))
                $root.im_proto.ReferencedMessageInfo.encode(m.ref_msg_info, w.uint32(90).fork()).ldelim();
            return w;
        };

        SendMessageRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.SendMessageRequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.conversation_short_id = r.int64();
                    break;
                case 4:
                    m.content = r.string();
                    break;
                case 5:
                    if (m.ext === $util.emptyObject)
                        m.ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.ext[k] = value;
                    break;
                case 6:
                    m.message_type = r.int32();
                    break;
                case 7:
                    m.ticket = r.string();
                    break;
                case 8:
                    m.client_message_id = r.string();
                    break;
                case 9:
                    if (!(m.mentioned_users && m.mentioned_users.length))
                        m.mentioned_users = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.mentioned_users.push(r.int64());
                    } else
                        m.mentioned_users.push(r.int64());
                    break;
                case 11:
                    m.ref_msg_info = $root.im_proto.ReferencedMessageInfo.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SendMessageRequestBody;
    })();

    im_proto.ReferencedMessageInfo = (function() {

        function ReferencedMessageInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ReferencedMessageInfo.prototype.referenced_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ReferencedMessageInfo.prototype.hint = "";
        ReferencedMessageInfo.prototype.root_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ReferencedMessageInfo.prototype.root_message_conv_index = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        ReferencedMessageInfo.create = function create(properties) {
            return new ReferencedMessageInfo(properties);
        };

        ReferencedMessageInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            w.uint32(8).int64(m.referenced_message_id);
            w.uint32(18).string(m.hint);
            if (m.root_message_id != null && Object.hasOwnProperty.call(m, "root_message_id"))
                w.uint32(24).int64(m.root_message_id);
            if (m.root_message_conv_index != null && Object.hasOwnProperty.call(m, "root_message_conv_index"))
                w.uint32(32).int64(m.root_message_conv_index);
            return w;
        };

        ReferencedMessageInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ReferencedMessageInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.referenced_message_id = r.int64();
                    break;
                case 2:
                    m.hint = r.string();
                    break;
                case 3:
                    m.root_message_id = r.int64();
                    break;
                case 4:
                    m.root_message_conv_index = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            if (!m.hasOwnProperty("referenced_message_id"))
                throw $util.ProtocolError("missing required 'referenced_message_id'", { instance: m });
            if (!m.hasOwnProperty("hint"))
                throw $util.ProtocolError("missing required 'hint'", { instance: m });
            return m;
        };

        return ReferencedMessageInfo;
    })();

    im_proto.SendMessageResponseBody = (function() {

        function SendMessageResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SendMessageResponseBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        SendMessageResponseBody.prototype.extra_info = "";
        SendMessageResponseBody.prototype.status = 0;
        SendMessageResponseBody.prototype.client_message_id = "";
        SendMessageResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        SendMessageResponseBody.prototype.check_message = "";

        SendMessageResponseBody.create = function create(properties) {
            return new SendMessageResponseBody(properties);
        };

        SendMessageResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.server_message_id != null && Object.hasOwnProperty.call(m, "server_message_id"))
                w.uint32(8).int64(m.server_message_id);
            if (m.extra_info != null && Object.hasOwnProperty.call(m, "extra_info"))
                w.uint32(18).string(m.extra_info);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            if (m.client_message_id != null && Object.hasOwnProperty.call(m, "client_message_id"))
                w.uint32(34).string(m.client_message_id);
            if (m.check_code != null && Object.hasOwnProperty.call(m, "check_code"))
                w.uint32(40).int64(m.check_code);
            if (m.check_message != null && Object.hasOwnProperty.call(m, "check_message"))
                w.uint32(50).string(m.check_message);
            return w;
        };

        SendMessageResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.SendMessageResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.server_message_id = r.int64();
                    break;
                case 2:
                    m.extra_info = r.string();
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                case 4:
                    m.client_message_id = r.string();
                    break;
                case 5:
                    m.check_code = r.int64();
                    break;
                case 6:
                    m.check_message = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SendMessageResponseBody;
    })();

    im_proto.NewMessageNotifyType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "PER_USER"] = 1;
        values[valuesById[2] = "PER_CONVERSATION"] = 2;
        return values;
    })();

    im_proto.NewMessageNotify = (function() {

        function NewMessageNotify(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        NewMessageNotify.prototype.conversation_id = "";
        NewMessageNotify.prototype.conversation_type = 0;
        NewMessageNotify.prototype.notify_type = 1;
        NewMessageNotify.prototype.message = null;
        NewMessageNotify.prototype.previous_cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        NewMessageNotify.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        NewMessageNotify.prototype.index_in_conversation = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        NewMessageNotify.prototype.ref_msg_info = null;

        NewMessageNotify.create = function create(properties) {
            return new NewMessageNotify(properties);
        };

        NewMessageNotify.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(18).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.notify_type != null && Object.hasOwnProperty.call(m, "notify_type"))
                w.uint32(32).int32(m.notify_type);
            if (m.message != null && Object.hasOwnProperty.call(m, "message"))
                $root.im_proto.MessageBody.encode(m.message, w.uint32(42).fork()).ldelim();
            if (m.previous_cursor != null && Object.hasOwnProperty.call(m, "previous_cursor"))
                w.uint32(48).int64(m.previous_cursor);
            if (m.next_cursor != null && Object.hasOwnProperty.call(m, "next_cursor"))
                w.uint32(56).int64(m.next_cursor);
            if (m.index_in_conversation != null && Object.hasOwnProperty.call(m, "index_in_conversation"))
                w.uint32(64).int64(m.index_in_conversation);
            if (m.ref_msg_info != null && Object.hasOwnProperty.call(m, "ref_msg_info"))
                $root.im_proto.ReferenceInfo.encode(m.ref_msg_info, w.uint32(122).fork()).ldelim();
            return w;
        };

        NewMessageNotify.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.NewMessageNotify();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 2:
                    m.conversation_id = r.string();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    m.notify_type = r.int32();
                    break;
                case 5:
                    m.message = $root.im_proto.MessageBody.decode(r, r.uint32());
                    break;
                case 6:
                    m.previous_cursor = r.int64();
                    break;
                case 7:
                    m.next_cursor = r.int64();
                    break;
                case 8:
                    m.index_in_conversation = r.int64();
                    break;
                case 15:
                    m.ref_msg_info = $root.im_proto.ReferenceInfo.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return NewMessageNotify;
    })();

    im_proto.ConversationsPerUserByFavoriteV2RequestBody = (function() {

        function ConversationsPerUserByFavoriteV2RequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationsPerUserByFavoriteV2RequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationsPerUserByFavoriteV2RequestBody.prototype.limit = 500;

        ConversationsPerUserByFavoriteV2RequestBody.create = function create(properties) {
            return new ConversationsPerUserByFavoriteV2RequestBody(properties);
        };

        ConversationsPerUserByFavoriteV2RequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.cursor != null && Object.hasOwnProperty.call(m, "cursor"))
                w.uint32(8).int64(m.cursor);
            if (m.limit != null && Object.hasOwnProperty.call(m, "limit"))
                w.uint32(16).int32(m.limit);
            return w;
        };

        ConversationsPerUserByFavoriteV2RequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationsPerUserByFavoriteV2RequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.cursor = r.int64();
                    break;
                case 2:
                    m.limit = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ConversationsPerUserByFavoriteV2RequestBody;
    })();

    im_proto.ConversationsPerUserByTopV2RequestBody = (function() {

        function ConversationsPerUserByTopV2RequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationsPerUserByTopV2RequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationsPerUserByTopV2RequestBody.prototype.limit = 500;

        ConversationsPerUserByTopV2RequestBody.create = function create(properties) {
            return new ConversationsPerUserByTopV2RequestBody(properties);
        };

        ConversationsPerUserByTopV2RequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.cursor != null && Object.hasOwnProperty.call(m, "cursor"))
                w.uint32(8).int64(m.cursor);
            if (m.limit != null && Object.hasOwnProperty.call(m, "limit"))
                w.uint32(16).int32(m.limit);
            return w;
        };

        ConversationsPerUserByTopV2RequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationsPerUserByTopV2RequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.cursor = r.int64();
                    break;
                case 2:
                    m.limit = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ConversationsPerUserByTopV2RequestBody;
    })();

    im_proto.GetConversationInfoV2RequestBody = (function() {

        function GetConversationInfoV2RequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetConversationInfoV2RequestBody.prototype.conversation_id = "";
        GetConversationInfoV2RequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetConversationInfoV2RequestBody.prototype.conversation_type = 0;

        GetConversationInfoV2RequestBody.create = function create(properties) {
            return new GetConversationInfoV2RequestBody(properties);
        };

        GetConversationInfoV2RequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            return w;
        };

        GetConversationInfoV2RequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetConversationInfoV2RequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetConversationInfoV2RequestBody;
    })();

    im_proto.GetConversationInfoListV2RequestBody = (function() {

        function GetConversationInfoListV2RequestBody(p) {
            this.conversation_info_list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetConversationInfoListV2RequestBody.prototype.conversation_info_list = $util.emptyArray;

        GetConversationInfoListV2RequestBody.create = function create(properties) {
            return new GetConversationInfoListV2RequestBody(properties);
        };

        GetConversationInfoListV2RequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_info_list != null && m.conversation_info_list.length) {
                for (var i = 0; i < m.conversation_info_list.length; ++i)
                    $root.im_proto.GetConversationInfoV2RequestBody.encode(m.conversation_info_list[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        GetConversationInfoListV2RequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetConversationInfoListV2RequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.conversation_info_list && m.conversation_info_list.length))
                        m.conversation_info_list = [];
                    m.conversation_info_list.push($root.im_proto.GetConversationInfoV2RequestBody.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetConversationInfoListV2RequestBody;
    })();

    im_proto.GetConversationInfoListV2ResponseBody = (function() {

        function GetConversationInfoListV2ResponseBody(p) {
            this.conversation_info_list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetConversationInfoListV2ResponseBody.prototype.conversation_info_list = $util.emptyArray;

        GetConversationInfoListV2ResponseBody.create = function create(properties) {
            return new GetConversationInfoListV2ResponseBody(properties);
        };

        GetConversationInfoListV2ResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_info_list != null && m.conversation_info_list.length) {
                for (var i = 0; i < m.conversation_info_list.length; ++i)
                    $root.im_proto.ConversationInfoV2.encode(m.conversation_info_list[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        GetConversationInfoListV2ResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetConversationInfoListV2ResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.conversation_info_list && m.conversation_info_list.length))
                        m.conversation_info_list = [];
                    m.conversation_info_list.push($root.im_proto.ConversationInfoV2.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetConversationInfoListV2ResponseBody;
    })();

    im_proto.GetConversationInfoListByFavoriteV2ResponseBody = (function() {

        function GetConversationInfoListByFavoriteV2ResponseBody(p) {
            this.conversation_info_list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetConversationInfoListByFavoriteV2ResponseBody.prototype.conversation_info_list = $util.emptyArray;
        GetConversationInfoListByFavoriteV2ResponseBody.prototype.has_more = false;
        GetConversationInfoListByFavoriteV2ResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        GetConversationInfoListByFavoriteV2ResponseBody.create = function create(properties) {
            return new GetConversationInfoListByFavoriteV2ResponseBody(properties);
        };

        GetConversationInfoListByFavoriteV2ResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_info_list != null && m.conversation_info_list.length) {
                for (var i = 0; i < m.conversation_info_list.length; ++i)
                    $root.im_proto.ConversationInfoV2.encode(m.conversation_info_list[i], w.uint32(10).fork()).ldelim();
            }
            if (m.has_more != null && Object.hasOwnProperty.call(m, "has_more"))
                w.uint32(16).bool(m.has_more);
            if (m.next_cursor != null && Object.hasOwnProperty.call(m, "next_cursor"))
                w.uint32(24).int64(m.next_cursor);
            return w;
        };

        GetConversationInfoListByFavoriteV2ResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetConversationInfoListByFavoriteV2ResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.conversation_info_list && m.conversation_info_list.length))
                        m.conversation_info_list = [];
                    m.conversation_info_list.push($root.im_proto.ConversationInfoV2.decode(r, r.uint32()));
                    break;
                case 2:
                    m.has_more = r.bool();
                    break;
                case 3:
                    m.next_cursor = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetConversationInfoListByFavoriteV2ResponseBody;
    })();

    im_proto.GetConversationInfoListByTopV2ResponseBody = (function() {

        function GetConversationInfoListByTopV2ResponseBody(p) {
            this.conversation_info_list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetConversationInfoListByTopV2ResponseBody.prototype.conversation_info_list = $util.emptyArray;
        GetConversationInfoListByTopV2ResponseBody.prototype.has_more = false;
        GetConversationInfoListByTopV2ResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        GetConversationInfoListByTopV2ResponseBody.create = function create(properties) {
            return new GetConversationInfoListByTopV2ResponseBody(properties);
        };

        GetConversationInfoListByTopV2ResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_info_list != null && m.conversation_info_list.length) {
                for (var i = 0; i < m.conversation_info_list.length; ++i)
                    $root.im_proto.ConversationInfoV2.encode(m.conversation_info_list[i], w.uint32(10).fork()).ldelim();
            }
            if (m.has_more != null && Object.hasOwnProperty.call(m, "has_more"))
                w.uint32(16).bool(m.has_more);
            if (m.next_cursor != null && Object.hasOwnProperty.call(m, "next_cursor"))
                w.uint32(24).int64(m.next_cursor);
            return w;
        };

        GetConversationInfoListByTopV2ResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetConversationInfoListByTopV2ResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.conversation_info_list && m.conversation_info_list.length))
                        m.conversation_info_list = [];
                    m.conversation_info_list.push($root.im_proto.ConversationInfoV2.decode(r, r.uint32()));
                    break;
                case 2:
                    m.has_more = r.bool();
                    break;
                case 3:
                    m.next_cursor = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetConversationInfoListByTopV2ResponseBody;
    })();

    im_proto.RecallMessageRequestBody = (function() {

        function RecallMessageRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        RecallMessageRequestBody.prototype.conversation_id = "";
        RecallMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        RecallMessageRequestBody.prototype.conversation_type = 0;
        RecallMessageRequestBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        RecallMessageRequestBody.create = function create(properties) {
            return new RecallMessageRequestBody(properties);
        };

        RecallMessageRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.server_message_id != null && Object.hasOwnProperty.call(m, "server_message_id"))
                w.uint32(32).int64(m.server_message_id);
            return w;
        };

        RecallMessageRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.RecallMessageRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    m.server_message_id = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return RecallMessageRequestBody;
    })();

    im_proto.ConversationAddParticipantsRequestBody = (function() {

        function ConversationAddParticipantsRequestBody(p) {
            this.participants = [];
            this.biz_ext = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationAddParticipantsRequestBody.prototype.conversation_id = "";
        ConversationAddParticipantsRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationAddParticipantsRequestBody.prototype.conversation_type = 0;
        ConversationAddParticipantsRequestBody.prototype.participants = $util.emptyArray;
        ConversationAddParticipantsRequestBody.prototype.biz_ext = $util.emptyObject;

        ConversationAddParticipantsRequestBody.create = function create(properties) {
            return new ConversationAddParticipantsRequestBody(properties);
        };

        ConversationAddParticipantsRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.participants != null && m.participants.length) {
                for (var i = 0; i < m.participants.length; ++i)
                    w.uint32(32).int64(m.participants[i]);
            }
            if (m.biz_ext != null && Object.hasOwnProperty.call(m, "biz_ext")) {
                for (var ks = Object.keys(m.biz_ext), i = 0; i < ks.length; ++i) {
                    w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.biz_ext[ks[i]]).ldelim();
                }
            }
            return w;
        };

        ConversationAddParticipantsRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationAddParticipantsRequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    if (!(m.participants && m.participants.length))
                        m.participants = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.participants.push(r.int64());
                    } else
                        m.participants.push(r.int64());
                    break;
                case 5:
                    if (m.biz_ext === $util.emptyObject)
                        m.biz_ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.biz_ext[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ConversationAddParticipantsRequestBody;
    })();

    im_proto.SecUidPair = (function() {

        function SecUidPair(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SecUidPair.prototype.uid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        SecUidPair.prototype.sec_uid = "";

        SecUidPair.create = function create(properties) {
            return new SecUidPair(properties);
        };

        SecUidPair.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.uid != null && Object.hasOwnProperty.call(m, "uid"))
                w.uint32(8).int64(m.uid);
            if (m.sec_uid != null && Object.hasOwnProperty.call(m, "sec_uid"))
                w.uint32(18).string(m.sec_uid);
            return w;
        };

        SecUidPair.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.SecUidPair();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.uid = r.int64();
                    break;
                case 2:
                    m.sec_uid = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SecUidPair;
    })();

    im_proto.ConversationAddParticipantsResponseBody = (function() {

        function ConversationAddParticipantsResponseBody(p) {
            this.success_participants = [];
            this.failed_participants = [];
            this.sec_success_participants = [];
            this.sec_failed_participants = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationAddParticipantsResponseBody.prototype.success_participants = $util.emptyArray;
        ConversationAddParticipantsResponseBody.prototype.failed_participants = $util.emptyArray;
        ConversationAddParticipantsResponseBody.prototype.status = 0;
        ConversationAddParticipantsResponseBody.prototype.extra_info = "";
        ConversationAddParticipantsResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationAddParticipantsResponseBody.prototype.check_message = "";
        ConversationAddParticipantsResponseBody.prototype.sec_success_participants = $util.emptyArray;
        ConversationAddParticipantsResponseBody.prototype.sec_failed_participants = $util.emptyArray;

        ConversationAddParticipantsResponseBody.create = function create(properties) {
            return new ConversationAddParticipantsResponseBody(properties);
        };

        ConversationAddParticipantsResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.success_participants != null && m.success_participants.length) {
                for (var i = 0; i < m.success_participants.length; ++i)
                    w.uint32(8).int64(m.success_participants[i]);
            }
            if (m.failed_participants != null && m.failed_participants.length) {
                for (var i = 0; i < m.failed_participants.length; ++i)
                    w.uint32(16).int64(m.failed_participants[i]);
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            if (m.extra_info != null && Object.hasOwnProperty.call(m, "extra_info"))
                w.uint32(34).string(m.extra_info);
            if (m.check_code != null && Object.hasOwnProperty.call(m, "check_code"))
                w.uint32(40).int64(m.check_code);
            if (m.check_message != null && Object.hasOwnProperty.call(m, "check_message"))
                w.uint32(50).string(m.check_message);
            if (m.sec_success_participants != null && m.sec_success_participants.length) {
                for (var i = 0; i < m.sec_success_participants.length; ++i)
                    $root.im_proto.SecUidPair.encode(m.sec_success_participants[i], w.uint32(58).fork()).ldelim();
            }
            if (m.sec_failed_participants != null && m.sec_failed_participants.length) {
                for (var i = 0; i < m.sec_failed_participants.length; ++i)
                    $root.im_proto.SecUidPair.encode(m.sec_failed_participants[i], w.uint32(66).fork()).ldelim();
            }
            return w;
        };

        ConversationAddParticipantsResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationAddParticipantsResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.success_participants && m.success_participants.length))
                        m.success_participants = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.success_participants.push(r.int64());
                    } else
                        m.success_participants.push(r.int64());
                    break;
                case 2:
                    if (!(m.failed_participants && m.failed_participants.length))
                        m.failed_participants = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.failed_participants.push(r.int64());
                    } else
                        m.failed_participants.push(r.int64());
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                case 4:
                    m.extra_info = r.string();
                    break;
                case 5:
                    m.check_code = r.int64();
                    break;
                case 6:
                    m.check_message = r.string();
                    break;
                case 7:
                    if (!(m.sec_success_participants && m.sec_success_participants.length))
                        m.sec_success_participants = [];
                    m.sec_success_participants.push($root.im_proto.SecUidPair.decode(r, r.uint32()));
                    break;
                case 8:
                    if (!(m.sec_failed_participants && m.sec_failed_participants.length))
                        m.sec_failed_participants = [];
                    m.sec_failed_participants.push($root.im_proto.SecUidPair.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ConversationAddParticipantsResponseBody;
    })();

    im_proto.ConversationRemoveParticipantsRequestBody = (function() {

        function ConversationRemoveParticipantsRequestBody(p) {
            this.participants = [];
            this.biz_ext = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationRemoveParticipantsRequestBody.prototype.conversation_id = "";
        ConversationRemoveParticipantsRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationRemoveParticipantsRequestBody.prototype.conversation_type = 0;
        ConversationRemoveParticipantsRequestBody.prototype.participants = $util.emptyArray;
        ConversationRemoveParticipantsRequestBody.prototype.biz_ext = $util.emptyObject;

        ConversationRemoveParticipantsRequestBody.create = function create(properties) {
            return new ConversationRemoveParticipantsRequestBody(properties);
        };

        ConversationRemoveParticipantsRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.participants != null && m.participants.length) {
                for (var i = 0; i < m.participants.length; ++i)
                    w.uint32(32).int64(m.participants[i]);
            }
            if (m.biz_ext != null && Object.hasOwnProperty.call(m, "biz_ext")) {
                for (var ks = Object.keys(m.biz_ext), i = 0; i < ks.length; ++i) {
                    w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.biz_ext[ks[i]]).ldelim();
                }
            }
            return w;
        };

        ConversationRemoveParticipantsRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationRemoveParticipantsRequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    if (!(m.participants && m.participants.length))
                        m.participants = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.participants.push(r.int64());
                    } else
                        m.participants.push(r.int64());
                    break;
                case 5:
                    if (m.biz_ext === $util.emptyObject)
                        m.biz_ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.biz_ext[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ConversationRemoveParticipantsRequestBody;
    })();

    im_proto.ConversationRemoveParticipantsResponseBody = (function() {

        function ConversationRemoveParticipantsResponseBody(p) {
            this.failed_participants = [];
            this.failed_sec_participants = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationRemoveParticipantsResponseBody.prototype.failed_participants = $util.emptyArray;
        ConversationRemoveParticipantsResponseBody.prototype.status = 0;
        ConversationRemoveParticipantsResponseBody.prototype.extra_info = "";
        ConversationRemoveParticipantsResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationRemoveParticipantsResponseBody.prototype.check_message = "";
        ConversationRemoveParticipantsResponseBody.prototype.failed_sec_participants = $util.emptyArray;

        ConversationRemoveParticipantsResponseBody.create = function create(properties) {
            return new ConversationRemoveParticipantsResponseBody(properties);
        };

        ConversationRemoveParticipantsResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.failed_participants != null && m.failed_participants.length) {
                for (var i = 0; i < m.failed_participants.length; ++i)
                    w.uint32(8).int64(m.failed_participants[i]);
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(16).int32(m.status);
            if (m.extra_info != null && Object.hasOwnProperty.call(m, "extra_info"))
                w.uint32(26).string(m.extra_info);
            if (m.check_code != null && Object.hasOwnProperty.call(m, "check_code"))
                w.uint32(32).int64(m.check_code);
            if (m.check_message != null && Object.hasOwnProperty.call(m, "check_message"))
                w.uint32(42).string(m.check_message);
            if (m.failed_sec_participants != null && m.failed_sec_participants.length) {
                for (var i = 0; i < m.failed_sec_participants.length; ++i)
                    $root.im_proto.SecUidPair.encode(m.failed_sec_participants[i], w.uint32(50).fork()).ldelim();
            }
            return w;
        };

        ConversationRemoveParticipantsResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationRemoveParticipantsResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.failed_participants && m.failed_participants.length))
                        m.failed_participants = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.failed_participants.push(r.int64());
                    } else
                        m.failed_participants.push(r.int64());
                    break;
                case 2:
                    m.status = r.int32();
                    break;
                case 3:
                    m.extra_info = r.string();
                    break;
                case 4:
                    m.check_code = r.int64();
                    break;
                case 5:
                    m.check_message = r.string();
                    break;
                case 6:
                    if (!(m.failed_sec_participants && m.failed_sec_participants.length))
                        m.failed_sec_participants = [];
                    m.failed_sec_participants.push($root.im_proto.SecUidPair.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ConversationRemoveParticipantsResponseBody;
    })();

    im_proto.ConversationLeaveRequestBody = (function() {

        function ConversationLeaveRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationLeaveRequestBody.prototype.conversation_id = "";
        ConversationLeaveRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationLeaveRequestBody.prototype.conversation_type = 0;

        ConversationLeaveRequestBody.create = function create(properties) {
            return new ConversationLeaveRequestBody(properties);
        };

        ConversationLeaveRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            return w;
        };

        ConversationLeaveRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationLeaveRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ConversationLeaveRequestBody;
    })();

    im_proto.ConversationParticipantsListRequestBody = (function() {

        function ConversationParticipantsListRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationParticipantsListRequestBody.prototype.conversation_id = "";
        ConversationParticipantsListRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationParticipantsListRequestBody.prototype.conversation_type = 0;
        ConversationParticipantsListRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationParticipantsListRequestBody.prototype.limit = 100;

        ConversationParticipantsListRequestBody.create = function create(properties) {
            return new ConversationParticipantsListRequestBody(properties);
        };

        ConversationParticipantsListRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.cursor != null && Object.hasOwnProperty.call(m, "cursor"))
                w.uint32(32).int64(m.cursor);
            if (m.limit != null && Object.hasOwnProperty.call(m, "limit"))
                w.uint32(40).int32(m.limit);
            return w;
        };

        ConversationParticipantsListRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationParticipantsListRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    m.cursor = r.int64();
                    break;
                case 5:
                    m.limit = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ConversationParticipantsListRequestBody;
    })();

    im_proto.ConversationParticipantsListResponseBody = (function() {

        function ConversationParticipantsListResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationParticipantsListResponseBody.prototype.participants_page = null;

        ConversationParticipantsListResponseBody.create = function create(properties) {
            return new ConversationParticipantsListResponseBody(properties);
        };

        ConversationParticipantsListResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.participants_page != null && Object.hasOwnProperty.call(m, "participants_page"))
                $root.im_proto.ParticipantsPage.encode(m.participants_page, w.uint32(10).fork()).ldelim();
            return w;
        };

        ConversationParticipantsListResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationParticipantsListResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.participants_page = $root.im_proto.ParticipantsPage.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ConversationParticipantsListResponseBody;
    })();

    im_proto.MgetConversationParticipantsRequestBody = (function() {

        function MgetConversationParticipantsRequestBody(p) {
            this.participants = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MgetConversationParticipantsRequestBody.prototype.conversation_id = "";
        MgetConversationParticipantsRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MgetConversationParticipantsRequestBody.prototype.conversation_type = 0;
        MgetConversationParticipantsRequestBody.prototype.participants = $util.emptyArray;

        MgetConversationParticipantsRequestBody.create = function create(properties) {
            return new MgetConversationParticipantsRequestBody(properties);
        };

        MgetConversationParticipantsRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.participants != null && m.participants.length) {
                for (var i = 0; i < m.participants.length; ++i)
                    w.uint32(32).int64(m.participants[i]);
            }
            return w;
        };

        MgetConversationParticipantsRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MgetConversationParticipantsRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    if (!(m.participants && m.participants.length))
                        m.participants = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.participants.push(r.int64());
                    } else
                        m.participants.push(r.int64());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MgetConversationParticipantsRequestBody;
    })();

    im_proto.MgetConversationParticipantsResponseBody = (function() {

        function MgetConversationParticipantsResponseBody(p) {
            this.participants = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MgetConversationParticipantsResponseBody.prototype.participants = $util.emptyArray;

        MgetConversationParticipantsResponseBody.create = function create(properties) {
            return new MgetConversationParticipantsResponseBody(properties);
        };

        MgetConversationParticipantsResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.participants != null && m.participants.length) {
                for (var i = 0; i < m.participants.length; ++i)
                    $root.im_proto.Participant.encode(m.participants[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        MgetConversationParticipantsResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MgetConversationParticipantsResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.participants && m.participants.length))
                        m.participants = [];
                    m.participants.push($root.im_proto.Participant.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MgetConversationParticipantsResponseBody;
    })();

    im_proto.UpdateConversationParticipantRequestBody = (function() {

        function UpdateConversationParticipantRequestBody(p) {
            this.biz_ext = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UpdateConversationParticipantRequestBody.prototype.conversation_id = "";
        UpdateConversationParticipantRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        UpdateConversationParticipantRequestBody.prototype.conversation_type = 0;
        UpdateConversationParticipantRequestBody.prototype.user_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        UpdateConversationParticipantRequestBody.prototype.role = 0;
        UpdateConversationParticipantRequestBody.prototype.alias = "";
        UpdateConversationParticipantRequestBody.prototype.is_alias_set = false;
        UpdateConversationParticipantRequestBody.prototype.biz_ext = $util.emptyObject;

        UpdateConversationParticipantRequestBody.create = function create(properties) {
            return new UpdateConversationParticipantRequestBody(properties);
        };

        UpdateConversationParticipantRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.user_id != null && Object.hasOwnProperty.call(m, "user_id"))
                w.uint32(32).int64(m.user_id);
            if (m.role != null && Object.hasOwnProperty.call(m, "role"))
                w.uint32(40).int32(m.role);
            if (m.alias != null && Object.hasOwnProperty.call(m, "alias"))
                w.uint32(50).string(m.alias);
            if (m.is_alias_set != null && Object.hasOwnProperty.call(m, "is_alias_set"))
                w.uint32(56).bool(m.is_alias_set);
            if (m.biz_ext != null && Object.hasOwnProperty.call(m, "biz_ext")) {
                for (var ks = Object.keys(m.biz_ext), i = 0; i < ks.length; ++i) {
                    w.uint32(90).fork().uint32(10).string(ks[i]).uint32(18).string(m.biz_ext[ks[i]]).ldelim();
                }
            }
            return w;
        };

        UpdateConversationParticipantRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.UpdateConversationParticipantRequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    m.user_id = r.int64();
                    break;
                case 5:
                    m.role = r.int32();
                    break;
                case 6:
                    m.alias = r.string();
                    break;
                case 7:
                    m.is_alias_set = r.bool();
                    break;
                case 11:
                    if (m.biz_ext === $util.emptyObject)
                        m.biz_ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.biz_ext[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateConversationParticipantRequestBody;
    })();

    im_proto.UpdateConversationParticipantResponseBody = (function() {

        function UpdateConversationParticipantResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UpdateConversationParticipantResponseBody.prototype.participant = null;
        UpdateConversationParticipantResponseBody.prototype.status = 0;
        UpdateConversationParticipantResponseBody.prototype.extra_info = "";
        UpdateConversationParticipantResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        UpdateConversationParticipantResponseBody.prototype.check_message = "";

        UpdateConversationParticipantResponseBody.create = function create(properties) {
            return new UpdateConversationParticipantResponseBody(properties);
        };

        UpdateConversationParticipantResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.participant != null && Object.hasOwnProperty.call(m, "participant"))
                $root.im_proto.Participant.encode(m.participant, w.uint32(10).fork()).ldelim();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(16).int32(m.status);
            if (m.extra_info != null && Object.hasOwnProperty.call(m, "extra_info"))
                w.uint32(26).string(m.extra_info);
            if (m.check_code != null && Object.hasOwnProperty.call(m, "check_code"))
                w.uint32(32).int64(m.check_code);
            if (m.check_message != null && Object.hasOwnProperty.call(m, "check_message"))
                w.uint32(42).string(m.check_message);
            return w;
        };

        UpdateConversationParticipantResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.UpdateConversationParticipantResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.participant = $root.im_proto.Participant.decode(r, r.uint32());
                    break;
                case 2:
                    m.status = r.int32();
                    break;
                case 3:
                    m.extra_info = r.string();
                    break;
                case 4:
                    m.check_code = r.int64();
                    break;
                case 5:
                    m.check_message = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateConversationParticipantResponseBody;
    })();

    im_proto.GetConversationCoreInfoRequestBody = (function() {

        function GetConversationCoreInfoRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetConversationCoreInfoRequestBody.prototype.conversation_id = "";
        GetConversationCoreInfoRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetConversationCoreInfoRequestBody.prototype.conversation_type = 0;

        GetConversationCoreInfoRequestBody.create = function create(properties) {
            return new GetConversationCoreInfoRequestBody(properties);
        };

        GetConversationCoreInfoRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            return w;
        };

        GetConversationCoreInfoRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetConversationCoreInfoRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetConversationCoreInfoRequestBody;
    })();

    im_proto.GetConversationCoreInfoResponseBody = (function() {

        function GetConversationCoreInfoResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetConversationCoreInfoResponseBody.prototype.conversation_core_info = null;

        GetConversationCoreInfoResponseBody.create = function create(properties) {
            return new GetConversationCoreInfoResponseBody(properties);
        };

        GetConversationCoreInfoResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_core_info != null && Object.hasOwnProperty.call(m, "conversation_core_info"))
                $root.im_proto.ConversationCoreInfo.encode(m.conversation_core_info, w.uint32(10).fork()).ldelim();
            return w;
        };

        GetConversationCoreInfoResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetConversationCoreInfoResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_core_info = $root.im_proto.ConversationCoreInfo.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetConversationCoreInfoResponseBody;
    })();

    im_proto.SetConversationCoreInfoRequestBody = (function() {

        function SetConversationCoreInfoRequestBody(p) {
            this.ext = {};
            this.biz_ext = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SetConversationCoreInfoRequestBody.prototype.conversation_id = "";
        SetConversationCoreInfoRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        SetConversationCoreInfoRequestBody.prototype.conversation_type = 0;
        SetConversationCoreInfoRequestBody.prototype.name = "";
        SetConversationCoreInfoRequestBody.prototype.desc = "";
        SetConversationCoreInfoRequestBody.prototype.icon = "";
        SetConversationCoreInfoRequestBody.prototype.notice = "";
        SetConversationCoreInfoRequestBody.prototype.is_name_set = false;
        SetConversationCoreInfoRequestBody.prototype.is_desc_set = false;
        SetConversationCoreInfoRequestBody.prototype.is_icon_set = false;
        SetConversationCoreInfoRequestBody.prototype.is_notice_set = false;
        SetConversationCoreInfoRequestBody.prototype.ext = $util.emptyObject;
        SetConversationCoreInfoRequestBody.prototype.biz_ext = $util.emptyObject;

        SetConversationCoreInfoRequestBody.create = function create(properties) {
            return new SetConversationCoreInfoRequestBody(properties);
        };

        SetConversationCoreInfoRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(34).string(m.name);
            if (m.desc != null && Object.hasOwnProperty.call(m, "desc"))
                w.uint32(42).string(m.desc);
            if (m.icon != null && Object.hasOwnProperty.call(m, "icon"))
                w.uint32(50).string(m.icon);
            if (m.notice != null && Object.hasOwnProperty.call(m, "notice"))
                w.uint32(58).string(m.notice);
            if (m.is_name_set != null && Object.hasOwnProperty.call(m, "is_name_set"))
                w.uint32(64).bool(m.is_name_set);
            if (m.is_desc_set != null && Object.hasOwnProperty.call(m, "is_desc_set"))
                w.uint32(72).bool(m.is_desc_set);
            if (m.is_icon_set != null && Object.hasOwnProperty.call(m, "is_icon_set"))
                w.uint32(80).bool(m.is_icon_set);
            if (m.is_notice_set != null && Object.hasOwnProperty.call(m, "is_notice_set"))
                w.uint32(88).bool(m.is_notice_set);
            if (m.ext != null && Object.hasOwnProperty.call(m, "ext")) {
                for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
                    w.uint32(98).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
                }
            }
            if (m.biz_ext != null && Object.hasOwnProperty.call(m, "biz_ext")) {
                for (var ks = Object.keys(m.biz_ext), i = 0; i < ks.length; ++i) {
                    w.uint32(186).fork().uint32(10).string(ks[i]).uint32(18).string(m.biz_ext[ks[i]]).ldelim();
                }
            }
            return w;
        };

        SetConversationCoreInfoRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.SetConversationCoreInfoRequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    m.name = r.string();
                    break;
                case 5:
                    m.desc = r.string();
                    break;
                case 6:
                    m.icon = r.string();
                    break;
                case 7:
                    m.notice = r.string();
                    break;
                case 8:
                    m.is_name_set = r.bool();
                    break;
                case 9:
                    m.is_desc_set = r.bool();
                    break;
                case 10:
                    m.is_icon_set = r.bool();
                    break;
                case 11:
                    m.is_notice_set = r.bool();
                    break;
                case 12:
                    if (m.ext === $util.emptyObject)
                        m.ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.ext[k] = value;
                    break;
                case 23:
                    if (m.biz_ext === $util.emptyObject)
                        m.biz_ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.biz_ext[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SetConversationCoreInfoRequestBody;
    })();

    im_proto.SetConversationCoreInfoResponseBody = (function() {

        function SetConversationCoreInfoResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SetConversationCoreInfoResponseBody.prototype.conversation_core_info = null;
        SetConversationCoreInfoResponseBody.prototype.status = 0;
        SetConversationCoreInfoResponseBody.prototype.extra_info = "";
        SetConversationCoreInfoResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        SetConversationCoreInfoResponseBody.prototype.check_message = "";

        SetConversationCoreInfoResponseBody.create = function create(properties) {
            return new SetConversationCoreInfoResponseBody(properties);
        };

        SetConversationCoreInfoResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_core_info != null && Object.hasOwnProperty.call(m, "conversation_core_info"))
                $root.im_proto.ConversationCoreInfo.encode(m.conversation_core_info, w.uint32(10).fork()).ldelim();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(16).int32(m.status);
            if (m.extra_info != null && Object.hasOwnProperty.call(m, "extra_info"))
                w.uint32(26).string(m.extra_info);
            if (m.check_code != null && Object.hasOwnProperty.call(m, "check_code"))
                w.uint32(32).int64(m.check_code);
            if (m.check_message != null && Object.hasOwnProperty.call(m, "check_message"))
                w.uint32(42).string(m.check_message);
            return w;
        };

        SetConversationCoreInfoResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.SetConversationCoreInfoResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_core_info = $root.im_proto.ConversationCoreInfo.decode(r, r.uint32());
                    break;
                case 2:
                    m.status = r.int32();
                    break;
                case 3:
                    m.extra_info = r.string();
                    break;
                case 4:
                    m.check_code = r.int64();
                    break;
                case 5:
                    m.check_message = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SetConversationCoreInfoResponseBody;
    })();

    im_proto.UpsertConversationCoreExtInfoRequestBody = (function() {

        function UpsertConversationCoreExtInfoRequestBody(p) {
            this.ext = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UpsertConversationCoreExtInfoRequestBody.prototype.conversation_id = "";
        UpsertConversationCoreExtInfoRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        UpsertConversationCoreExtInfoRequestBody.prototype.conversation_type = 0;
        UpsertConversationCoreExtInfoRequestBody.prototype.ext = $util.emptyObject;

        UpsertConversationCoreExtInfoRequestBody.create = function create(properties) {
            return new UpsertConversationCoreExtInfoRequestBody(properties);
        };

        UpsertConversationCoreExtInfoRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.ext != null && Object.hasOwnProperty.call(m, "ext")) {
                for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
                    w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
                }
            }
            return w;
        };

        UpsertConversationCoreExtInfoRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.UpsertConversationCoreExtInfoRequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    if (m.ext === $util.emptyObject)
                        m.ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.ext[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpsertConversationCoreExtInfoRequestBody;
    })();

    im_proto.UpsertConversationCoreExtInfoResponseBody = (function() {

        function UpsertConversationCoreExtInfoResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UpsertConversationCoreExtInfoResponseBody.prototype.core_info = null;
        UpsertConversationCoreExtInfoResponseBody.prototype.status = 0;
        UpsertConversationCoreExtInfoResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        UpsertConversationCoreExtInfoResponseBody.prototype.check_message = "";
        UpsertConversationCoreExtInfoResponseBody.prototype.extra_info = "";

        UpsertConversationCoreExtInfoResponseBody.create = function create(properties) {
            return new UpsertConversationCoreExtInfoResponseBody(properties);
        };

        UpsertConversationCoreExtInfoResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.core_info != null && Object.hasOwnProperty.call(m, "core_info"))
                $root.im_proto.ConversationCoreInfo.encode(m.core_info, w.uint32(10).fork()).ldelim();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(16).int32(m.status);
            if (m.check_code != null && Object.hasOwnProperty.call(m, "check_code"))
                w.uint32(24).int64(m.check_code);
            if (m.check_message != null && Object.hasOwnProperty.call(m, "check_message"))
                w.uint32(34).string(m.check_message);
            if (m.extra_info != null && Object.hasOwnProperty.call(m, "extra_info"))
                w.uint32(42).string(m.extra_info);
            return w;
        };

        UpsertConversationCoreExtInfoResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.UpsertConversationCoreExtInfoResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.core_info = $root.im_proto.ConversationCoreInfo.decode(r, r.uint32());
                    break;
                case 2:
                    m.status = r.int32();
                    break;
                case 3:
                    m.check_code = r.int64();
                    break;
                case 4:
                    m.check_message = r.string();
                    break;
                case 5:
                    m.extra_info = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpsertConversationCoreExtInfoResponseBody;
    })();

    im_proto.SetConversationSettingInfoRequestBody = (function() {

        function SetConversationSettingInfoRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SetConversationSettingInfoRequestBody.prototype.conversation_id = "";
        SetConversationSettingInfoRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        SetConversationSettingInfoRequestBody.prototype.conversation_type = 0;
        SetConversationSettingInfoRequestBody.prototype.set_stick_on_top = false;
        SetConversationSettingInfoRequestBody.prototype.set_mute = false;
        SetConversationSettingInfoRequestBody.prototype.set_favorite = false;
        SetConversationSettingInfoRequestBody.prototype.push_status = 0;

        SetConversationSettingInfoRequestBody.create = function create(properties) {
            return new SetConversationSettingInfoRequestBody(properties);
        };

        SetConversationSettingInfoRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.set_stick_on_top != null && Object.hasOwnProperty.call(m, "set_stick_on_top"))
                w.uint32(32).bool(m.set_stick_on_top);
            if (m.set_mute != null && Object.hasOwnProperty.call(m, "set_mute"))
                w.uint32(40).bool(m.set_mute);
            if (m.set_favorite != null && Object.hasOwnProperty.call(m, "set_favorite"))
                w.uint32(48).bool(m.set_favorite);
            if (m.push_status != null && Object.hasOwnProperty.call(m, "push_status"))
                w.uint32(56).int32(m.push_status);
            return w;
        };

        SetConversationSettingInfoRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.SetConversationSettingInfoRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    m.set_stick_on_top = r.bool();
                    break;
                case 5:
                    m.set_mute = r.bool();
                    break;
                case 6:
                    m.set_favorite = r.bool();
                    break;
                case 7:
                    m.push_status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SetConversationSettingInfoRequestBody;
    })();

    im_proto.SetConversationSettingInfoResponseBody = (function() {

        function SetConversationSettingInfoResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SetConversationSettingInfoResponseBody.prototype.setting_info = null;
        SetConversationSettingInfoResponseBody.prototype.status = 0;
        SetConversationSettingInfoResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        SetConversationSettingInfoResponseBody.prototype.check_message = "";
        SetConversationSettingInfoResponseBody.prototype.extra_info = "";

        SetConversationSettingInfoResponseBody.create = function create(properties) {
            return new SetConversationSettingInfoResponseBody(properties);
        };

        SetConversationSettingInfoResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.setting_info != null && Object.hasOwnProperty.call(m, "setting_info"))
                $root.im_proto.ConversationSettingInfo.encode(m.setting_info, w.uint32(10).fork()).ldelim();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(16).int32(m.status);
            if (m.check_code != null && Object.hasOwnProperty.call(m, "check_code"))
                w.uint32(24).int64(m.check_code);
            if (m.check_message != null && Object.hasOwnProperty.call(m, "check_message"))
                w.uint32(34).string(m.check_message);
            if (m.extra_info != null && Object.hasOwnProperty.call(m, "extra_info"))
                w.uint32(42).string(m.extra_info);
            return w;
        };

        SetConversationSettingInfoResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.SetConversationSettingInfoResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.setting_info = $root.im_proto.ConversationSettingInfo.decode(r, r.uint32());
                    break;
                case 2:
                    m.status = r.int32();
                    break;
                case 3:
                    m.check_code = r.int64();
                    break;
                case 4:
                    m.check_message = r.string();
                    break;
                case 5:
                    m.extra_info = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SetConversationSettingInfoResponseBody;
    })();

    im_proto.UpsertConversationSettingExtInfoRequestBody = (function() {

        function UpsertConversationSettingExtInfoRequestBody(p) {
            this.ext = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UpsertConversationSettingExtInfoRequestBody.prototype.conversation_id = "";
        UpsertConversationSettingExtInfoRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        UpsertConversationSettingExtInfoRequestBody.prototype.conversation_type = 0;
        UpsertConversationSettingExtInfoRequestBody.prototype.ext = $util.emptyObject;

        UpsertConversationSettingExtInfoRequestBody.create = function create(properties) {
            return new UpsertConversationSettingExtInfoRequestBody(properties);
        };

        UpsertConversationSettingExtInfoRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.ext != null && Object.hasOwnProperty.call(m, "ext")) {
                for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
                    w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
                }
            }
            return w;
        };

        UpsertConversationSettingExtInfoRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.UpsertConversationSettingExtInfoRequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    if (m.ext === $util.emptyObject)
                        m.ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.ext[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpsertConversationSettingExtInfoRequestBody;
    })();

    im_proto.UpsertConversationSettingExtInfoResponseBody = (function() {

        function UpsertConversationSettingExtInfoResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UpsertConversationSettingExtInfoResponseBody.prototype.setting_info = null;
        UpsertConversationSettingExtInfoResponseBody.prototype.status = 0;
        UpsertConversationSettingExtInfoResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        UpsertConversationSettingExtInfoResponseBody.prototype.check_message = "";
        UpsertConversationSettingExtInfoResponseBody.prototype.extra_info = "";

        UpsertConversationSettingExtInfoResponseBody.create = function create(properties) {
            return new UpsertConversationSettingExtInfoResponseBody(properties);
        };

        UpsertConversationSettingExtInfoResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.setting_info != null && Object.hasOwnProperty.call(m, "setting_info"))
                $root.im_proto.ConversationSettingInfo.encode(m.setting_info, w.uint32(10).fork()).ldelim();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(16).int32(m.status);
            if (m.check_code != null && Object.hasOwnProperty.call(m, "check_code"))
                w.uint32(24).int64(m.check_code);
            if (m.check_message != null && Object.hasOwnProperty.call(m, "check_message"))
                w.uint32(34).string(m.check_message);
            if (m.extra_info != null && Object.hasOwnProperty.call(m, "extra_info"))
                w.uint32(42).string(m.extra_info);
            return w;
        };

        UpsertConversationSettingExtInfoResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.UpsertConversationSettingExtInfoResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.setting_info = $root.im_proto.ConversationSettingInfo.decode(r, r.uint32());
                    break;
                case 2:
                    m.status = r.int32();
                    break;
                case 3:
                    m.check_code = r.int64();
                    break;
                case 4:
                    m.check_message = r.string();
                    break;
                case 5:
                    m.extra_info = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpsertConversationSettingExtInfoResponseBody;
    })();

    im_proto.StrangerConversation = (function() {

        function StrangerConversation(p) {
            this.participants = [];
            this.ext = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        StrangerConversation.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        StrangerConversation.prototype.unread = 0;
        StrangerConversation.prototype.last_message = null;
        StrangerConversation.prototype.conversation_id = "";
        StrangerConversation.prototype.participants = $util.emptyArray;
        StrangerConversation.prototype.ext = $util.emptyObject;

        StrangerConversation.create = function create(properties) {
            return new StrangerConversation(properties);
        };

        StrangerConversation.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(8).int64(m.conversation_short_id);
            if (m.unread != null && Object.hasOwnProperty.call(m, "unread"))
                w.uint32(16).int32(m.unread);
            if (m.last_message != null && Object.hasOwnProperty.call(m, "last_message"))
                $root.im_proto.MessageBody.encode(m.last_message, w.uint32(26).fork()).ldelim();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(34).string(m.conversation_id);
            if (m.participants != null && m.participants.length) {
                for (var i = 0; i < m.participants.length; ++i)
                    $root.im_proto.Participant.encode(m.participants[i], w.uint32(42).fork()).ldelim();
            }
            if (m.ext != null && Object.hasOwnProperty.call(m, "ext")) {
                for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
                    w.uint32(58).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
                }
            }
            return w;
        };

        StrangerConversation.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.StrangerConversation(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_short_id = r.int64();
                    break;
                case 2:
                    m.unread = r.int32();
                    break;
                case 3:
                    m.last_message = $root.im_proto.MessageBody.decode(r, r.uint32());
                    break;
                case 4:
                    m.conversation_id = r.string();
                    break;
                case 5:
                    if (!(m.participants && m.participants.length))
                        m.participants = [];
                    m.participants.push($root.im_proto.Participant.decode(r, r.uint32()));
                    break;
                case 7:
                    if (m.ext === $util.emptyObject)
                        m.ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.ext[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return StrangerConversation;
    })();

    im_proto.GetStrangerConversationListRequestBody = (function() {

        function GetStrangerConversationListRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetStrangerConversationListRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetStrangerConversationListRequestBody.prototype.count = $util.Long ? $util.Long.fromBits(50,0,false) : 50;
        GetStrangerConversationListRequestBody.prototype.show_total_unread = false;

        GetStrangerConversationListRequestBody.create = function create(properties) {
            return new GetStrangerConversationListRequestBody(properties);
        };

        GetStrangerConversationListRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.cursor != null && Object.hasOwnProperty.call(m, "cursor"))
                w.uint32(8).int64(m.cursor);
            if (m.count != null && Object.hasOwnProperty.call(m, "count"))
                w.uint32(16).int64(m.count);
            if (m.show_total_unread != null && Object.hasOwnProperty.call(m, "show_total_unread"))
                w.uint32(24).bool(m.show_total_unread);
            return w;
        };

        GetStrangerConversationListRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetStrangerConversationListRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.cursor = r.int64();
                    break;
                case 2:
                    m.count = r.int64();
                    break;
                case 3:
                    m.show_total_unread = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetStrangerConversationListRequestBody;
    })();

    im_proto.GetStrangerConversationListResponseBody = (function() {

        function GetStrangerConversationListResponseBody(p) {
            this.conversation_list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetStrangerConversationListResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetStrangerConversationListResponseBody.prototype.has_more = false;
        GetStrangerConversationListResponseBody.prototype.total_unread = 0;
        GetStrangerConversationListResponseBody.prototype.conversation_list = $util.emptyArray;

        GetStrangerConversationListResponseBody.create = function create(properties) {
            return new GetStrangerConversationListResponseBody(properties);
        };

        GetStrangerConversationListResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.next_cursor != null && Object.hasOwnProperty.call(m, "next_cursor"))
                w.uint32(8).int64(m.next_cursor);
            if (m.has_more != null && Object.hasOwnProperty.call(m, "has_more"))
                w.uint32(16).bool(m.has_more);
            if (m.total_unread != null && Object.hasOwnProperty.call(m, "total_unread"))
                w.uint32(24).int32(m.total_unread);
            if (m.conversation_list != null && m.conversation_list.length) {
                for (var i = 0; i < m.conversation_list.length; ++i)
                    $root.im_proto.StrangerConversation.encode(m.conversation_list[i], w.uint32(34).fork()).ldelim();
            }
            return w;
        };

        GetStrangerConversationListResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetStrangerConversationListResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.next_cursor = r.int64();
                    break;
                case 2:
                    m.has_more = r.bool();
                    break;
                case 3:
                    m.total_unread = r.int32();
                    break;
                case 4:
                    if (!(m.conversation_list && m.conversation_list.length))
                        m.conversation_list = [];
                    m.conversation_list.push($root.im_proto.StrangerConversation.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetStrangerConversationListResponseBody;
    })();

    im_proto.GetStrangerMessagesRequestBody = (function() {

        function GetStrangerMessagesRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetStrangerMessagesRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetStrangerMessagesRequestBody.prototype.reset_unread_count = false;

        GetStrangerMessagesRequestBody.create = function create(properties) {
            return new GetStrangerMessagesRequestBody(properties);
        };

        GetStrangerMessagesRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(8).int64(m.conversation_short_id);
            if (m.reset_unread_count != null && Object.hasOwnProperty.call(m, "reset_unread_count"))
                w.uint32(16).bool(m.reset_unread_count);
            return w;
        };

        GetStrangerMessagesRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetStrangerMessagesRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_short_id = r.int64();
                    break;
                case 2:
                    m.reset_unread_count = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetStrangerMessagesRequestBody;
    })();

    im_proto.GetStrangerMessagesResponseBody = (function() {

        function GetStrangerMessagesResponseBody(p) {
            this.messages = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetStrangerMessagesResponseBody.prototype.messages = $util.emptyArray;

        GetStrangerMessagesResponseBody.create = function create(properties) {
            return new GetStrangerMessagesResponseBody(properties);
        };

        GetStrangerMessagesResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.messages != null && m.messages.length) {
                for (var i = 0; i < m.messages.length; ++i)
                    $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(26).fork()).ldelim();
            }
            return w;
        };

        GetStrangerMessagesResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetStrangerMessagesResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 3:
                    if (!(m.messages && m.messages.length))
                        m.messages = [];
                    m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetStrangerMessagesResponseBody;
    })();

    im_proto.DeleteStrangerMessageRequestBody = (function() {

        function DeleteStrangerMessageRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        DeleteStrangerMessageRequestBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        DeleteStrangerMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        DeleteStrangerMessageRequestBody.create = function create(properties) {
            return new DeleteStrangerMessageRequestBody(properties);
        };

        DeleteStrangerMessageRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.server_message_id != null && Object.hasOwnProperty.call(m, "server_message_id"))
                w.uint32(8).int64(m.server_message_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            return w;
        };

        DeleteStrangerMessageRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.DeleteStrangerMessageRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.server_message_id = r.int64();
                    break;
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DeleteStrangerMessageRequestBody;
    })();

    im_proto.DeleteStrangerConversationRequestBody = (function() {

        function DeleteStrangerConversationRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        DeleteStrangerConversationRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        DeleteStrangerConversationRequestBody.create = function create(properties) {
            return new DeleteStrangerConversationRequestBody(properties);
        };

        DeleteStrangerConversationRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(8).int64(m.conversation_short_id);
            return w;
        };

        DeleteStrangerConversationRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.DeleteStrangerConversationRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_short_id = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DeleteStrangerConversationRequestBody;
    })();

    im_proto.DeleteStrangerAllConversationRequestBody = (function() {

        function DeleteStrangerAllConversationRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        DeleteStrangerAllConversationRequestBody.create = function create(properties) {
            return new DeleteStrangerAllConversationRequestBody(properties);
        };

        DeleteStrangerAllConversationRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            return w;
        };

        DeleteStrangerAllConversationRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.DeleteStrangerAllConversationRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DeleteStrangerAllConversationRequestBody;
    })();

    im_proto.MarkStrangerConversationReadRequestBody = (function() {

        function MarkStrangerConversationReadRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MarkStrangerConversationReadRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        MarkStrangerConversationReadRequestBody.create = function create(properties) {
            return new MarkStrangerConversationReadRequestBody(properties);
        };

        MarkStrangerConversationReadRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(8).int64(m.conversation_short_id);
            return w;
        };

        MarkStrangerConversationReadRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MarkStrangerConversationReadRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_short_id = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MarkStrangerConversationReadRequestBody;
    })();

    im_proto.MarkStrangerAllConversationReadRequestBody = (function() {

        function MarkStrangerAllConversationReadRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MarkStrangerAllConversationReadRequestBody.create = function create(properties) {
            return new MarkStrangerAllConversationReadRequestBody(properties);
        };

        MarkStrangerAllConversationReadRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            return w;
        };

        MarkStrangerAllConversationReadRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MarkStrangerAllConversationReadRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MarkStrangerAllConversationReadRequestBody;
    })();

    im_proto.OPERATION_TYPE = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ADD_PROPERTY_ITEM"] = 0;
        values[valuesById[1] = "REMOVE_PROPERTY_ITEM"] = 1;
        values[valuesById[2] = "SET_PROPERTY"] = 2;
        values[valuesById[3] = "DEL_PROPERTY"] = 3;
        return values;
    })();

    im_proto.ModifyPropertyContent = (function() {

        function ModifyPropertyContent(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ModifyPropertyContent.prototype.operation = 0;
        ModifyPropertyContent.prototype.key = "";
        ModifyPropertyContent.prototype.value = "";
        ModifyPropertyContent.prototype.idempotent_id = "";

        ModifyPropertyContent.create = function create(properties) {
            return new ModifyPropertyContent(properties);
        };

        ModifyPropertyContent.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.operation != null && Object.hasOwnProperty.call(m, "operation"))
                w.uint32(8).int32(m.operation);
            if (m.key != null && Object.hasOwnProperty.call(m, "key"))
                w.uint32(18).string(m.key);
            if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                w.uint32(26).string(m.value);
            if (m.idempotent_id != null && Object.hasOwnProperty.call(m, "idempotent_id"))
                w.uint32(34).string(m.idempotent_id);
            return w;
        };

        ModifyPropertyContent.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ModifyPropertyContent();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.operation = r.int32();
                    break;
                case 2:
                    m.key = r.string();
                    break;
                case 3:
                    m.value = r.string();
                    break;
                case 4:
                    m.idempotent_id = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ModifyPropertyContent;
    })();

    im_proto.ModifyPropertyBody = (function() {

        function ModifyPropertyBody(p) {
            this.modify_property_content = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ModifyPropertyBody.prototype.conversation_id = "";
        ModifyPropertyBody.prototype.conversation_type = 0;
        ModifyPropertyBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ModifyPropertyBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ModifyPropertyBody.prototype.client_message_id = "";
        ModifyPropertyBody.prototype.modify_property_content = $util.emptyArray;

        ModifyPropertyBody.create = function create(properties) {
            return new ModifyPropertyBody(properties);
        };

        ModifyPropertyBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(24).int64(m.conversation_short_id);
            if (m.server_message_id != null && Object.hasOwnProperty.call(m, "server_message_id"))
                w.uint32(32).int64(m.server_message_id);
            if (m.client_message_id != null && Object.hasOwnProperty.call(m, "client_message_id"))
                w.uint32(42).string(m.client_message_id);
            if (m.modify_property_content != null && m.modify_property_content.length) {
                for (var i = 0; i < m.modify_property_content.length; ++i)
                    $root.im_proto.ModifyPropertyContent.encode(m.modify_property_content[i], w.uint32(50).fork()).ldelim();
            }
            return w;
        };

        ModifyPropertyBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ModifyPropertyBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.conversation_short_id = r.int64();
                    break;
                case 4:
                    m.server_message_id = r.int64();
                    break;
                case 5:
                    m.client_message_id = r.string();
                    break;
                case 6:
                    if (!(m.modify_property_content && m.modify_property_content.length))
                        m.modify_property_content = [];
                    m.modify_property_content.push($root.im_proto.ModifyPropertyContent.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ModifyPropertyBody;
    })();

    im_proto.ModifyMessagePropertyRequestBody = (function() {

        function ModifyMessagePropertyRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ModifyMessagePropertyRequestBody.prototype.property_list = null;
        ModifyMessagePropertyRequestBody.prototype.ticket = "";

        ModifyMessagePropertyRequestBody.create = function create(properties) {
            return new ModifyMessagePropertyRequestBody(properties);
        };

        ModifyMessagePropertyRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.property_list != null && Object.hasOwnProperty.call(m, "property_list"))
                $root.im_proto.ModifyPropertyBody.encode(m.property_list, w.uint32(10).fork()).ldelim();
            if (m.ticket != null && Object.hasOwnProperty.call(m, "ticket"))
                w.uint32(18).string(m.ticket);
            return w;
        };

        ModifyMessagePropertyRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ModifyMessagePropertyRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.property_list = $root.im_proto.ModifyPropertyBody.decode(r, r.uint32());
                    break;
                case 2:
                    m.ticket = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ModifyMessagePropertyRequestBody;
    })();

    im_proto.ModifyMessagePropertyStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MODIFY_PROPERTY_SUCCESS"] = 0;
        values[valuesById[1] = "MODIFY_PROPERTY_REPEAT_REQUEST"] = 1;
        values[valuesById[2] = "MODIFY_PROPERTY_INVALID_LENGTH"] = 2;
        values[valuesById[3] = "MODIFY_PROPERTY_INVALID_REQUEST"] = 3;
        values[valuesById[4] = "MODIFY_PROPERTY_CALLBACK_ERROR"] = 4;
        values[valuesById[500] = "MODIFY_PROPERTY_INTERNAL_ERROR"] = 500;
        return values;
    })();

    im_proto.ModifyMessagePropertyResponseBody = (function() {

        function ModifyMessagePropertyResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ModifyMessagePropertyResponseBody.prototype.status = 0;
        ModifyMessagePropertyResponseBody.prototype.version = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        ModifyMessagePropertyResponseBody.create = function create(properties) {
            return new ModifyMessagePropertyResponseBody(properties);
        };

        ModifyMessagePropertyResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(8).int32(m.status);
            if (m.version != null && Object.hasOwnProperty.call(m, "version"))
                w.uint32(16).int64(m.version);
            return w;
        };

        ModifyMessagePropertyResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ModifyMessagePropertyResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.status = r.int32();
                    break;
                case 2:
                    m.version = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ModifyMessagePropertyResponseBody;
    })();

    im_proto.MediaType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "IMG"] = 1;
        values[valuesById[2] = "VIDEO"] = 2;
        values[valuesById[3] = "AUDIO"] = 3;
        values[valuesById[4] = "FILE"] = 4;
        values[valuesById[10] = "OTHER"] = 10;
        return values;
    })();

    im_proto.MediaTokenType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "VSDK"] = 1;
        values[valuesById[2] = "IMAGEX"] = 2;
        values[valuesById[3] = "VSDK_V5"] = 3;
        values[valuesById[4] = "IMAGEX_V5"] = 4;
        return values;
    })();

    im_proto.GetUploadTokenRequestBody = (function() {

        function GetUploadTokenRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetUploadTokenRequestBody.prototype.vsdk_version = "";
        GetUploadTokenRequestBody.prototype.token_type = 1;

        GetUploadTokenRequestBody.create = function create(properties) {
            return new GetUploadTokenRequestBody(properties);
        };

        GetUploadTokenRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.vsdk_version != null && Object.hasOwnProperty.call(m, "vsdk_version"))
                w.uint32(10).string(m.vsdk_version);
            if (m.token_type != null && Object.hasOwnProperty.call(m, "token_type"))
                w.uint32(16).int32(m.token_type);
            return w;
        };

        GetUploadTokenRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetUploadTokenRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.vsdk_version = r.string();
                    break;
                case 2:
                    m.token_type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetUploadTokenRequestBody;
    })();

    im_proto.GetUploadTokenResponseBody = (function() {

        function GetUploadTokenResponseBody(p) {
            this.hosts = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetUploadTokenResponseBody.prototype.access_key = "";
        GetUploadTokenResponseBody.prototype.hosts = $util.emptyArray;
        GetUploadTokenResponseBody.prototype.token = "";
        GetUploadTokenResponseBody.prototype.token_type = 1;
        GetUploadTokenResponseBody.prototype.secret_access_key = "";
        GetUploadTokenResponseBody.prototype.space_name = "";
        GetUploadTokenResponseBody.prototype.service_id = "";
        GetUploadTokenResponseBody.prototype.expire_time = "";
        GetUploadTokenResponseBody.prototype.current_time = "";

        GetUploadTokenResponseBody.create = function create(properties) {
            return new GetUploadTokenResponseBody(properties);
        };

        GetUploadTokenResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.access_key != null && Object.hasOwnProperty.call(m, "access_key"))
                w.uint32(10).string(m.access_key);
            if (m.hosts != null && m.hosts.length) {
                for (var i = 0; i < m.hosts.length; ++i)
                    w.uint32(18).string(m.hosts[i]);
            }
            if (m.token != null && Object.hasOwnProperty.call(m, "token"))
                w.uint32(26).string(m.token);
            if (m.token_type != null && Object.hasOwnProperty.call(m, "token_type"))
                w.uint32(32).int32(m.token_type);
            if (m.secret_access_key != null && Object.hasOwnProperty.call(m, "secret_access_key"))
                w.uint32(42).string(m.secret_access_key);
            if (m.space_name != null && Object.hasOwnProperty.call(m, "space_name"))
                w.uint32(50).string(m.space_name);
            if (m.service_id != null && Object.hasOwnProperty.call(m, "service_id"))
                w.uint32(58).string(m.service_id);
            if (m.expire_time != null && Object.hasOwnProperty.call(m, "expire_time"))
                w.uint32(66).string(m.expire_time);
            if (m.current_time != null && Object.hasOwnProperty.call(m, "current_time"))
                w.uint32(74).string(m.current_time);
            return w;
        };

        GetUploadTokenResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetUploadTokenResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.access_key = r.string();
                    break;
                case 2:
                    if (!(m.hosts && m.hosts.length))
                        m.hosts = [];
                    m.hosts.push(r.string());
                    break;
                case 3:
                    m.token = r.string();
                    break;
                case 4:
                    m.token_type = r.int32();
                    break;
                case 5:
                    m.secret_access_key = r.string();
                    break;
                case 6:
                    m.space_name = r.string();
                    break;
                case 7:
                    m.service_id = r.string();
                    break;
                case 8:
                    m.expire_time = r.string();
                    break;
                case 9:
                    m.current_time = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetUploadTokenResponseBody;
    })();

    im_proto.ImgOption = (function() {

        function ImgOption(p) {
            this.params = [];
            this.urls = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ImgOption.prototype.tplv = "";
        ImgOption.prototype.params = $util.emptyArray;
        ImgOption.prototype.format = "";
        ImgOption.prototype.urls = $util.emptyArray;

        ImgOption.create = function create(properties) {
            return new ImgOption(properties);
        };

        ImgOption.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.tplv != null && Object.hasOwnProperty.call(m, "tplv"))
                w.uint32(10).string(m.tplv);
            if (m.params != null && m.params.length) {
                for (var i = 0; i < m.params.length; ++i)
                    w.uint32(18).string(m.params[i]);
            }
            if (m.format != null && Object.hasOwnProperty.call(m, "format"))
                w.uint32(26).string(m.format);
            if (m.urls != null && m.urls.length) {
                for (var i = 0; i < m.urls.length; ++i)
                    w.uint32(802).string(m.urls[i]);
            }
            return w;
        };

        ImgOption.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ImgOption();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.tplv = r.string();
                    break;
                case 2:
                    if (!(m.params && m.params.length))
                        m.params = [];
                    m.params.push(r.string());
                    break;
                case 3:
                    m.format = r.string();
                    break;
                case 100:
                    if (!(m.urls && m.urls.length))
                        m.urls = [];
                    m.urls.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ImgOption;
    })();

    im_proto.VideoOption = (function() {

        function VideoOption(p) {
            this.urls = [];
            this.cover_urls = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        VideoOption.prototype.vid = "";
        VideoOption.prototype.cover_uri = "";
        VideoOption.prototype.urls = $util.emptyArray;
        VideoOption.prototype.cover_urls = $util.emptyArray;

        VideoOption.create = function create(properties) {
            return new VideoOption(properties);
        };

        VideoOption.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.vid != null && Object.hasOwnProperty.call(m, "vid"))
                w.uint32(10).string(m.vid);
            if (m.cover_uri != null && Object.hasOwnProperty.call(m, "cover_uri"))
                w.uint32(18).string(m.cover_uri);
            if (m.urls != null && m.urls.length) {
                for (var i = 0; i < m.urls.length; ++i)
                    w.uint32(802).string(m.urls[i]);
            }
            if (m.cover_urls != null && m.cover_urls.length) {
                for (var i = 0; i < m.cover_urls.length; ++i)
                    w.uint32(810).string(m.cover_urls[i]);
            }
            return w;
        };

        VideoOption.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.VideoOption();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.vid = r.string();
                    break;
                case 2:
                    m.cover_uri = r.string();
                    break;
                case 100:
                    if (!(m.urls && m.urls.length))
                        m.urls = [];
                    m.urls.push(r.string());
                    break;
                case 101:
                    if (!(m.cover_urls && m.cover_urls.length))
                        m.cover_urls = [];
                    m.cover_urls.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return VideoOption;
    })();

    im_proto.AudioOption = (function() {

        function AudioOption(p) {
            this.urls = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        AudioOption.prototype.vid = "";
        AudioOption.prototype.urls = $util.emptyArray;

        AudioOption.create = function create(properties) {
            return new AudioOption(properties);
        };

        AudioOption.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.vid != null && Object.hasOwnProperty.call(m, "vid"))
                w.uint32(10).string(m.vid);
            if (m.urls != null && m.urls.length) {
                for (var i = 0; i < m.urls.length; ++i)
                    w.uint32(802).string(m.urls[i]);
            }
            return w;
        };

        AudioOption.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.AudioOption();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.vid = r.string();
                    break;
                case 100:
                    if (!(m.urls && m.urls.length))
                        m.urls = [];
                    m.urls.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return AudioOption;
    })();

    im_proto.FileOption = (function() {

        function FileOption(p) {
            this.urls = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        FileOption.prototype.urls = $util.emptyArray;

        FileOption.create = function create(properties) {
            return new FileOption(properties);
        };

        FileOption.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.urls != null && m.urls.length) {
                for (var i = 0; i < m.urls.length; ++i)
                    w.uint32(802).string(m.urls[i]);
            }
            return w;
        };

        FileOption.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.FileOption();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    if (!(m.urls && m.urls.length))
                        m.urls = [];
                    m.urls.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return FileOption;
    })();

    im_proto.ReadURLFrom = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "URL_VSDK"] = 1;
        values[valuesById[2] = "URL_IMAGEX"] = 2;
        return values;
    })();

    im_proto.GetMediaUrlsRequestBody = (function() {

        function GetMediaUrlsRequestBody(p) {
            this.img_options = [];
            this.video_options = [];
            this.audio_options = [];
            this.file_options = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetMediaUrlsRequestBody.prototype.source_appid = 0;
        GetMediaUrlsRequestBody.prototype.uri = "";
        GetMediaUrlsRequestBody.prototype.media_type = 0;
        GetMediaUrlsRequestBody.prototype.encrypted = false;
        GetMediaUrlsRequestBody.prototype.img_options = $util.emptyArray;
        GetMediaUrlsRequestBody.prototype.video_options = $util.emptyArray;
        GetMediaUrlsRequestBody.prototype.audio_options = $util.emptyArray;
        GetMediaUrlsRequestBody.prototype.file_options = $util.emptyArray;
        GetMediaUrlsRequestBody.prototype.encrypted_uri = "";
        GetMediaUrlsRequestBody.prototype.read_url_from = 1;

        GetMediaUrlsRequestBody.create = function create(properties) {
            return new GetMediaUrlsRequestBody(properties);
        };

        GetMediaUrlsRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.source_appid != null && Object.hasOwnProperty.call(m, "source_appid"))
                w.uint32(8).int32(m.source_appid);
            if (m.uri != null && Object.hasOwnProperty.call(m, "uri"))
                w.uint32(18).string(m.uri);
            if (m.media_type != null && Object.hasOwnProperty.call(m, "media_type"))
                w.uint32(24).int32(m.media_type);
            if (m.encrypted != null && Object.hasOwnProperty.call(m, "encrypted"))
                w.uint32(32).bool(m.encrypted);
            if (m.img_options != null && m.img_options.length) {
                for (var i = 0; i < m.img_options.length; ++i)
                    $root.im_proto.ImgOption.encode(m.img_options[i], w.uint32(42).fork()).ldelim();
            }
            if (m.video_options != null && m.video_options.length) {
                for (var i = 0; i < m.video_options.length; ++i)
                    $root.im_proto.VideoOption.encode(m.video_options[i], w.uint32(50).fork()).ldelim();
            }
            if (m.audio_options != null && m.audio_options.length) {
                for (var i = 0; i < m.audio_options.length; ++i)
                    $root.im_proto.AudioOption.encode(m.audio_options[i], w.uint32(58).fork()).ldelim();
            }
            if (m.file_options != null && m.file_options.length) {
                for (var i = 0; i < m.file_options.length; ++i)
                    $root.im_proto.FileOption.encode(m.file_options[i], w.uint32(66).fork()).ldelim();
            }
            if (m.encrypted_uri != null && Object.hasOwnProperty.call(m, "encrypted_uri"))
                w.uint32(74).string(m.encrypted_uri);
            if (m.read_url_from != null && Object.hasOwnProperty.call(m, "read_url_from"))
                w.uint32(80).int32(m.read_url_from);
            return w;
        };

        GetMediaUrlsRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetMediaUrlsRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.source_appid = r.int32();
                    break;
                case 2:
                    m.uri = r.string();
                    break;
                case 3:
                    m.media_type = r.int32();
                    break;
                case 4:
                    m.encrypted = r.bool();
                    break;
                case 5:
                    if (!(m.img_options && m.img_options.length))
                        m.img_options = [];
                    m.img_options.push($root.im_proto.ImgOption.decode(r, r.uint32()));
                    break;
                case 6:
                    if (!(m.video_options && m.video_options.length))
                        m.video_options = [];
                    m.video_options.push($root.im_proto.VideoOption.decode(r, r.uint32()));
                    break;
                case 7:
                    if (!(m.audio_options && m.audio_options.length))
                        m.audio_options = [];
                    m.audio_options.push($root.im_proto.AudioOption.decode(r, r.uint32()));
                    break;
                case 8:
                    if (!(m.file_options && m.file_options.length))
                        m.file_options = [];
                    m.file_options.push($root.im_proto.FileOption.decode(r, r.uint32()));
                    break;
                case 9:
                    m.encrypted_uri = r.string();
                    break;
                case 10:
                    m.read_url_from = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetMediaUrlsRequestBody;
    })();

    im_proto.GetMediaUrlsResponseBody = (function() {

        function GetMediaUrlsResponseBody(p) {
            this.img_options = [];
            this.video_options = [];
            this.audio_options = [];
            this.file_options = [];
            this.encrypted_urls = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetMediaUrlsResponseBody.prototype.uri = "";
        GetMediaUrlsResponseBody.prototype.media_type = 0;
        GetMediaUrlsResponseBody.prototype.img_options = $util.emptyArray;
        GetMediaUrlsResponseBody.prototype.video_options = $util.emptyArray;
        GetMediaUrlsResponseBody.prototype.audio_options = $util.emptyArray;
        GetMediaUrlsResponseBody.prototype.file_options = $util.emptyArray;
        GetMediaUrlsResponseBody.prototype.encrypted_urls = $util.emptyArray;

        GetMediaUrlsResponseBody.create = function create(properties) {
            return new GetMediaUrlsResponseBody(properties);
        };

        GetMediaUrlsResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.uri != null && Object.hasOwnProperty.call(m, "uri"))
                w.uint32(10).string(m.uri);
            if (m.media_type != null && Object.hasOwnProperty.call(m, "media_type"))
                w.uint32(16).int32(m.media_type);
            if (m.img_options != null && m.img_options.length) {
                for (var i = 0; i < m.img_options.length; ++i)
                    $root.im_proto.ImgOption.encode(m.img_options[i], w.uint32(26).fork()).ldelim();
            }
            if (m.video_options != null && m.video_options.length) {
                for (var i = 0; i < m.video_options.length; ++i)
                    $root.im_proto.VideoOption.encode(m.video_options[i], w.uint32(34).fork()).ldelim();
            }
            if (m.audio_options != null && m.audio_options.length) {
                for (var i = 0; i < m.audio_options.length; ++i)
                    $root.im_proto.AudioOption.encode(m.audio_options[i], w.uint32(42).fork()).ldelim();
            }
            if (m.file_options != null && m.file_options.length) {
                for (var i = 0; i < m.file_options.length; ++i)
                    $root.im_proto.FileOption.encode(m.file_options[i], w.uint32(50).fork()).ldelim();
            }
            if (m.encrypted_urls != null && m.encrypted_urls.length) {
                for (var i = 0; i < m.encrypted_urls.length; ++i)
                    w.uint32(58).string(m.encrypted_urls[i]);
            }
            return w;
        };

        GetMediaUrlsResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetMediaUrlsResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.uri = r.string();
                    break;
                case 2:
                    m.media_type = r.int32();
                    break;
                case 3:
                    if (!(m.img_options && m.img_options.length))
                        m.img_options = [];
                    m.img_options.push($root.im_proto.ImgOption.decode(r, r.uint32()));
                    break;
                case 4:
                    if (!(m.video_options && m.video_options.length))
                        m.video_options = [];
                    m.video_options.push($root.im_proto.VideoOption.decode(r, r.uint32()));
                    break;
                case 5:
                    if (!(m.audio_options && m.audio_options.length))
                        m.audio_options = [];
                    m.audio_options.push($root.im_proto.AudioOption.decode(r, r.uint32()));
                    break;
                case 6:
                    if (!(m.file_options && m.file_options.length))
                        m.file_options = [];
                    m.file_options.push($root.im_proto.FileOption.decode(r, r.uint32()));
                    break;
                case 7:
                    if (!(m.encrypted_urls && m.encrypted_urls.length))
                        m.encrypted_urls = [];
                    m.encrypted_urls.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetMediaUrlsResponseBody;
    })();

    im_proto.GetTicketRequestBody = (function() {

        function GetTicketRequestBody(p) {
            this.ext = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetTicketRequestBody.prototype.ticket_type = 1;
        GetTicketRequestBody.prototype.conversation_type = 1;
        GetTicketRequestBody.prototype.to_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetTicketRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetTicketRequestBody.prototype.ext = $util.emptyObject;

        GetTicketRequestBody.create = function create(properties) {
            return new GetTicketRequestBody(properties);
        };

        GetTicketRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ticket_type != null && Object.hasOwnProperty.call(m, "ticket_type"))
                w.uint32(8).int32(m.ticket_type);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.to_id != null && Object.hasOwnProperty.call(m, "to_id"))
                w.uint32(32).int64(m.to_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(40).int64(m.conversation_short_id);
            if (m.ext != null && Object.hasOwnProperty.call(m, "ext")) {
                for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
                    w.uint32(82).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
                }
            }
            return w;
        };

        GetTicketRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetTicketRequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.ticket_type = r.int32();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    m.to_id = r.int64();
                    break;
                case 5:
                    m.conversation_short_id = r.int64();
                    break;
                case 10:
                    if (m.ext === $util.emptyObject)
                        m.ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.ext[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetTicketRequestBody;
    })();

    im_proto.GetTicketResponseBody = (function() {

        function GetTicketResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetTicketResponseBody.prototype.ticket = "";

        GetTicketResponseBody.create = function create(properties) {
            return new GetTicketResponseBody(properties);
        };

        GetTicketResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ticket != null && Object.hasOwnProperty.call(m, "ticket"))
                w.uint32(10).string(m.ticket);
            return w;
        };

        GetTicketResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetTicketResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.ticket = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetTicketResponseBody;
    })();

    im_proto.SortType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "JOIN_TIME"] = 1;
        values[valuesById[2] = "CREATED_TIME"] = 2;
        values[valuesById[3] = "GROUP_NAME"] = 3;
        values[valuesById[4] = "ACTIVE_TIME"] = 4;
        return values;
    })();

    im_proto.GetUserConversationListRequestBody = (function() {

        function GetUserConversationListRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetUserConversationListRequestBody.prototype.sort_type = 1;
        GetUserConversationListRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetUserConversationListRequestBody.prototype.con_type = 1;
        GetUserConversationListRequestBody.prototype.limit = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetUserConversationListRequestBody.prototype.include_role = 0;
        GetUserConversationListRequestBody.prototype.exclude_role = 0;
        GetUserConversationListRequestBody.prototype.with_cold = false;
        GetUserConversationListRequestBody.prototype.push_status = 0;

        GetUserConversationListRequestBody.create = function create(properties) {
            return new GetUserConversationListRequestBody(properties);
        };

        GetUserConversationListRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.sort_type != null && Object.hasOwnProperty.call(m, "sort_type"))
                w.uint32(8).int32(m.sort_type);
            if (m.cursor != null && Object.hasOwnProperty.call(m, "cursor"))
                w.uint32(16).int64(m.cursor);
            if (m.con_type != null && Object.hasOwnProperty.call(m, "con_type"))
                w.uint32(24).int32(m.con_type);
            if (m.limit != null && Object.hasOwnProperty.call(m, "limit"))
                w.uint32(32).int64(m.limit);
            if (m.include_role != null && Object.hasOwnProperty.call(m, "include_role"))
                w.uint32(40).int32(m.include_role);
            if (m.exclude_role != null && Object.hasOwnProperty.call(m, "exclude_role"))
                w.uint32(48).int32(m.exclude_role);
            if (m.with_cold != null && Object.hasOwnProperty.call(m, "with_cold"))
                w.uint32(64).bool(m.with_cold);
            if (m.push_status != null && Object.hasOwnProperty.call(m, "push_status"))
                w.uint32(80).int32(m.push_status);
            return w;
        };

        GetUserConversationListRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetUserConversationListRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.sort_type = r.int32();
                    break;
                case 2:
                    m.cursor = r.int64();
                    break;
                case 3:
                    m.con_type = r.int32();
                    break;
                case 4:
                    m.limit = r.int64();
                    break;
                case 5:
                    m.include_role = r.int32();
                    break;
                case 6:
                    m.exclude_role = r.int32();
                    break;
                case 8:
                    m.with_cold = r.bool();
                    break;
                case 10:
                    m.push_status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetUserConversationListRequestBody;
    })();

    im_proto.GetUserConversationListResponseBody = (function() {

        function GetUserConversationListResponseBody(p) {
            this.list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetUserConversationListResponseBody.prototype.list = $util.emptyArray;
        GetUserConversationListResponseBody.prototype.has_more = false;
        GetUserConversationListResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        GetUserConversationListResponseBody.create = function create(properties) {
            return new GetUserConversationListResponseBody(properties);
        };

        GetUserConversationListResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.list != null && m.list.length) {
                for (var i = 0; i < m.list.length; ++i)
                    $root.im_proto.ConversationInfoV2.encode(m.list[i], w.uint32(10).fork()).ldelim();
            }
            if (m.has_more != null && Object.hasOwnProperty.call(m, "has_more"))
                w.uint32(16).bool(m.has_more);
            if (m.next_cursor != null && Object.hasOwnProperty.call(m, "next_cursor"))
                w.uint32(24).int64(m.next_cursor);
            return w;
        };

        GetUserConversationListResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetUserConversationListResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.list && m.list.length))
                        m.list = [];
                    m.list.push($root.im_proto.ConversationInfoV2.decode(r, r.uint32()));
                    break;
                case 2:
                    m.has_more = r.bool();
                    break;
                case 3:
                    m.next_cursor = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetUserConversationListResponseBody;
    })();

    im_proto.ModifyMessageExtRequestBody = (function() {

        function ModifyMessageExtRequestBody(p) {
            this.ext = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ModifyMessageExtRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ModifyMessageExtRequestBody.prototype.message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ModifyMessageExtRequestBody.prototype.ticket = "";
        ModifyMessageExtRequestBody.prototype.ext = $util.emptyObject;

        ModifyMessageExtRequestBody.create = function create(properties) {
            return new ModifyMessageExtRequestBody(properties);
        };

        ModifyMessageExtRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            w.uint32(8).int64(m.conversation_short_id);
            w.uint32(16).int64(m.message_id);
            w.uint32(26).string(m.ticket);
            if (m.ext != null && Object.hasOwnProperty.call(m, "ext")) {
                for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
                    w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
                }
            }
            return w;
        };

        ModifyMessageExtRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ModifyMessageExtRequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_short_id = r.int64();
                    break;
                case 2:
                    m.message_id = r.int64();
                    break;
                case 3:
                    m.ticket = r.string();
                    break;
                case 4:
                    if (m.ext === $util.emptyObject)
                        m.ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.ext[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            if (!m.hasOwnProperty("conversation_short_id"))
                throw $util.ProtocolError("missing required 'conversation_short_id'", { instance: m });
            if (!m.hasOwnProperty("message_id"))
                throw $util.ProtocolError("missing required 'message_id'", { instance: m });
            if (!m.hasOwnProperty("ticket"))
                throw $util.ProtocolError("missing required 'ticket'", { instance: m });
            return m;
        };

        return ModifyMessageExtRequestBody;
    })();

    im_proto.RequestBody = (function() {

        function RequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        RequestBody.prototype.send_message_body = null;
        RequestBody.prototype.messages_per_user_body = null;
        RequestBody.prototype.messages_per_user_init_v2_body = null;
        RequestBody.prototype.get_message_by_id_body = null;
        RequestBody.prototype.messages_in_conversation_body = null;
        RequestBody.prototype.get_messages_checkinfo_in_conversation_body = null;
        RequestBody.prototype.send_user_action_body = null;
        RequestBody.prototype.send_input_status_body = null;
        RequestBody.prototype.delete_conversation_body = null;
        RequestBody.prototype.mark_conversation_read_body = null;
        RequestBody.prototype.conversation_participants_body = null;
        RequestBody.prototype.dissolve_conversation_body = null;
        RequestBody.prototype.create_conversation_v2_body = null;
        RequestBody.prototype.get_conversation_info_list_v2_body = null;
        RequestBody.prototype.get_conversation_info_list_by_favorite_v2_body = null;
        RequestBody.prototype.get_conversation_info_list_by_top_v2_body = null;
        RequestBody.prototype.conversation_add_participants_body = null;
        RequestBody.prototype.conversation_remove_participants_body = null;
        RequestBody.prototype.leave_conversation_body = null;
        RequestBody.prototype.mget_conversation_participants_body = null;
        RequestBody.prototype.update_conversation_participant_body = null;
        RequestBody.prototype.delete_message_body = null;
        RequestBody.prototype.recall_message_body = null;
        RequestBody.prototype.modify_message_property_body = null;
        RequestBody.prototype.audio_recognition_body = null;
        RequestBody.prototype.get_conversation_core_info_body = null;
        RequestBody.prototype.set_conversation_core_info_body = null;
        RequestBody.prototype.upsert_conversation_core_ext_info_body = null;
        RequestBody.prototype.set_conversation_setting_info_body = null;
        RequestBody.prototype.upsert_conversation_setting_ext_info_body = null;
        RequestBody.prototype.get_stranger_conversation_body = null;
        RequestBody.prototype.get_stranger_messages_body = null;
        RequestBody.prototype.delete_stranger_message_body = null;
        RequestBody.prototype.delete_stranger_conversation_body = null;
        RequestBody.prototype.delete_stranger_all_conversation_body = null;
        RequestBody.prototype.mark_stranger_conversation_read_body = null;
        RequestBody.prototype.mark_stranger_all_conversation_read_body = null;
        RequestBody.prototype.participants_read_index_body = null;
        RequestBody.prototype.participants_min_index_body = null;
        RequestBody.prototype.get_upload_token_body = null;
        RequestBody.prototype.get_media_urls_body = null;
        RequestBody.prototype.get_ticket_body = null;
        RequestBody.prototype.get_conversation_list_body = null;
        RequestBody.prototype.broadcast_send_message_body = null;
        RequestBody.prototype.broadcast_recv_message_body = null;
        RequestBody.prototype.broadcast_user_counter_body = null;
        RequestBody.prototype.client_ack_body = null;
        RequestBody.prototype.create_voip_body = null;
        RequestBody.prototype.call_voip_body = null;
        RequestBody.prototype.update_voip_body = null;
        RequestBody.prototype.channel_heartbeat_body = null;
        RequestBody.prototype.profile_get_info = null;
        RequestBody.prototype.report_client_metrics_body = null;
        RequestBody.prototype.get_configs_body = null;
        RequestBody.prototype.modify_message_ext_body = null;
        RequestBody.prototype.unread_count_report_body = null;
        RequestBody.prototype.block_members_body = null;
        RequestBody.prototype.block_conversation_body = null;
        RequestBody.prototype.get_unread_count_body = null;
        RequestBody.prototype.send_message_p2p_body = null;
        RequestBody.prototype.get_blocklist_body = null;
        RequestBody.prototype.set_blocklist_body = null;
        RequestBody.prototype.check_in_blocklist_body = null;
        RequestBody.prototype.mark_message_body = null;
        RequestBody.prototype.pull_mark_message_body = null;
        RequestBody.prototype.batch_get_conversation_participants_readindex = null;
        RequestBody.prototype.message_by_init = null;
        RequestBody.prototype.mark_msg_unread_count_report = null;
        RequestBody.prototype.mark_msg_get_unread_count = null;
        RequestBody.prototype.batch_unmark_message = null;
        RequestBody.prototype.client_batch_ack_body = null;

        RequestBody.create = function create(properties) {
            return new RequestBody(properties);
        };

        RequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.send_message_body != null && Object.hasOwnProperty.call(m, "send_message_body"))
                $root.im_proto.SendMessageRequestBody.encode(m.send_message_body, w.uint32(802).fork()).ldelim();
            if (m.messages_per_user_body != null && Object.hasOwnProperty.call(m, "messages_per_user_body"))
                $root.im_proto.MessagesPerUserRequestBody.encode(m.messages_per_user_body, w.uint32(1602).fork()).ldelim();
            if (m.messages_per_user_init_v2_body != null && Object.hasOwnProperty.call(m, "messages_per_user_init_v2_body"))
                $root.im_proto.MessagesPerUserInitV2RequestBody.encode(m.messages_per_user_init_v2_body, w.uint32(1626).fork()).ldelim();
            if (m.get_message_by_id_body != null && Object.hasOwnProperty.call(m, "get_message_by_id_body"))
                $root.im_proto.GetMessageByIdRequestBody.encode(m.get_message_by_id_body, w.uint32(1690).fork()).ldelim();
            if (m.messages_in_conversation_body != null && Object.hasOwnProperty.call(m, "messages_in_conversation_body"))
                $root.im_proto.MessagesInConversationRequestBody.encode(m.messages_in_conversation_body, w.uint32(2410).fork()).ldelim();
            if (m.get_messages_checkinfo_in_conversation_body != null && Object.hasOwnProperty.call(m, "get_messages_checkinfo_in_conversation_body"))
                $root.im_proto.GetMessagesCheckInfoInConversationRequestBody.encode(m.get_messages_checkinfo_in_conversation_body, w.uint32(2418).fork()).ldelim();
            if (m.send_user_action_body != null && Object.hasOwnProperty.call(m, "send_user_action_body"))
                $root.im_proto.SendUserActionRequestBody.encode(m.send_user_action_body, w.uint32(3282).fork()).ldelim();
            if (m.send_input_status_body != null && Object.hasOwnProperty.call(m, "send_input_status_body"))
                $root.im_proto.SendInputStatusRequestBody.encode(m.send_input_status_body, w.uint32(3290).fork()).ldelim();
            if (m.delete_conversation_body != null && Object.hasOwnProperty.call(m, "delete_conversation_body"))
                $root.im_proto.DeleteConversationRequestBody.encode(m.delete_conversation_body, w.uint32(4826).fork()).ldelim();
            if (m.mark_conversation_read_body != null && Object.hasOwnProperty.call(m, "mark_conversation_read_body"))
                $root.im_proto.MarkConversationReadRequestBody.encode(m.mark_conversation_read_body, w.uint32(4834).fork()).ldelim();
            if (m.conversation_participants_body != null && Object.hasOwnProperty.call(m, "conversation_participants_body"))
                $root.im_proto.ConversationParticipantsListRequestBody.encode(m.conversation_participants_body, w.uint32(4842).fork()).ldelim();
            if (m.create_conversation_v2_body != null && Object.hasOwnProperty.call(m, "create_conversation_v2_body"))
                $root.im_proto.CreateConversationV2RequestBody.encode(m.create_conversation_v2_body, w.uint32(4874).fork()).ldelim();
            if (m.get_conversation_info_list_v2_body != null && Object.hasOwnProperty.call(m, "get_conversation_info_list_v2_body"))
                $root.im_proto.GetConversationInfoListV2RequestBody.encode(m.get_conversation_info_list_v2_body, w.uint32(4882).fork()).ldelim();
            if (m.get_conversation_info_list_by_favorite_v2_body != null && Object.hasOwnProperty.call(m, "get_conversation_info_list_by_favorite_v2_body"))
                $root.im_proto.ConversationsPerUserByFavoriteV2RequestBody.encode(m.get_conversation_info_list_by_favorite_v2_body, w.uint32(4890).fork()).ldelim();
            if (m.get_conversation_info_list_by_top_v2_body != null && Object.hasOwnProperty.call(m, "get_conversation_info_list_by_top_v2_body"))
                $root.im_proto.ConversationsPerUserByTopV2RequestBody.encode(m.get_conversation_info_list_by_top_v2_body, w.uint32(4898).fork()).ldelim();
            if (m.dissolve_conversation_body != null && Object.hasOwnProperty.call(m, "dissolve_conversation_body"))
                $root.im_proto.DissolveConversationRequestBody.encode(m.dissolve_conversation_body, w.uint32(4914).fork()).ldelim();
            if (m.conversation_add_participants_body != null && Object.hasOwnProperty.call(m, "conversation_add_participants_body"))
                $root.im_proto.ConversationAddParticipantsRequestBody.encode(m.conversation_add_participants_body, w.uint32(5202).fork()).ldelim();
            if (m.conversation_remove_participants_body != null && Object.hasOwnProperty.call(m, "conversation_remove_participants_body"))
                $root.im_proto.ConversationRemoveParticipantsRequestBody.encode(m.conversation_remove_participants_body, w.uint32(5210).fork()).ldelim();
            if (m.leave_conversation_body != null && Object.hasOwnProperty.call(m, "leave_conversation_body"))
                $root.im_proto.ConversationLeaveRequestBody.encode(m.leave_conversation_body, w.uint32(5218).fork()).ldelim();
            if (m.mget_conversation_participants_body != null && Object.hasOwnProperty.call(m, "mget_conversation_participants_body"))
                $root.im_proto.MgetConversationParticipantsRequestBody.encode(m.mget_conversation_participants_body, w.uint32(5234).fork()).ldelim();
            if (m.update_conversation_participant_body != null && Object.hasOwnProperty.call(m, "update_conversation_participant_body"))
                $root.im_proto.UpdateConversationParticipantRequestBody.encode(m.update_conversation_participant_body, w.uint32(5242).fork()).ldelim();
            if (m.delete_message_body != null && Object.hasOwnProperty.call(m, "delete_message_body"))
                $root.im_proto.DeleteMessageRequestBody.encode(m.delete_message_body, w.uint32(5610).fork()).ldelim();
            if (m.recall_message_body != null && Object.hasOwnProperty.call(m, "recall_message_body"))
                $root.im_proto.RecallMessageRequestBody.encode(m.recall_message_body, w.uint32(5618).fork()).ldelim();
            if (m.modify_message_property_body != null && Object.hasOwnProperty.call(m, "modify_message_property_body"))
                $root.im_proto.ModifyMessagePropertyRequestBody.encode(m.modify_message_property_body, w.uint32(5642).fork()).ldelim();
            if (m.get_conversation_core_info_body != null && Object.hasOwnProperty.call(m, "get_conversation_core_info_body"))
                $root.im_proto.GetConversationCoreInfoRequestBody.encode(m.get_conversation_core_info_body, w.uint32(7210).fork()).ldelim();
            if (m.set_conversation_core_info_body != null && Object.hasOwnProperty.call(m, "set_conversation_core_info_body"))
                $root.im_proto.SetConversationCoreInfoRequestBody.encode(m.set_conversation_core_info_body, w.uint32(7218).fork()).ldelim();
            if (m.upsert_conversation_core_ext_info_body != null && Object.hasOwnProperty.call(m, "upsert_conversation_core_ext_info_body"))
                $root.im_proto.UpsertConversationCoreExtInfoRequestBody.encode(m.upsert_conversation_core_ext_info_body, w.uint32(7234).fork()).ldelim();
            if (m.set_conversation_setting_info_body != null && Object.hasOwnProperty.call(m, "set_conversation_setting_info_body"))
                $root.im_proto.SetConversationSettingInfoRequestBody.encode(m.set_conversation_setting_info_body, w.uint32(7370).fork()).ldelim();
            if (m.upsert_conversation_setting_ext_info_body != null && Object.hasOwnProperty.call(m, "upsert_conversation_setting_ext_info_body"))
                $root.im_proto.UpsertConversationSettingExtInfoRequestBody.encode(m.upsert_conversation_setting_ext_info_body, w.uint32(7378).fork()).ldelim();
            if (m.get_stranger_conversation_body != null && Object.hasOwnProperty.call(m, "get_stranger_conversation_body"))
                $root.im_proto.GetStrangerConversationListRequestBody.encode(m.get_stranger_conversation_body, w.uint32(8002).fork()).ldelim();
            if (m.get_stranger_messages_body != null && Object.hasOwnProperty.call(m, "get_stranger_messages_body"))
                $root.im_proto.GetStrangerMessagesRequestBody.encode(m.get_stranger_messages_body, w.uint32(8010).fork()).ldelim();
            if (m.delete_stranger_message_body != null && Object.hasOwnProperty.call(m, "delete_stranger_message_body"))
                $root.im_proto.DeleteStrangerMessageRequestBody.encode(m.delete_stranger_message_body, w.uint32(8018).fork()).ldelim();
            if (m.delete_stranger_conversation_body != null && Object.hasOwnProperty.call(m, "delete_stranger_conversation_body"))
                $root.im_proto.DeleteStrangerConversationRequestBody.encode(m.delete_stranger_conversation_body, w.uint32(8026).fork()).ldelim();
            if (m.delete_stranger_all_conversation_body != null && Object.hasOwnProperty.call(m, "delete_stranger_all_conversation_body"))
                $root.im_proto.DeleteStrangerAllConversationRequestBody.encode(m.delete_stranger_all_conversation_body, w.uint32(8034).fork()).ldelim();
            if (m.mark_stranger_conversation_read_body != null && Object.hasOwnProperty.call(m, "mark_stranger_conversation_read_body"))
                $root.im_proto.MarkStrangerConversationReadRequestBody.encode(m.mark_stranger_conversation_read_body, w.uint32(8042).fork()).ldelim();
            if (m.mark_stranger_all_conversation_read_body != null && Object.hasOwnProperty.call(m, "mark_stranger_all_conversation_read_body"))
                $root.im_proto.MarkStrangerAllConversationReadRequestBody.encode(m.mark_stranger_all_conversation_read_body, w.uint32(8050).fork()).ldelim();
            if (m.participants_read_index_body != null && Object.hasOwnProperty.call(m, "participants_read_index_body"))
                $root.im_proto.GetConversationParticipantsReadIndexV3RequestBody.encode(m.participants_read_index_body, w.uint32(16002).fork()).ldelim();
            if (m.participants_min_index_body != null && Object.hasOwnProperty.call(m, "participants_min_index_body"))
                $root.im_proto.GetConversationParticipantsMinIndexV3RequestBody.encode(m.participants_min_index_body, w.uint32(16010).fork()).ldelim();
            if (m.get_upload_token_body != null && Object.hasOwnProperty.call(m, "get_upload_token_body"))
                $root.im_proto.GetUploadTokenRequestBody.encode(m.get_upload_token_body, w.uint32(16026).fork()).ldelim();
            if (m.get_media_urls_body != null && Object.hasOwnProperty.call(m, "get_media_urls_body"))
                $root.im_proto.GetMediaUrlsRequestBody.encode(m.get_media_urls_body, w.uint32(16034).fork()).ldelim();
            if (m.get_ticket_body != null && Object.hasOwnProperty.call(m, "get_ticket_body"))
                $root.im_proto.GetTicketRequestBody.encode(m.get_ticket_body, w.uint32(16042).fork()).ldelim();
            if (m.get_conversation_list_body != null && Object.hasOwnProperty.call(m, "get_conversation_list_body"))
                $root.im_proto.GetUserConversationListRequestBody.encode(m.get_conversation_list_body, w.uint32(16050).fork()).ldelim();
            if (m.broadcast_send_message_body != null && Object.hasOwnProperty.call(m, "broadcast_send_message_body"))
                $root.im_proto.BroadcastSendMessageRequestBody.encode(m.broadcast_send_message_body, w.uint32(16058).fork()).ldelim();
            if (m.broadcast_recv_message_body != null && Object.hasOwnProperty.call(m, "broadcast_recv_message_body"))
                $root.im_proto.BroadcastRecvMessageRequestBody.encode(m.broadcast_recv_message_body, w.uint32(16066).fork()).ldelim();
            if (m.broadcast_user_counter_body != null && Object.hasOwnProperty.call(m, "broadcast_user_counter_body"))
                $root.im_proto.BroadcastUserCounterRequestBody.encode(m.broadcast_user_counter_body, w.uint32(16074).fork()).ldelim();
            if (m.client_ack_body != null && Object.hasOwnProperty.call(m, "client_ack_body"))
                $root.im_proto.ClientACKRequestBody.encode(m.client_ack_body, w.uint32(16082).fork()).ldelim();
            if (m.create_voip_body != null && Object.hasOwnProperty.call(m, "create_voip_body"))
                $root.im_proto.CreateVoipRequestBody.encode(m.create_voip_body, w.uint32(16090).fork()).ldelim();
            if (m.call_voip_body != null && Object.hasOwnProperty.call(m, "call_voip_body"))
                $root.im_proto.CallVoipRequestBody.encode(m.call_voip_body, w.uint32(16098).fork()).ldelim();
            if (m.update_voip_body != null && Object.hasOwnProperty.call(m, "update_voip_body"))
                $root.im_proto.UpdateVoipRequestBody.encode(m.update_voip_body, w.uint32(16106).fork()).ldelim();
            if (m.channel_heartbeat_body != null && Object.hasOwnProperty.call(m, "channel_heartbeat_body"))
                $root.im_proto.ChannelHeartBeatRequestBody.encode(m.channel_heartbeat_body, w.uint32(16114).fork()).ldelim();
            if (m.profile_get_info != null && Object.hasOwnProperty.call(m, "profile_get_info"))
                $root.im_proto.ProfileGetInfoRequestBody.encode(m.profile_get_info, w.uint32(16122).fork()).ldelim();
            if (m.report_client_metrics_body != null && Object.hasOwnProperty.call(m, "report_client_metrics_body"))
                $root.im_proto.ReportClientMetricsRequestBody.encode(m.report_client_metrics_body, w.uint32(16130).fork()).ldelim();
            if (m.get_configs_body != null && Object.hasOwnProperty.call(m, "get_configs_body"))
                $root.im_proto.GetConfigsRequestBody.encode(m.get_configs_body, w.uint32(16138).fork()).ldelim();
            if (m.unread_count_report_body != null && Object.hasOwnProperty.call(m, "unread_count_report_body"))
                $root.im_proto.UnReadCountReportRequestBody.encode(m.unread_count_report_body, w.uint32(16146).fork()).ldelim();
            if (m.block_members_body != null && Object.hasOwnProperty.call(m, "block_members_body"))
                $root.im_proto.BlockMembersRequestBody.encode(m.block_members_body, w.uint32(16154).fork()).ldelim();
            if (m.block_conversation_body != null && Object.hasOwnProperty.call(m, "block_conversation_body"))
                $root.im_proto.BlockConversationRequestBody.encode(m.block_conversation_body, w.uint32(16162).fork()).ldelim();
            if (m.modify_message_ext_body != null && Object.hasOwnProperty.call(m, "modify_message_ext_body"))
                $root.im_proto.ModifyMessageExtRequestBody.encode(m.modify_message_ext_body, w.uint32(16170).fork()).ldelim();
            if (m.get_unread_count_body != null && Object.hasOwnProperty.call(m, "get_unread_count_body"))
                $root.im_proto.GetUnreadCountRequestBody.encode(m.get_unread_count_body, w.uint32(16242).fork()).ldelim();
            if (m.send_message_p2p_body != null && Object.hasOwnProperty.call(m, "send_message_p2p_body"))
                $root.im_proto.SendMessageP2PRequestBody.encode(m.send_message_p2p_body, w.uint32(16250).fork()).ldelim();
            if (m.get_blocklist_body != null && Object.hasOwnProperty.call(m, "get_blocklist_body"))
                $root.im_proto.GetBlockListRequestBody.encode(m.get_blocklist_body, w.uint32(16258).fork()).ldelim();
            if (m.set_blocklist_body != null && Object.hasOwnProperty.call(m, "set_blocklist_body"))
                $root.im_proto.SetBlocklistRequestBody.encode(m.set_blocklist_body, w.uint32(16266).fork()).ldelim();
            if (m.check_in_blocklist_body != null && Object.hasOwnProperty.call(m, "check_in_blocklist_body"))
                $root.im_proto.CheckInBlockListRequestBody.encode(m.check_in_blocklist_body, w.uint32(16274).fork()).ldelim();
            if (m.mark_message_body != null && Object.hasOwnProperty.call(m, "mark_message_body"))
                $root.im_proto.MarkMessageRequestBody.encode(m.mark_message_body, w.uint32(16290).fork()).ldelim();
            if (m.pull_mark_message_body != null && Object.hasOwnProperty.call(m, "pull_mark_message_body"))
                $root.im_proto.PullMarkMessageRequestBody.encode(m.pull_mark_message_body, w.uint32(16298).fork()).ldelim();
            if (m.batch_get_conversation_participants_readindex != null && Object.hasOwnProperty.call(m, "batch_get_conversation_participants_readindex"))
                $root.im_proto.BatchGetConversationParticipantsReadIndexRequestBody.encode(m.batch_get_conversation_participants_readindex, w.uint32(16306).fork()).ldelim();
            if (m.message_by_init != null && Object.hasOwnProperty.call(m, "message_by_init"))
                $root.im_proto.MessageByInitRequestBody.encode(m.message_by_init, w.uint32(16346).fork()).ldelim();
            if (m.mark_msg_unread_count_report != null && Object.hasOwnProperty.call(m, "mark_msg_unread_count_report"))
                $root.im_proto.MarkMsgUnreadCountReportRequestBody.encode(m.mark_msg_unread_count_report, w.uint32(16434).fork()).ldelim();
            if (m.mark_msg_get_unread_count != null && Object.hasOwnProperty.call(m, "mark_msg_get_unread_count"))
                $root.im_proto.MarkMsgGetUnreadCountRequestBody.encode(m.mark_msg_get_unread_count, w.uint32(16442).fork()).ldelim();
            if (m.batch_unmark_message != null && Object.hasOwnProperty.call(m, "batch_unmark_message"))
                $root.im_proto.BatchUnmarkMessageRequestBody.encode(m.batch_unmark_message, w.uint32(16450).fork()).ldelim();
            if (m.client_batch_ack_body != null && Object.hasOwnProperty.call(m, "client_batch_ack_body"))
                $root.im_proto.ClientBatchACKRequestBody.encode(m.client_batch_ack_body, w.uint32(16458).fork()).ldelim();
            if (m.audio_recognition_body != null && Object.hasOwnProperty.call(m, "audio_recognition_body"))
                $root.im_proto.AudioRecognitionRequestBody.encode(m.audio_recognition_body, w.uint32(16474).fork()).ldelim();
            return w;
        };

        RequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.RequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.send_message_body = $root.im_proto.SendMessageRequestBody.decode(r, r.uint32());
                    break;
                case 200:
                    m.messages_per_user_body = $root.im_proto.MessagesPerUserRequestBody.decode(r, r.uint32());
                    break;
                case 203:
                    m.messages_per_user_init_v2_body = $root.im_proto.MessagesPerUserInitV2RequestBody.decode(r, r.uint32());
                    break;
                case 211:
                    m.get_message_by_id_body = $root.im_proto.GetMessageByIdRequestBody.decode(r, r.uint32());
                    break;
                case 301:
                    m.messages_in_conversation_body = $root.im_proto.MessagesInConversationRequestBody.decode(r, r.uint32());
                    break;
                case 302:
                    m.get_messages_checkinfo_in_conversation_body = $root.im_proto.GetMessagesCheckInfoInConversationRequestBody.decode(r, r.uint32());
                    break;
                case 410:
                    m.send_user_action_body = $root.im_proto.SendUserActionRequestBody.decode(r, r.uint32());
                    break;
                case 411:
                    m.send_input_status_body = $root.im_proto.SendInputStatusRequestBody.decode(r, r.uint32());
                    break;
                case 603:
                    m.delete_conversation_body = $root.im_proto.DeleteConversationRequestBody.decode(r, r.uint32());
                    break;
                case 604:
                    m.mark_conversation_read_body = $root.im_proto.MarkConversationReadRequestBody.decode(r, r.uint32());
                    break;
                case 605:
                    m.conversation_participants_body = $root.im_proto.ConversationParticipantsListRequestBody.decode(r, r.uint32());
                    break;
                case 614:
                    m.dissolve_conversation_body = $root.im_proto.DissolveConversationRequestBody.decode(r, r.uint32());
                    break;
                case 609:
                    m.create_conversation_v2_body = $root.im_proto.CreateConversationV2RequestBody.decode(r, r.uint32());
                    break;
                case 610:
                    m.get_conversation_info_list_v2_body = $root.im_proto.GetConversationInfoListV2RequestBody.decode(r, r.uint32());
                    break;
                case 611:
                    m.get_conversation_info_list_by_favorite_v2_body = $root.im_proto.ConversationsPerUserByFavoriteV2RequestBody.decode(r, r.uint32());
                    break;
                case 612:
                    m.get_conversation_info_list_by_top_v2_body = $root.im_proto.ConversationsPerUserByTopV2RequestBody.decode(r, r.uint32());
                    break;
                case 650:
                    m.conversation_add_participants_body = $root.im_proto.ConversationAddParticipantsRequestBody.decode(r, r.uint32());
                    break;
                case 651:
                    m.conversation_remove_participants_body = $root.im_proto.ConversationRemoveParticipantsRequestBody.decode(r, r.uint32());
                    break;
                case 652:
                    m.leave_conversation_body = $root.im_proto.ConversationLeaveRequestBody.decode(r, r.uint32());
                    break;
                case 654:
                    m.mget_conversation_participants_body = $root.im_proto.MgetConversationParticipantsRequestBody.decode(r, r.uint32());
                    break;
                case 655:
                    m.update_conversation_participant_body = $root.im_proto.UpdateConversationParticipantRequestBody.decode(r, r.uint32());
                    break;
                case 701:
                    m.delete_message_body = $root.im_proto.DeleteMessageRequestBody.decode(r, r.uint32());
                    break;
                case 702:
                    m.recall_message_body = $root.im_proto.RecallMessageRequestBody.decode(r, r.uint32());
                    break;
                case 705:
                    m.modify_message_property_body = $root.im_proto.ModifyMessagePropertyRequestBody.decode(r, r.uint32());
                    break;
                case 2059:
                    m.audio_recognition_body = $root.im_proto.AudioRecognitionRequestBody.decode(r, r.uint32());
                    break;
                case 901:
                    m.get_conversation_core_info_body = $root.im_proto.GetConversationCoreInfoRequestBody.decode(r, r.uint32());
                    break;
                case 902:
                    m.set_conversation_core_info_body = $root.im_proto.SetConversationCoreInfoRequestBody.decode(r, r.uint32());
                    break;
                case 904:
                    m.upsert_conversation_core_ext_info_body = $root.im_proto.UpsertConversationCoreExtInfoRequestBody.decode(r, r.uint32());
                    break;
                case 921:
                    m.set_conversation_setting_info_body = $root.im_proto.SetConversationSettingInfoRequestBody.decode(r, r.uint32());
                    break;
                case 922:
                    m.upsert_conversation_setting_ext_info_body = $root.im_proto.UpsertConversationSettingExtInfoRequestBody.decode(r, r.uint32());
                    break;
                case 1000:
                    m.get_stranger_conversation_body = $root.im_proto.GetStrangerConversationListRequestBody.decode(r, r.uint32());
                    break;
                case 1001:
                    m.get_stranger_messages_body = $root.im_proto.GetStrangerMessagesRequestBody.decode(r, r.uint32());
                    break;
                case 1002:
                    m.delete_stranger_message_body = $root.im_proto.DeleteStrangerMessageRequestBody.decode(r, r.uint32());
                    break;
                case 1003:
                    m.delete_stranger_conversation_body = $root.im_proto.DeleteStrangerConversationRequestBody.decode(r, r.uint32());
                    break;
                case 1004:
                    m.delete_stranger_all_conversation_body = $root.im_proto.DeleteStrangerAllConversationRequestBody.decode(r, r.uint32());
                    break;
                case 1005:
                    m.mark_stranger_conversation_read_body = $root.im_proto.MarkStrangerConversationReadRequestBody.decode(r, r.uint32());
                    break;
                case 1006:
                    m.mark_stranger_all_conversation_read_body = $root.im_proto.MarkStrangerAllConversationReadRequestBody.decode(r, r.uint32());
                    break;
                case 2000:
                    m.participants_read_index_body = $root.im_proto.GetConversationParticipantsReadIndexV3RequestBody.decode(r, r.uint32());
                    break;
                case 2001:
                    m.participants_min_index_body = $root.im_proto.GetConversationParticipantsMinIndexV3RequestBody.decode(r, r.uint32());
                    break;
                case 2003:
                    m.get_upload_token_body = $root.im_proto.GetUploadTokenRequestBody.decode(r, r.uint32());
                    break;
                case 2004:
                    m.get_media_urls_body = $root.im_proto.GetMediaUrlsRequestBody.decode(r, r.uint32());
                    break;
                case 2005:
                    m.get_ticket_body = $root.im_proto.GetTicketRequestBody.decode(r, r.uint32());
                    break;
                case 2006:
                    m.get_conversation_list_body = $root.im_proto.GetUserConversationListRequestBody.decode(r, r.uint32());
                    break;
                case 2007:
                    m.broadcast_send_message_body = $root.im_proto.BroadcastSendMessageRequestBody.decode(r, r.uint32());
                    break;
                case 2008:
                    m.broadcast_recv_message_body = $root.im_proto.BroadcastRecvMessageRequestBody.decode(r, r.uint32());
                    break;
                case 2009:
                    m.broadcast_user_counter_body = $root.im_proto.BroadcastUserCounterRequestBody.decode(r, r.uint32());
                    break;
                case 2010:
                    m.client_ack_body = $root.im_proto.ClientACKRequestBody.decode(r, r.uint32());
                    break;
                case 2011:
                    m.create_voip_body = $root.im_proto.CreateVoipRequestBody.decode(r, r.uint32());
                    break;
                case 2012:
                    m.call_voip_body = $root.im_proto.CallVoipRequestBody.decode(r, r.uint32());
                    break;
                case 2013:
                    m.update_voip_body = $root.im_proto.UpdateVoipRequestBody.decode(r, r.uint32());
                    break;
                case 2014:
                    m.channel_heartbeat_body = $root.im_proto.ChannelHeartBeatRequestBody.decode(r, r.uint32());
                    break;
                case 2015:
                    m.profile_get_info = $root.im_proto.ProfileGetInfoRequestBody.decode(r, r.uint32());
                    break;
                case 2016:
                    m.report_client_metrics_body = $root.im_proto.ReportClientMetricsRequestBody.decode(r, r.uint32());
                    break;
                case 2017:
                    m.get_configs_body = $root.im_proto.GetConfigsRequestBody.decode(r, r.uint32());
                    break;
                case 2021:
                    m.modify_message_ext_body = $root.im_proto.ModifyMessageExtRequestBody.decode(r, r.uint32());
                    break;
                case 2018:
                    m.unread_count_report_body = $root.im_proto.UnReadCountReportRequestBody.decode(r, r.uint32());
                    break;
                case 2019:
                    m.block_members_body = $root.im_proto.BlockMembersRequestBody.decode(r, r.uint32());
                    break;
                case 2020:
                    m.block_conversation_body = $root.im_proto.BlockConversationRequestBody.decode(r, r.uint32());
                    break;
                case 2030:
                    m.get_unread_count_body = $root.im_proto.GetUnreadCountRequestBody.decode(r, r.uint32());
                    break;
                case 2031:
                    m.send_message_p2p_body = $root.im_proto.SendMessageP2PRequestBody.decode(r, r.uint32());
                    break;
                case 2032:
                    m.get_blocklist_body = $root.im_proto.GetBlockListRequestBody.decode(r, r.uint32());
                    break;
                case 2033:
                    m.set_blocklist_body = $root.im_proto.SetBlocklistRequestBody.decode(r, r.uint32());
                    break;
                case 2034:
                    m.check_in_blocklist_body = $root.im_proto.CheckInBlockListRequestBody.decode(r, r.uint32());
                    break;
                case 2036:
                    m.mark_message_body = $root.im_proto.MarkMessageRequestBody.decode(r, r.uint32());
                    break;
                case 2037:
                    m.pull_mark_message_body = $root.im_proto.PullMarkMessageRequestBody.decode(r, r.uint32());
                    break;
                case 2038:
                    m.batch_get_conversation_participants_readindex = $root.im_proto.BatchGetConversationParticipantsReadIndexRequestBody.decode(r, r.uint32());
                    break;
                case 2043:
                    m.message_by_init = $root.im_proto.MessageByInitRequestBody.decode(r, r.uint32());
                    break;
                case 2054:
                    m.mark_msg_unread_count_report = $root.im_proto.MarkMsgUnreadCountReportRequestBody.decode(r, r.uint32());
                    break;
                case 2055:
                    m.mark_msg_get_unread_count = $root.im_proto.MarkMsgGetUnreadCountRequestBody.decode(r, r.uint32());
                    break;
                case 2056:
                    m.batch_unmark_message = $root.im_proto.BatchUnmarkMessageRequestBody.decode(r, r.uint32());
                    break;
                case 2057:
                    m.client_batch_ack_body = $root.im_proto.ClientBatchACKRequestBody.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return RequestBody;
    })();

    im_proto.Request = (function() {

        function Request(p) {
            this.headers = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Request.prototype.cmd = 0;
        Request.prototype.sequence_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        Request.prototype.sdk_version = "";
        Request.prototype.token = "";
        Request.prototype.refer = 1;
        Request.prototype.inbox_type = 0;
        Request.prototype.build_number = "";
        Request.prototype.body = null;
        Request.prototype.device_id = "";
        Request.prototype.channel = "";
        Request.prototype.device_platform = "";
        Request.prototype.device_type = "";
        Request.prototype.os_version = "";
        Request.prototype.version_code = "";
        Request.prototype.headers = $util.emptyObject;
        Request.prototype.config_id = 0;
        Request.prototype.token_info = null;
        Request.prototype.auth_type = 0;
        Request.prototype.biz = "";
        Request.prototype.access = "";
        Request.prototype.ts_sign = "";
        Request.prototype.sdk_cert = "";
        Request.prototype.reuqest_sign = "";

        Request.create = function create(properties) {
            return new Request(properties);
        };

        Request.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.cmd != null && Object.hasOwnProperty.call(m, "cmd"))
                w.uint32(8).int32(m.cmd);
            if (m.sequence_id != null && Object.hasOwnProperty.call(m, "sequence_id"))
                w.uint32(16).int64(m.sequence_id);
            if (m.sdk_version != null && Object.hasOwnProperty.call(m, "sdk_version"))
                w.uint32(26).string(m.sdk_version);
            if (m.token != null && Object.hasOwnProperty.call(m, "token"))
                w.uint32(34).string(m.token);
            if (m.refer != null && Object.hasOwnProperty.call(m, "refer"))
                w.uint32(40).int32(m.refer);
            if (m.inbox_type != null && Object.hasOwnProperty.call(m, "inbox_type"))
                w.uint32(48).int32(m.inbox_type);
            if (m.build_number != null && Object.hasOwnProperty.call(m, "build_number"))
                w.uint32(58).string(m.build_number);
            if (m.body != null && Object.hasOwnProperty.call(m, "body"))
                $root.im_proto.RequestBody.encode(m.body, w.uint32(66).fork()).ldelim();
            if (m.device_id != null && Object.hasOwnProperty.call(m, "device_id"))
                w.uint32(74).string(m.device_id);
            if (m.channel != null && Object.hasOwnProperty.call(m, "channel"))
                w.uint32(82).string(m.channel);
            if (m.device_platform != null && Object.hasOwnProperty.call(m, "device_platform"))
                w.uint32(90).string(m.device_platform);
            if (m.device_type != null && Object.hasOwnProperty.call(m, "device_type"))
                w.uint32(98).string(m.device_type);
            if (m.os_version != null && Object.hasOwnProperty.call(m, "os_version"))
                w.uint32(106).string(m.os_version);
            if (m.version_code != null && Object.hasOwnProperty.call(m, "version_code"))
                w.uint32(114).string(m.version_code);
            if (m.headers != null && Object.hasOwnProperty.call(m, "headers")) {
                for (var ks = Object.keys(m.headers), i = 0; i < ks.length; ++i) {
                    w.uint32(122).fork().uint32(10).string(ks[i]).uint32(18).string(m.headers[ks[i]]).ldelim();
                }
            }
            if (m.config_id != null && Object.hasOwnProperty.call(m, "config_id"))
                w.uint32(128).int32(m.config_id);
            if (m.token_info != null && Object.hasOwnProperty.call(m, "token_info"))
                $root.im_proto.TokenInfo.encode(m.token_info, w.uint32(138).fork()).ldelim();
            if (m.auth_type != null && Object.hasOwnProperty.call(m, "auth_type"))
                w.uint32(144).int32(m.auth_type);
            if (m.biz != null && Object.hasOwnProperty.call(m, "biz"))
                w.uint32(170).string(m.biz);
            if (m.access != null && Object.hasOwnProperty.call(m, "access"))
                w.uint32(178).string(m.access);
            if (m.ts_sign != null && Object.hasOwnProperty.call(m, "ts_sign"))
                w.uint32(186).string(m.ts_sign);
            if (m.sdk_cert != null && Object.hasOwnProperty.call(m, "sdk_cert"))
                w.uint32(194).string(m.sdk_cert);
            if (m.reuqest_sign != null && Object.hasOwnProperty.call(m, "reuqest_sign"))
                w.uint32(202).string(m.reuqest_sign);
            return w;
        };

        Request.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.Request(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.cmd = r.int32();
                    break;
                case 2:
                    m.sequence_id = r.int64();
                    break;
                case 3:
                    m.sdk_version = r.string();
                    break;
                case 4:
                    m.token = r.string();
                    break;
                case 5:
                    m.refer = r.int32();
                    break;
                case 6:
                    m.inbox_type = r.int32();
                    break;
                case 7:
                    m.build_number = r.string();
                    break;
                case 8:
                    m.body = $root.im_proto.RequestBody.decode(r, r.uint32());
                    break;
                case 9:
                    m.device_id = r.string();
                    break;
                case 10:
                    m.channel = r.string();
                    break;
                case 11:
                    m.device_platform = r.string();
                    break;
                case 12:
                    m.device_type = r.string();
                    break;
                case 13:
                    m.os_version = r.string();
                    break;
                case 14:
                    m.version_code = r.string();
                    break;
                case 15:
                    if (m.headers === $util.emptyObject)
                        m.headers = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.headers[k] = value;
                    break;
                case 16:
                    m.config_id = r.int32();
                    break;
                case 17:
                    m.token_info = $root.im_proto.TokenInfo.decode(r, r.uint32());
                    break;
                case 18:
                    m.auth_type = r.int32();
                    break;
                case 21:
                    m.biz = r.string();
                    break;
                case 22:
                    m.access = r.string();
                    break;
                case 23:
                    m.ts_sign = r.string();
                    break;
                case 24:
                    m.sdk_cert = r.string();
                    break;
                case 25:
                    m.reuqest_sign = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Request;
    })();

    im_proto.AuthType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_AUTH"] = 0;
        values[valuesById[1] = "SESSION_AUTH"] = 1;
        values[valuesById[2] = "TOKEN_AUTH"] = 2;
        values[valuesById[3] = "CERT_AUTH"] = 3;
        return values;
    })();

    im_proto.TokenType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DEFAULT_TOKEN"] = 0;
        values[valuesById[1] = "APP_TOKEN"] = 1;
        values[valuesById[2] = "SERVER_TOKEN"] = 2;
        return values;
    })();

    im_proto.TokenInfo = (function() {

        function TokenInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        TokenInfo.prototype.mark_id = 0;
        TokenInfo.prototype.type = 0;
        TokenInfo.prototype.app_id = 0;
        TokenInfo.prototype.user_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        TokenInfo.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        TokenInfo.create = function create(properties) {
            return new TokenInfo(properties);
        };

        TokenInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.mark_id != null && Object.hasOwnProperty.call(m, "mark_id"))
                w.uint32(8).int32(m.mark_id);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(16).int32(m.type);
            if (m.app_id != null && Object.hasOwnProperty.call(m, "app_id"))
                w.uint32(24).int32(m.app_id);
            if (m.user_id != null && Object.hasOwnProperty.call(m, "user_id"))
                w.uint32(32).int64(m.user_id);
            if (m.timestamp != null && Object.hasOwnProperty.call(m, "timestamp"))
                w.uint32(40).int64(m.timestamp);
            return w;
        };

        TokenInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.TokenInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.mark_id = r.int32();
                    break;
                case 2:
                    m.type = r.int32();
                    break;
                case 3:
                    m.app_id = r.int32();
                    break;
                case 4:
                    m.user_id = r.int64();
                    break;
                case 5:
                    m.timestamp = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return TokenInfo;
    })();

    im_proto.SendType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "BY_CONVERSATION"] = 0;
        values[valuesById[1] = "BY_USER"] = 1;
        return values;
    })();

    im_proto.NewP2PMessageNotify = (function() {

        function NewP2PMessageNotify(p) {
            this.ext = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        NewP2PMessageNotify.prototype.send_type = 0;
        NewP2PMessageNotify.prototype.sender = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        NewP2PMessageNotify.prototype.sec_sender = "";
        NewP2PMessageNotify.prototype.conversation_id = "";
        NewP2PMessageNotify.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        NewP2PMessageNotify.prototype.conversation_type = 0;
        NewP2PMessageNotify.prototype.message_type = 0;
        NewP2PMessageNotify.prototype.content = "";
        NewP2PMessageNotify.prototype.ext = $util.emptyObject;
        NewP2PMessageNotify.prototype.create_time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        NewP2PMessageNotify.create = function create(properties) {
            return new NewP2PMessageNotify(properties);
        };

        NewP2PMessageNotify.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.send_type != null && Object.hasOwnProperty.call(m, "send_type"))
                w.uint32(8).int32(m.send_type);
            if (m.sender != null && Object.hasOwnProperty.call(m, "sender"))
                w.uint32(16).int64(m.sender);
            if (m.sec_sender != null && Object.hasOwnProperty.call(m, "sec_sender"))
                w.uint32(26).string(m.sec_sender);
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(34).string(m.conversation_id);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(40).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(48).int32(m.conversation_type);
            if (m.message_type != null && Object.hasOwnProperty.call(m, "message_type"))
                w.uint32(56).int32(m.message_type);
            if (m.content != null && Object.hasOwnProperty.call(m, "content"))
                w.uint32(66).string(m.content);
            if (m.ext != null && Object.hasOwnProperty.call(m, "ext")) {
                for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
                    w.uint32(74).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
                }
            }
            if (m.create_time != null && Object.hasOwnProperty.call(m, "create_time"))
                w.uint32(80).int64(m.create_time);
            return w;
        };

        NewP2PMessageNotify.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.NewP2PMessageNotify(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.send_type = r.int32();
                    break;
                case 2:
                    m.sender = r.int64();
                    break;
                case 3:
                    m.sec_sender = r.string();
                    break;
                case 4:
                    m.conversation_id = r.string();
                    break;
                case 5:
                    m.conversation_short_id = r.int64();
                    break;
                case 6:
                    m.conversation_type = r.int32();
                    break;
                case 7:
                    m.message_type = r.int32();
                    break;
                case 8:
                    m.content = r.string();
                    break;
                case 9:
                    if (m.ext === $util.emptyObject)
                        m.ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.ext[k] = value;
                    break;
                case 10:
                    m.create_time = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return NewP2PMessageNotify;
    })();

    im_proto.MessageInfo = (function() {

        function MessageInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MessageInfo.prototype.status = 0;
        MessageInfo.prototype.body = null;

        MessageInfo.create = function create(properties) {
            return new MessageInfo(properties);
        };

        MessageInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(8).int32(m.status);
            if (m.body != null && Object.hasOwnProperty.call(m, "body"))
                $root.im_proto.MessageBody.encode(m.body, w.uint32(18).fork()).ldelim();
            return w;
        };

        MessageInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MessageInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.status = r.int32();
                    break;
                case 2:
                    m.body = $root.im_proto.MessageBody.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MessageInfo;
    })();

    im_proto.GetMessageByIdRequestBody = (function() {

        function GetMessageByIdRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetMessageByIdRequestBody.prototype.conversation_id = "";
        GetMessageByIdRequestBody.prototype.conversation_type = 0;
        GetMessageByIdRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetMessageByIdRequestBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        GetMessageByIdRequestBody.create = function create(properties) {
            return new GetMessageByIdRequestBody(properties);
        };

        GetMessageByIdRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(24).int64(m.conversation_short_id);
            if (m.server_message_id != null && Object.hasOwnProperty.call(m, "server_message_id"))
                w.uint32(32).int64(m.server_message_id);
            return w;
        };

        GetMessageByIdRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetMessageByIdRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.conversation_short_id = r.int64();
                    break;
                case 4:
                    m.server_message_id = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetMessageByIdRequestBody;
    })();

    im_proto.GetMessageByIdResponseBody = (function() {

        function GetMessageByIdResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetMessageByIdResponseBody.prototype.msg_info = null;

        GetMessageByIdResponseBody.create = function create(properties) {
            return new GetMessageByIdResponseBody(properties);
        };

        GetMessageByIdResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msg_info != null && Object.hasOwnProperty.call(m, "msg_info"))
                $root.im_proto.MessageInfo.encode(m.msg_info, w.uint32(10).fork()).ldelim();
            return w;
        };

        GetMessageByIdResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetMessageByIdResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msg_info = $root.im_proto.MessageInfo.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetMessageByIdResponseBody;
    })();

    im_proto.ResponseBody = (function() {

        function ResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ResponseBody.prototype.send_message_body = null;
        ResponseBody.prototype.messages_per_user_body = null;
        ResponseBody.prototype.messages_per_user_init_v2_body = null;
        ResponseBody.prototype.get_message_by_id_body = null;
        ResponseBody.prototype.messages_in_conversation_body = null;
        ResponseBody.prototype.get_messages_checkinfo_in_conversation_body = null;
        ResponseBody.prototype.has_new_message_notify = null;
        ResponseBody.prototype.has_new_p2p_message_notify = null;
        ResponseBody.prototype.get_conversations_checkinfo_body = null;
        ResponseBody.prototype.create_conversation_v2_body = null;
        ResponseBody.prototype.get_conversation_info_list_v2_body = null;
        ResponseBody.prototype.get_conversation_info_list_by_favorite_v2_body = null;
        ResponseBody.prototype.get_conversation_info_list_by_top_v2_body = null;
        ResponseBody.prototype.conversation_participants_body = null;
        ResponseBody.prototype.conversation_add_participants_body = null;
        ResponseBody.prototype.conversation_remove_participants_body = null;
        ResponseBody.prototype.mget_conversation_participants_body = null;
        ResponseBody.prototype.update_conversation_participant_body = null;
        ResponseBody.prototype.modify_message_property_body = null;
        ResponseBody.prototype.audio_recognition_body = null;
        ResponseBody.prototype.get_conversation_core_info_body = null;
        ResponseBody.prototype.set_conversation_core_info_body = null;
        ResponseBody.prototype.upsert_conversation_core_ext_info_body = null;
        ResponseBody.prototype.set_conversation_setting_info_body = null;
        ResponseBody.prototype.upsert_conversation_setting_ext_info_body = null;
        ResponseBody.prototype.get_stranger_conversation_body = null;
        ResponseBody.prototype.get_stranger_messages_body = null;
        ResponseBody.prototype.participants_read_index_body = null;
        ResponseBody.prototype.participants_min_index_body = null;
        ResponseBody.prototype.get_upload_token_body = null;
        ResponseBody.prototype.get_media_urls_body = null;
        ResponseBody.prototype.batch_get_conversation_participants_readindex = null;
        ResponseBody.prototype.get_ticket_body = null;
        ResponseBody.prototype.get_conversation_list_body = null;
        ResponseBody.prototype.broadcast_send_message_body = null;
        ResponseBody.prototype.broadcast_recv_message_body = null;
        ResponseBody.prototype.broadcast_user_counter_body = null;
        ResponseBody.prototype.create_voip_body = null;
        ResponseBody.prototype.call_voip_body = null;
        ResponseBody.prototype.update_voip_body = null;
        ResponseBody.prototype.profile_get_info = null;
        ResponseBody.prototype.get_configs_body = null;
        ResponseBody.prototype.unread_count_report_body = null;
        ResponseBody.prototype.block_members_body = null;
        ResponseBody.prototype.get_unread_count_body = null;
        ResponseBody.prototype.send_message_p2p_body = null;
        ResponseBody.prototype.get_blocklist_body = null;
        ResponseBody.prototype.set_blocklist_body = null;
        ResponseBody.prototype.check_in_blocklist_body = null;
        ResponseBody.prototype.mark_message_body = null;
        ResponseBody.prototype.pull_mark_message_body = null;
        ResponseBody.prototype.message_by_init = null;
        ResponseBody.prototype.mark_msg_unread_count_report = null;
        ResponseBody.prototype.mark_msg_get_unread_count = null;
        ResponseBody.prototype.batch_unmark_message = null;

        ResponseBody.create = function create(properties) {
            return new ResponseBody(properties);
        };

        ResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.send_message_body != null && Object.hasOwnProperty.call(m, "send_message_body"))
                $root.im_proto.SendMessageResponseBody.encode(m.send_message_body, w.uint32(802).fork()).ldelim();
            if (m.messages_per_user_body != null && Object.hasOwnProperty.call(m, "messages_per_user_body"))
                $root.im_proto.MessagesPerUserResponseBody.encode(m.messages_per_user_body, w.uint32(1602).fork()).ldelim();
            if (m.messages_per_user_init_v2_body != null && Object.hasOwnProperty.call(m, "messages_per_user_init_v2_body"))
                $root.im_proto.MessagesPerUserInitV2ResponseBody.encode(m.messages_per_user_init_v2_body, w.uint32(1626).fork()).ldelim();
            if (m.get_message_by_id_body != null && Object.hasOwnProperty.call(m, "get_message_by_id_body"))
                $root.im_proto.GetMessageByIdResponseBody.encode(m.get_message_by_id_body, w.uint32(1690).fork()).ldelim();
            if (m.messages_in_conversation_body != null && Object.hasOwnProperty.call(m, "messages_in_conversation_body"))
                $root.im_proto.MessagesInConversationResponseBody.encode(m.messages_in_conversation_body, w.uint32(2410).fork()).ldelim();
            if (m.get_messages_checkinfo_in_conversation_body != null && Object.hasOwnProperty.call(m, "get_messages_checkinfo_in_conversation_body"))
                $root.im_proto.GetMessagesCheckInfoInConversationResponseBody.encode(m.get_messages_checkinfo_in_conversation_body, w.uint32(2418).fork()).ldelim();
            if (m.has_new_message_notify != null && Object.hasOwnProperty.call(m, "has_new_message_notify"))
                $root.im_proto.NewMessageNotify.encode(m.has_new_message_notify, w.uint32(4002).fork()).ldelim();
            if (m.has_new_p2p_message_notify != null && Object.hasOwnProperty.call(m, "has_new_p2p_message_notify"))
                $root.im_proto.NewP2PMessageNotify.encode(m.has_new_p2p_message_notify, w.uint32(4034).fork()).ldelim();
            if (m.conversation_participants_body != null && Object.hasOwnProperty.call(m, "conversation_participants_body"))
                $root.im_proto.ConversationParticipantsListResponseBody.encode(m.conversation_participants_body, w.uint32(4842).fork()).ldelim();
            if (m.create_conversation_v2_body != null && Object.hasOwnProperty.call(m, "create_conversation_v2_body"))
                $root.im_proto.CreateConversationV2ResponseBody.encode(m.create_conversation_v2_body, w.uint32(4874).fork()).ldelim();
            if (m.get_conversation_info_list_v2_body != null && Object.hasOwnProperty.call(m, "get_conversation_info_list_v2_body"))
                $root.im_proto.GetConversationInfoListV2ResponseBody.encode(m.get_conversation_info_list_v2_body, w.uint32(4882).fork()).ldelim();
            if (m.get_conversation_info_list_by_favorite_v2_body != null && Object.hasOwnProperty.call(m, "get_conversation_info_list_by_favorite_v2_body"))
                $root.im_proto.GetConversationInfoListByFavoriteV2ResponseBody.encode(m.get_conversation_info_list_by_favorite_v2_body, w.uint32(4890).fork()).ldelim();
            if (m.get_conversation_info_list_by_top_v2_body != null && Object.hasOwnProperty.call(m, "get_conversation_info_list_by_top_v2_body"))
                $root.im_proto.GetConversationInfoListByTopV2ResponseBody.encode(m.get_conversation_info_list_by_top_v2_body, w.uint32(4898).fork()).ldelim();
            if (m.get_conversations_checkinfo_body != null && Object.hasOwnProperty.call(m, "get_conversations_checkinfo_body"))
                $root.im_proto.GetConversationsCheckInfoResponseBody.encode(m.get_conversations_checkinfo_body, w.uint32(4922).fork()).ldelim();
            if (m.conversation_add_participants_body != null && Object.hasOwnProperty.call(m, "conversation_add_participants_body"))
                $root.im_proto.ConversationAddParticipantsResponseBody.encode(m.conversation_add_participants_body, w.uint32(5202).fork()).ldelim();
            if (m.conversation_remove_participants_body != null && Object.hasOwnProperty.call(m, "conversation_remove_participants_body"))
                $root.im_proto.ConversationRemoveParticipantsResponseBody.encode(m.conversation_remove_participants_body, w.uint32(5210).fork()).ldelim();
            if (m.mget_conversation_participants_body != null && Object.hasOwnProperty.call(m, "mget_conversation_participants_body"))
                $root.im_proto.MgetConversationParticipantsResponseBody.encode(m.mget_conversation_participants_body, w.uint32(5234).fork()).ldelim();
            if (m.update_conversation_participant_body != null && Object.hasOwnProperty.call(m, "update_conversation_participant_body"))
                $root.im_proto.UpdateConversationParticipantResponseBody.encode(m.update_conversation_participant_body, w.uint32(5242).fork()).ldelim();
            if (m.modify_message_property_body != null && Object.hasOwnProperty.call(m, "modify_message_property_body"))
                $root.im_proto.ModifyMessagePropertyResponseBody.encode(m.modify_message_property_body, w.uint32(5642).fork()).ldelim();
            if (m.get_conversation_core_info_body != null && Object.hasOwnProperty.call(m, "get_conversation_core_info_body"))
                $root.im_proto.GetConversationCoreInfoResponseBody.encode(m.get_conversation_core_info_body, w.uint32(7210).fork()).ldelim();
            if (m.set_conversation_core_info_body != null && Object.hasOwnProperty.call(m, "set_conversation_core_info_body"))
                $root.im_proto.SetConversationCoreInfoResponseBody.encode(m.set_conversation_core_info_body, w.uint32(7218).fork()).ldelim();
            if (m.upsert_conversation_core_ext_info_body != null && Object.hasOwnProperty.call(m, "upsert_conversation_core_ext_info_body"))
                $root.im_proto.UpsertConversationCoreExtInfoResponseBody.encode(m.upsert_conversation_core_ext_info_body, w.uint32(7234).fork()).ldelim();
            if (m.set_conversation_setting_info_body != null && Object.hasOwnProperty.call(m, "set_conversation_setting_info_body"))
                $root.im_proto.SetConversationSettingInfoResponseBody.encode(m.set_conversation_setting_info_body, w.uint32(7370).fork()).ldelim();
            if (m.upsert_conversation_setting_ext_info_body != null && Object.hasOwnProperty.call(m, "upsert_conversation_setting_ext_info_body"))
                $root.im_proto.UpsertConversationSettingExtInfoResponseBody.encode(m.upsert_conversation_setting_ext_info_body, w.uint32(7378).fork()).ldelim();
            if (m.get_stranger_conversation_body != null && Object.hasOwnProperty.call(m, "get_stranger_conversation_body"))
                $root.im_proto.GetStrangerConversationListResponseBody.encode(m.get_stranger_conversation_body, w.uint32(8002).fork()).ldelim();
            if (m.get_stranger_messages_body != null && Object.hasOwnProperty.call(m, "get_stranger_messages_body"))
                $root.im_proto.GetStrangerMessagesResponseBody.encode(m.get_stranger_messages_body, w.uint32(8010).fork()).ldelim();
            if (m.participants_read_index_body != null && Object.hasOwnProperty.call(m, "participants_read_index_body"))
                $root.im_proto.GetConversationParticipantsReadIndexV3ResponseBody.encode(m.participants_read_index_body, w.uint32(16002).fork()).ldelim();
            if (m.participants_min_index_body != null && Object.hasOwnProperty.call(m, "participants_min_index_body"))
                $root.im_proto.GetConversationParticipantsMinIndexV3ResponseBody.encode(m.participants_min_index_body, w.uint32(16010).fork()).ldelim();
            if (m.get_upload_token_body != null && Object.hasOwnProperty.call(m, "get_upload_token_body"))
                $root.im_proto.GetUploadTokenResponseBody.encode(m.get_upload_token_body, w.uint32(16026).fork()).ldelim();
            if (m.get_media_urls_body != null && Object.hasOwnProperty.call(m, "get_media_urls_body"))
                $root.im_proto.GetMediaUrlsResponseBody.encode(m.get_media_urls_body, w.uint32(16034).fork()).ldelim();
            if (m.get_ticket_body != null && Object.hasOwnProperty.call(m, "get_ticket_body"))
                $root.im_proto.GetTicketResponseBody.encode(m.get_ticket_body, w.uint32(16042).fork()).ldelim();
            if (m.get_conversation_list_body != null && Object.hasOwnProperty.call(m, "get_conversation_list_body"))
                $root.im_proto.GetUserConversationListResponseBody.encode(m.get_conversation_list_body, w.uint32(16050).fork()).ldelim();
            if (m.broadcast_send_message_body != null && Object.hasOwnProperty.call(m, "broadcast_send_message_body"))
                $root.im_proto.BroadcastSendMessageResponseBody.encode(m.broadcast_send_message_body, w.uint32(16058).fork()).ldelim();
            if (m.broadcast_recv_message_body != null && Object.hasOwnProperty.call(m, "broadcast_recv_message_body"))
                $root.im_proto.BroadcastRecvMessageResponseBody.encode(m.broadcast_recv_message_body, w.uint32(16066).fork()).ldelim();
            if (m.broadcast_user_counter_body != null && Object.hasOwnProperty.call(m, "broadcast_user_counter_body"))
                $root.im_proto.BroadcastUserCounterResponseBody.encode(m.broadcast_user_counter_body, w.uint32(16074).fork()).ldelim();
            if (m.create_voip_body != null && Object.hasOwnProperty.call(m, "create_voip_body"))
                $root.im_proto.CreateVoipResponseBody.encode(m.create_voip_body, w.uint32(16090).fork()).ldelim();
            if (m.call_voip_body != null && Object.hasOwnProperty.call(m, "call_voip_body"))
                $root.im_proto.CallVoipResponseBody.encode(m.call_voip_body, w.uint32(16098).fork()).ldelim();
            if (m.update_voip_body != null && Object.hasOwnProperty.call(m, "update_voip_body"))
                $root.im_proto.UpdateVoipResponseBody.encode(m.update_voip_body, w.uint32(16106).fork()).ldelim();
            if (m.profile_get_info != null && Object.hasOwnProperty.call(m, "profile_get_info"))
                $root.im_proto.ProfileGetInfoResponseBody.encode(m.profile_get_info, w.uint32(16122).fork()).ldelim();
            if (m.get_configs_body != null && Object.hasOwnProperty.call(m, "get_configs_body"))
                $root.im_proto.GetConfigsResponseBody.encode(m.get_configs_body, w.uint32(16138).fork()).ldelim();
            if (m.unread_count_report_body != null && Object.hasOwnProperty.call(m, "unread_count_report_body"))
                $root.im_proto.UnReadCountReportResponseBody.encode(m.unread_count_report_body, w.uint32(16146).fork()).ldelim();
            if (m.block_members_body != null && Object.hasOwnProperty.call(m, "block_members_body"))
                $root.im_proto.BlockMembersResponseBody.encode(m.block_members_body, w.uint32(16154).fork()).ldelim();
            if (m.get_unread_count_body != null && Object.hasOwnProperty.call(m, "get_unread_count_body"))
                $root.im_proto.GetUnreadCountResponseBody.encode(m.get_unread_count_body, w.uint32(16242).fork()).ldelim();
            if (m.send_message_p2p_body != null && Object.hasOwnProperty.call(m, "send_message_p2p_body"))
                $root.im_proto.SendMessageP2PResponseBody.encode(m.send_message_p2p_body, w.uint32(16250).fork()).ldelim();
            if (m.get_blocklist_body != null && Object.hasOwnProperty.call(m, "get_blocklist_body"))
                $root.im_proto.GetBlockListResponseBody.encode(m.get_blocklist_body, w.uint32(16258).fork()).ldelim();
            if (m.set_blocklist_body != null && Object.hasOwnProperty.call(m, "set_blocklist_body"))
                $root.im_proto.SetBlocklistResponseBody.encode(m.set_blocklist_body, w.uint32(16266).fork()).ldelim();
            if (m.check_in_blocklist_body != null && Object.hasOwnProperty.call(m, "check_in_blocklist_body"))
                $root.im_proto.CheckInBlockListResponseBody.encode(m.check_in_blocklist_body, w.uint32(16274).fork()).ldelim();
            if (m.mark_message_body != null && Object.hasOwnProperty.call(m, "mark_message_body"))
                $root.im_proto.MarkMessageResponseBody.encode(m.mark_message_body, w.uint32(16290).fork()).ldelim();
            if (m.pull_mark_message_body != null && Object.hasOwnProperty.call(m, "pull_mark_message_body"))
                $root.im_proto.PullMarkMessageResponseBody.encode(m.pull_mark_message_body, w.uint32(16298).fork()).ldelim();
            if (m.batch_get_conversation_participants_readindex != null && Object.hasOwnProperty.call(m, "batch_get_conversation_participants_readindex"))
                $root.im_proto.BatchGetConversationParticipantsReadIndexResponseBody.encode(m.batch_get_conversation_participants_readindex, w.uint32(16306).fork()).ldelim();
            if (m.message_by_init != null && Object.hasOwnProperty.call(m, "message_by_init"))
                $root.im_proto.MessageByInitResponseBody.encode(m.message_by_init, w.uint32(16346).fork()).ldelim();
            if (m.mark_msg_unread_count_report != null && Object.hasOwnProperty.call(m, "mark_msg_unread_count_report"))
                $root.im_proto.MarkMsgUnreadCountReportResponseBody.encode(m.mark_msg_unread_count_report, w.uint32(16434).fork()).ldelim();
            if (m.mark_msg_get_unread_count != null && Object.hasOwnProperty.call(m, "mark_msg_get_unread_count"))
                $root.im_proto.MarkMsgGetUnreadCountResponseBody.encode(m.mark_msg_get_unread_count, w.uint32(16442).fork()).ldelim();
            if (m.batch_unmark_message != null && Object.hasOwnProperty.call(m, "batch_unmark_message"))
                $root.im_proto.BatchUnmarkMessageResponseBody.encode(m.batch_unmark_message, w.uint32(16450).fork()).ldelim();
            if (m.audio_recognition_body != null && Object.hasOwnProperty.call(m, "audio_recognition_body"))
                $root.im_proto.AudioRecognitionResponseBody.encode(m.audio_recognition_body, w.uint32(16474).fork()).ldelim();
            return w;
        };

        ResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.send_message_body = $root.im_proto.SendMessageResponseBody.decode(r, r.uint32());
                    break;
                case 200:
                    m.messages_per_user_body = $root.im_proto.MessagesPerUserResponseBody.decode(r, r.uint32());
                    break;
                case 203:
                    m.messages_per_user_init_v2_body = $root.im_proto.MessagesPerUserInitV2ResponseBody.decode(r, r.uint32());
                    break;
                case 211:
                    m.get_message_by_id_body = $root.im_proto.GetMessageByIdResponseBody.decode(r, r.uint32());
                    break;
                case 301:
                    m.messages_in_conversation_body = $root.im_proto.MessagesInConversationResponseBody.decode(r, r.uint32());
                    break;
                case 302:
                    m.get_messages_checkinfo_in_conversation_body = $root.im_proto.GetMessagesCheckInfoInConversationResponseBody.decode(r, r.uint32());
                    break;
                case 500:
                    m.has_new_message_notify = $root.im_proto.NewMessageNotify.decode(r, r.uint32());
                    break;
                case 504:
                    m.has_new_p2p_message_notify = $root.im_proto.NewP2PMessageNotify.decode(r, r.uint32());
                    break;
                case 615:
                    m.get_conversations_checkinfo_body = $root.im_proto.GetConversationsCheckInfoResponseBody.decode(r, r.uint32());
                    break;
                case 609:
                    m.create_conversation_v2_body = $root.im_proto.CreateConversationV2ResponseBody.decode(r, r.uint32());
                    break;
                case 610:
                    m.get_conversation_info_list_v2_body = $root.im_proto.GetConversationInfoListV2ResponseBody.decode(r, r.uint32());
                    break;
                case 611:
                    m.get_conversation_info_list_by_favorite_v2_body = $root.im_proto.GetConversationInfoListByFavoriteV2ResponseBody.decode(r, r.uint32());
                    break;
                case 612:
                    m.get_conversation_info_list_by_top_v2_body = $root.im_proto.GetConversationInfoListByTopV2ResponseBody.decode(r, r.uint32());
                    break;
                case 605:
                    m.conversation_participants_body = $root.im_proto.ConversationParticipantsListResponseBody.decode(r, r.uint32());
                    break;
                case 650:
                    m.conversation_add_participants_body = $root.im_proto.ConversationAddParticipantsResponseBody.decode(r, r.uint32());
                    break;
                case 651:
                    m.conversation_remove_participants_body = $root.im_proto.ConversationRemoveParticipantsResponseBody.decode(r, r.uint32());
                    break;
                case 654:
                    m.mget_conversation_participants_body = $root.im_proto.MgetConversationParticipantsResponseBody.decode(r, r.uint32());
                    break;
                case 655:
                    m.update_conversation_participant_body = $root.im_proto.UpdateConversationParticipantResponseBody.decode(r, r.uint32());
                    break;
                case 705:
                    m.modify_message_property_body = $root.im_proto.ModifyMessagePropertyResponseBody.decode(r, r.uint32());
                    break;
                case 2059:
                    m.audio_recognition_body = $root.im_proto.AudioRecognitionResponseBody.decode(r, r.uint32());
                    break;
                case 901:
                    m.get_conversation_core_info_body = $root.im_proto.GetConversationCoreInfoResponseBody.decode(r, r.uint32());
                    break;
                case 902:
                    m.set_conversation_core_info_body = $root.im_proto.SetConversationCoreInfoResponseBody.decode(r, r.uint32());
                    break;
                case 904:
                    m.upsert_conversation_core_ext_info_body = $root.im_proto.UpsertConversationCoreExtInfoResponseBody.decode(r, r.uint32());
                    break;
                case 921:
                    m.set_conversation_setting_info_body = $root.im_proto.SetConversationSettingInfoResponseBody.decode(r, r.uint32());
                    break;
                case 922:
                    m.upsert_conversation_setting_ext_info_body = $root.im_proto.UpsertConversationSettingExtInfoResponseBody.decode(r, r.uint32());
                    break;
                case 1000:
                    m.get_stranger_conversation_body = $root.im_proto.GetStrangerConversationListResponseBody.decode(r, r.uint32());
                    break;
                case 1001:
                    m.get_stranger_messages_body = $root.im_proto.GetStrangerMessagesResponseBody.decode(r, r.uint32());
                    break;
                case 2000:
                    m.participants_read_index_body = $root.im_proto.GetConversationParticipantsReadIndexV3ResponseBody.decode(r, r.uint32());
                    break;
                case 2001:
                    m.participants_min_index_body = $root.im_proto.GetConversationParticipantsMinIndexV3ResponseBody.decode(r, r.uint32());
                    break;
                case 2003:
                    m.get_upload_token_body = $root.im_proto.GetUploadTokenResponseBody.decode(r, r.uint32());
                    break;
                case 2004:
                    m.get_media_urls_body = $root.im_proto.GetMediaUrlsResponseBody.decode(r, r.uint32());
                    break;
                case 2038:
                    m.batch_get_conversation_participants_readindex = $root.im_proto.BatchGetConversationParticipantsReadIndexResponseBody.decode(r, r.uint32());
                    break;
                case 2005:
                    m.get_ticket_body = $root.im_proto.GetTicketResponseBody.decode(r, r.uint32());
                    break;
                case 2006:
                    m.get_conversation_list_body = $root.im_proto.GetUserConversationListResponseBody.decode(r, r.uint32());
                    break;
                case 2007:
                    m.broadcast_send_message_body = $root.im_proto.BroadcastSendMessageResponseBody.decode(r, r.uint32());
                    break;
                case 2008:
                    m.broadcast_recv_message_body = $root.im_proto.BroadcastRecvMessageResponseBody.decode(r, r.uint32());
                    break;
                case 2009:
                    m.broadcast_user_counter_body = $root.im_proto.BroadcastUserCounterResponseBody.decode(r, r.uint32());
                    break;
                case 2011:
                    m.create_voip_body = $root.im_proto.CreateVoipResponseBody.decode(r, r.uint32());
                    break;
                case 2012:
                    m.call_voip_body = $root.im_proto.CallVoipResponseBody.decode(r, r.uint32());
                    break;
                case 2013:
                    m.update_voip_body = $root.im_proto.UpdateVoipResponseBody.decode(r, r.uint32());
                    break;
                case 2015:
                    m.profile_get_info = $root.im_proto.ProfileGetInfoResponseBody.decode(r, r.uint32());
                    break;
                case 2017:
                    m.get_configs_body = $root.im_proto.GetConfigsResponseBody.decode(r, r.uint32());
                    break;
                case 2018:
                    m.unread_count_report_body = $root.im_proto.UnReadCountReportResponseBody.decode(r, r.uint32());
                    break;
                case 2019:
                    m.block_members_body = $root.im_proto.BlockMembersResponseBody.decode(r, r.uint32());
                    break;
                case 2030:
                    m.get_unread_count_body = $root.im_proto.GetUnreadCountResponseBody.decode(r, r.uint32());
                    break;
                case 2031:
                    m.send_message_p2p_body = $root.im_proto.SendMessageP2PResponseBody.decode(r, r.uint32());
                    break;
                case 2032:
                    m.get_blocklist_body = $root.im_proto.GetBlockListResponseBody.decode(r, r.uint32());
                    break;
                case 2033:
                    m.set_blocklist_body = $root.im_proto.SetBlocklistResponseBody.decode(r, r.uint32());
                    break;
                case 2034:
                    m.check_in_blocklist_body = $root.im_proto.CheckInBlockListResponseBody.decode(r, r.uint32());
                    break;
                case 2036:
                    m.mark_message_body = $root.im_proto.MarkMessageResponseBody.decode(r, r.uint32());
                    break;
                case 2037:
                    m.pull_mark_message_body = $root.im_proto.PullMarkMessageResponseBody.decode(r, r.uint32());
                    break;
                case 2043:
                    m.message_by_init = $root.im_proto.MessageByInitResponseBody.decode(r, r.uint32());
                    break;
                case 2054:
                    m.mark_msg_unread_count_report = $root.im_proto.MarkMsgUnreadCountReportResponseBody.decode(r, r.uint32());
                    break;
                case 2055:
                    m.mark_msg_get_unread_count = $root.im_proto.MarkMsgGetUnreadCountResponseBody.decode(r, r.uint32());
                    break;
                case 2056:
                    m.batch_unmark_message = $root.im_proto.BatchUnmarkMessageResponseBody.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ResponseBody;
    })();

    im_proto.Response = (function() {

        function Response(p) {
            this.headers = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Response.prototype.cmd = 0;
        Response.prototype.sequence_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        Response.prototype.status_code = 0;
        Response.prototype.error_desc = "";
        Response.prototype.inbox_type = 0;
        Response.prototype.body = null;
        Response.prototype.log_id = "";
        Response.prototype.headers = $util.emptyObject;
        Response.prototype.start_time_stamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        Response.prototype.request_arrived_time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        Response.prototype.server_execution_end_time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        Response.create = function create(properties) {
            return new Response(properties);
        };

        Response.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.cmd != null && Object.hasOwnProperty.call(m, "cmd"))
                w.uint32(8).int32(m.cmd);
            if (m.sequence_id != null && Object.hasOwnProperty.call(m, "sequence_id"))
                w.uint32(16).int64(m.sequence_id);
            if (m.status_code != null && Object.hasOwnProperty.call(m, "status_code"))
                w.uint32(24).int32(m.status_code);
            if (m.error_desc != null && Object.hasOwnProperty.call(m, "error_desc"))
                w.uint32(34).string(m.error_desc);
            if (m.inbox_type != null && Object.hasOwnProperty.call(m, "inbox_type"))
                w.uint32(40).int32(m.inbox_type);
            if (m.body != null && Object.hasOwnProperty.call(m, "body"))
                $root.im_proto.ResponseBody.encode(m.body, w.uint32(50).fork()).ldelim();
            if (m.log_id != null && Object.hasOwnProperty.call(m, "log_id"))
                w.uint32(58).string(m.log_id);
            if (m.headers != null && Object.hasOwnProperty.call(m, "headers")) {
                for (var ks = Object.keys(m.headers), i = 0; i < ks.length; ++i) {
                    w.uint32(66).fork().uint32(10).string(ks[i]).uint32(18).string(m.headers[ks[i]]).ldelim();
                }
            }
            if (m.start_time_stamp != null && Object.hasOwnProperty.call(m, "start_time_stamp"))
                w.uint32(72).int64(m.start_time_stamp);
            if (m.request_arrived_time != null && Object.hasOwnProperty.call(m, "request_arrived_time"))
                w.uint32(80).int64(m.request_arrived_time);
            if (m.server_execution_end_time != null && Object.hasOwnProperty.call(m, "server_execution_end_time"))
                w.uint32(88).int64(m.server_execution_end_time);
            return w;
        };

        Response.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.Response(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.cmd = r.int32();
                    break;
                case 2:
                    m.sequence_id = r.int64();
                    break;
                case 3:
                    m.status_code = r.int32();
                    break;
                case 4:
                    m.error_desc = r.string();
                    break;
                case 5:
                    m.inbox_type = r.int32();
                    break;
                case 6:
                    m.body = $root.im_proto.ResponseBody.decode(r, r.uint32());
                    break;
                case 7:
                    m.log_id = r.string();
                    break;
                case 8:
                    if (m.headers === $util.emptyObject)
                        m.headers = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.headers[k] = value;
                    break;
                case 9:
                    m.start_time_stamp = r.int64();
                    break;
                case 10:
                    m.request_arrived_time = r.int64();
                    break;
                case 11:
                    m.server_execution_end_time = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Response;
    })();

    im_proto.BroadcastSendMessageRequestBody = (function() {

        function BroadcastSendMessageRequestBody(p) {
            this.ext = {};
            this.mentioned_users = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BroadcastSendMessageRequestBody.prototype.conversation_id = "";
        BroadcastSendMessageRequestBody.prototype.conversation_type = 0;
        BroadcastSendMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        BroadcastSendMessageRequestBody.prototype.content = "";
        BroadcastSendMessageRequestBody.prototype.ext = $util.emptyObject;
        BroadcastSendMessageRequestBody.prototype.message_type = 0;
        BroadcastSendMessageRequestBody.prototype.ticket = "";
        BroadcastSendMessageRequestBody.prototype.client_message_id = "";
        BroadcastSendMessageRequestBody.prototype.mentioned_users = $util.emptyArray;

        BroadcastSendMessageRequestBody.create = function create(properties) {
            return new BroadcastSendMessageRequestBody(properties);
        };

        BroadcastSendMessageRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(24).int64(m.conversation_short_id);
            if (m.content != null && Object.hasOwnProperty.call(m, "content"))
                w.uint32(34).string(m.content);
            if (m.ext != null && Object.hasOwnProperty.call(m, "ext")) {
                for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
                    w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
                }
            }
            if (m.message_type != null && Object.hasOwnProperty.call(m, "message_type"))
                w.uint32(48).int32(m.message_type);
            if (m.ticket != null && Object.hasOwnProperty.call(m, "ticket"))
                w.uint32(58).string(m.ticket);
            if (m.client_message_id != null && Object.hasOwnProperty.call(m, "client_message_id"))
                w.uint32(66).string(m.client_message_id);
            if (m.mentioned_users != null && m.mentioned_users.length) {
                for (var i = 0; i < m.mentioned_users.length; ++i)
                    w.uint32(72).int64(m.mentioned_users[i]);
            }
            return w;
        };

        BroadcastSendMessageRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.BroadcastSendMessageRequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.conversation_short_id = r.int64();
                    break;
                case 4:
                    m.content = r.string();
                    break;
                case 5:
                    if (m.ext === $util.emptyObject)
                        m.ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.ext[k] = value;
                    break;
                case 6:
                    m.message_type = r.int32();
                    break;
                case 7:
                    m.ticket = r.string();
                    break;
                case 8:
                    m.client_message_id = r.string();
                    break;
                case 9:
                    if (!(m.mentioned_users && m.mentioned_users.length))
                        m.mentioned_users = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.mentioned_users.push(r.int64());
                    } else
                        m.mentioned_users.push(r.int64());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BroadcastSendMessageRequestBody;
    })();

    im_proto.BroadcastSendMessageResponseBody = (function() {

        function BroadcastSendMessageResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BroadcastSendMessageResponseBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        BroadcastSendMessageResponseBody.prototype.extra_info = "";
        BroadcastSendMessageResponseBody.prototype.status = 0;
        BroadcastSendMessageResponseBody.prototype.client_message_id = "";
        BroadcastSendMessageResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        BroadcastSendMessageResponseBody.prototype.check_message = "";

        BroadcastSendMessageResponseBody.create = function create(properties) {
            return new BroadcastSendMessageResponseBody(properties);
        };

        BroadcastSendMessageResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.server_message_id != null && Object.hasOwnProperty.call(m, "server_message_id"))
                w.uint32(8).int64(m.server_message_id);
            if (m.extra_info != null && Object.hasOwnProperty.call(m, "extra_info"))
                w.uint32(18).string(m.extra_info);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            if (m.client_message_id != null && Object.hasOwnProperty.call(m, "client_message_id"))
                w.uint32(34).string(m.client_message_id);
            if (m.check_code != null && Object.hasOwnProperty.call(m, "check_code"))
                w.uint32(40).int64(m.check_code);
            if (m.check_message != null && Object.hasOwnProperty.call(m, "check_message"))
                w.uint32(50).string(m.check_message);
            return w;
        };

        BroadcastSendMessageResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.BroadcastSendMessageResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.server_message_id = r.int64();
                    break;
                case 2:
                    m.extra_info = r.string();
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                case 4:
                    m.client_message_id = r.string();
                    break;
                case 5:
                    m.check_code = r.int64();
                    break;
                case 6:
                    m.check_message = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BroadcastSendMessageResponseBody;
    })();

    im_proto.BroadcastRecvMessageRequestBody = (function() {

        function BroadcastRecvMessageRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BroadcastRecvMessageRequestBody.prototype.conversation_id = "";
        BroadcastRecvMessageRequestBody.prototype.conversation_type = 0;
        BroadcastRecvMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        BroadcastRecvMessageRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        BroadcastRecvMessageRequestBody.prototype.limit = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        BroadcastRecvMessageRequestBody.prototype.reverse = false;
        BroadcastRecvMessageRequestBody.prototype.pull_type = 0;

        BroadcastRecvMessageRequestBody.create = function create(properties) {
            return new BroadcastRecvMessageRequestBody(properties);
        };

        BroadcastRecvMessageRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(24).int64(m.conversation_short_id);
            if (m.cursor != null && Object.hasOwnProperty.call(m, "cursor"))
                w.uint32(32).int64(m.cursor);
            if (m.limit != null && Object.hasOwnProperty.call(m, "limit"))
                w.uint32(40).int64(m.limit);
            if (m.reverse != null && Object.hasOwnProperty.call(m, "reverse"))
                w.uint32(48).bool(m.reverse);
            if (m.pull_type != null && Object.hasOwnProperty.call(m, "pull_type"))
                w.uint32(56).int32(m.pull_type);
            return w;
        };

        BroadcastRecvMessageRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.BroadcastRecvMessageRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.conversation_short_id = r.int64();
                    break;
                case 4:
                    m.cursor = r.int64();
                    break;
                case 5:
                    m.limit = r.int64();
                    break;
                case 6:
                    m.reverse = r.bool();
                    break;
                case 7:
                    m.pull_type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BroadcastRecvMessageRequestBody;
    })();

    im_proto.BroadcastRecvMessageResponseBody = (function() {

        function BroadcastRecvMessageResponseBody(p) {
            this.messages = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BroadcastRecvMessageResponseBody.prototype.messages = $util.emptyArray;
        BroadcastRecvMessageResponseBody.prototype.has_more = false;
        BroadcastRecvMessageResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        BroadcastRecvMessageResponseBody.create = function create(properties) {
            return new BroadcastRecvMessageResponseBody(properties);
        };

        BroadcastRecvMessageResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.messages != null && m.messages.length) {
                for (var i = 0; i < m.messages.length; ++i)
                    $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(10).fork()).ldelim();
            }
            if (m.has_more != null && Object.hasOwnProperty.call(m, "has_more"))
                w.uint32(16).bool(m.has_more);
            if (m.next_cursor != null && Object.hasOwnProperty.call(m, "next_cursor"))
                w.uint32(24).int64(m.next_cursor);
            return w;
        };

        BroadcastRecvMessageResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.BroadcastRecvMessageResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.messages && m.messages.length))
                        m.messages = [];
                    m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
                    break;
                case 2:
                    m.has_more = r.bool();
                    break;
                case 3:
                    m.next_cursor = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BroadcastRecvMessageResponseBody;
    })();

    im_proto.ConversationRequest = (function() {

        function ConversationRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationRequest.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationRequest.prototype.conversation_type = 0;

        ConversationRequest.create = function create(properties) {
            return new ConversationRequest(properties);
        };

        ConversationRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(8).int64(m.conversation_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            return w;
        };

        ConversationRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_short_id = r.int64();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ConversationRequest;
    })();

    im_proto.BroadcastUserCounterRequestBody = (function() {

        function BroadcastUserCounterRequestBody(p) {
            this.conversations = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BroadcastUserCounterRequestBody.prototype.conversations = $util.emptyArray;

        BroadcastUserCounterRequestBody.create = function create(properties) {
            return new BroadcastUserCounterRequestBody(properties);
        };

        BroadcastUserCounterRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversations != null && m.conversations.length) {
                for (var i = 0; i < m.conversations.length; ++i)
                    $root.im_proto.ConversationRequest.encode(m.conversations[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        BroadcastUserCounterRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.BroadcastUserCounterRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.conversations && m.conversations.length))
                        m.conversations = [];
                    m.conversations.push($root.im_proto.ConversationRequest.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BroadcastUserCounterRequestBody;
    })();

    im_proto.BroadcastUserInfo = (function() {

        function BroadcastUserInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BroadcastUserInfo.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        BroadcastUserInfo.prototype.counter = 0;
        BroadcastUserInfo.prototype.conversation_type = 0;

        BroadcastUserInfo.create = function create(properties) {
            return new BroadcastUserInfo(properties);
        };

        BroadcastUserInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(8).int64(m.conversation_short_id);
            if (m.counter != null && Object.hasOwnProperty.call(m, "counter"))
                w.uint32(16).int32(m.counter);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            return w;
        };

        BroadcastUserInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.BroadcastUserInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_short_id = r.int64();
                    break;
                case 2:
                    m.counter = r.int32();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BroadcastUserInfo;
    })();

    im_proto.BroadcastUserCounterResponseBody = (function() {

        function BroadcastUserCounterResponseBody(p) {
            this.infos = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BroadcastUserCounterResponseBody.prototype.infos = $util.emptyArray;

        BroadcastUserCounterResponseBody.create = function create(properties) {
            return new BroadcastUserCounterResponseBody(properties);
        };

        BroadcastUserCounterResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.infos != null && m.infos.length) {
                for (var i = 0; i < m.infos.length; ++i)
                    $root.im_proto.BroadcastUserInfo.encode(m.infos[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        BroadcastUserCounterResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.BroadcastUserCounterResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.infos && m.infos.length))
                        m.infos = [];
                    m.infos.push($root.im_proto.BroadcastUserInfo.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BroadcastUserCounterResponseBody;
    })();

    im_proto.NetworkType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "WIFI"] = 1;
        values[valuesById[2] = "MOBILE_2G"] = 2;
        values[valuesById[3] = "MOBILE_3G"] = 3;
        values[valuesById[4] = "MOBILE_4G"] = 4;
        values[valuesById[5] = "MOBILE_5G"] = 5;
        return values;
    })();

    im_proto.MsgReportType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NOT_USE"] = 0;
        values[valuesById[1] = "MSG_RECEIVE_BY_WS"] = 1;
        values[valuesById[2] = "MSG_RECEIVE_BY_USER"] = 2;
        values[valuesById[3] = "MSG_RECEIVE_BY_INIT"] = 3;
        values[valuesById[4] = "MSG_RECEIVE_BY_LOAD_HISTORY"] = 4;
        values[valuesById[5] = "MSG_RECEIVE_BY_LOAD_NEWER"] = 5;
        values[valuesById[6] = "MSG_RECEIVE_BY_CHECK_MSG_V1"] = 6;
        values[valuesById[7] = "MSG_RECEIVE_BY_CHECK_MSG_V2"] = 7;
        values[valuesById[8] = "MSG_RECEIVE_BY_STRANGER"] = 8;
        values[valuesById[9] = "MSG_SHOW"] = 9;
        return values;
    })();

    im_proto.ClientACKRequestBody = (function() {

        function ClientACKRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ClientACKRequestBody.prototype.start_time_stamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ClientACKRequestBody.prototype.cmd = 0;
        ClientACKRequestBody.prototype.network_type = 0;
        ClientACKRequestBody.prototype.logid = "";
        ClientACKRequestBody.prototype.client_time_stamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ClientACKRequestBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ClientACKRequestBody.prototype.type = 0;

        ClientACKRequestBody.create = function create(properties) {
            return new ClientACKRequestBody(properties);
        };

        ClientACKRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            w.uint32(8).int64(m.start_time_stamp);
            w.uint32(16).int32(m.cmd);
            if (m.network_type != null && Object.hasOwnProperty.call(m, "network_type"))
                w.uint32(24).int32(m.network_type);
            if (m.logid != null && Object.hasOwnProperty.call(m, "logid"))
                w.uint32(34).string(m.logid);
            if (m.client_time_stamp != null && Object.hasOwnProperty.call(m, "client_time_stamp"))
                w.uint32(40).int64(m.client_time_stamp);
            if (m.server_message_id != null && Object.hasOwnProperty.call(m, "server_message_id"))
                w.uint32(48).int64(m.server_message_id);
            w.uint32(56).int32(m.type);
            return w;
        };

        ClientACKRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ClientACKRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.start_time_stamp = r.int64();
                    break;
                case 2:
                    m.cmd = r.int32();
                    break;
                case 3:
                    m.network_type = r.int32();
                    break;
                case 4:
                    m.logid = r.string();
                    break;
                case 5:
                    m.client_time_stamp = r.int64();
                    break;
                case 6:
                    m.server_message_id = r.int64();
                    break;
                case 7:
                    m.type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            if (!m.hasOwnProperty("start_time_stamp"))
                throw $util.ProtocolError("missing required 'start_time_stamp'", { instance: m });
            if (!m.hasOwnProperty("cmd"))
                throw $util.ProtocolError("missing required 'cmd'", { instance: m });
            if (!m.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: m });
            return m;
        };

        return ClientACKRequestBody;
    })();

    im_proto.ClientBatchACKRequestBody = (function() {

        function ClientBatchACKRequestBody(p) {
            this.ack_list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ClientBatchACKRequestBody.prototype.ack_list = $util.emptyArray;

        ClientBatchACKRequestBody.create = function create(properties) {
            return new ClientBatchACKRequestBody(properties);
        };

        ClientBatchACKRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.ack_list != null && m.ack_list.length) {
                for (var i = 0; i < m.ack_list.length; ++i)
                    $root.im_proto.ClientACKRequestBody.encode(m.ack_list[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        ClientBatchACKRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ClientBatchACKRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.ack_list && m.ack_list.length))
                        m.ack_list = [];
                    m.ack_list.push($root.im_proto.ClientACKRequestBody.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ClientBatchACKRequestBody;
    })();

    im_proto.VoipMode = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "VOIP_MODE_DOUBLE"] = 0;
        values[valuesById[1] = "VOIP_MODE_MULTIPLAYER"] = 1;
        return values;
    })();

    im_proto.VoipStatusCode = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SUCCESS"] = 0;
        values[valuesById[4] = "VOIP_PARAMS_ERROR"] = 4;
        values[valuesById[18] = "VOIP_STATUS_ERROR"] = 18;
        values[valuesById[19] = "VOIP_CANCEL_ERROR"] = 19;
        values[valuesById[20] = "VOIP_OTHER_RESPONSE_ERROR"] = 20;
        values[valuesById[21] = "VOIP_CALLBACK_ERROR"] = 21;
        return values;
    })();

    im_proto.VoipStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "IDLE"] = 0;
        values[valuesById[1] = "CALLING"] = 1;
        values[valuesById[2] = "RINGING"] = 2;
        values[valuesById[3] = "ACCEPTED"] = 3;
        values[valuesById[4] = "ONTHECALL"] = 4;
        values[valuesById[101] = "TERMINATED"] = 101;
        values[valuesById[102] = "OCCUPIED"] = 102;
        values[valuesById[103] = "REFUSED"] = 103;
        values[valuesById[104] = "CANCELLED"] = 104;
        values[valuesById[105] = "UNAVAILABLE"] = 105;
        values[valuesById[106] = "RTCERROR"] = 106;
        values[valuesById[107] = "RTC_ENGINE_MISMATCH"] = 107;
        return values;
    })();

    im_proto.VoipType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "VOIP_TYPE_NOT_USED"] = 0;
        values[valuesById[1] = "VOIP_TYPE_ALL"] = 1;
        values[valuesById[2] = "VOIP_TYPE_VIDEOONLY"] = 2;
        values[valuesById[3] = "VOIP_TYPE_AUDIOONLY"] = 3;
        return values;
    })();

    im_proto.VoipInfo = (function() {

        function VoipInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        VoipInfo.prototype.user_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        VoipInfo.prototype.device_id = "";
        VoipInfo.prototype.channel_id = "";
        VoipInfo.prototype.token = "";
        VoipInfo.prototype.status = 0;
        VoipInfo.prototype.caller_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        VoipInfo.prototype.created_time_ms = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        VoipInfo.prototype.updated_time_ms = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        VoipInfo.prototype.con_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        VoipInfo.prototype.v_type = 0;
        VoipInfo.prototype.srv_msg_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        VoipInfo.create = function create(properties) {
            return new VoipInfo(properties);
        };

        VoipInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.user_id != null && Object.hasOwnProperty.call(m, "user_id"))
                w.uint32(8).int64(m.user_id);
            if (m.device_id != null && Object.hasOwnProperty.call(m, "device_id"))
                w.uint32(18).string(m.device_id);
            if (m.channel_id != null && Object.hasOwnProperty.call(m, "channel_id"))
                w.uint32(26).string(m.channel_id);
            if (m.token != null && Object.hasOwnProperty.call(m, "token"))
                w.uint32(34).string(m.token);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(40).int32(m.status);
            if (m.caller_id != null && Object.hasOwnProperty.call(m, "caller_id"))
                w.uint32(48).int64(m.caller_id);
            if (m.created_time_ms != null && Object.hasOwnProperty.call(m, "created_time_ms"))
                w.uint32(56).int64(m.created_time_ms);
            if (m.updated_time_ms != null && Object.hasOwnProperty.call(m, "updated_time_ms"))
                w.uint32(64).int64(m.updated_time_ms);
            if (m.con_short_id != null && Object.hasOwnProperty.call(m, "con_short_id"))
                w.uint32(72).int64(m.con_short_id);
            if (m.v_type != null && Object.hasOwnProperty.call(m, "v_type"))
                w.uint32(80).int32(m.v_type);
            if (m.srv_msg_id != null && Object.hasOwnProperty.call(m, "srv_msg_id"))
                w.uint32(88).int64(m.srv_msg_id);
            return w;
        };

        VoipInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.VoipInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.user_id = r.int64();
                    break;
                case 2:
                    m.device_id = r.string();
                    break;
                case 3:
                    m.channel_id = r.string();
                    break;
                case 4:
                    m.token = r.string();
                    break;
                case 5:
                    m.status = r.int32();
                    break;
                case 6:
                    m.caller_id = r.int64();
                    break;
                case 7:
                    m.created_time_ms = r.int64();
                    break;
                case 8:
                    m.updated_time_ms = r.int64();
                    break;
                case 9:
                    m.con_short_id = r.int64();
                    break;
                case 10:
                    m.v_type = r.int32();
                    break;
                case 11:
                    m.srv_msg_id = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return VoipInfo;
    })();

    im_proto.CreateVoipRequestBody = (function() {

        function CreateVoipRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CreateVoipRequestBody.prototype.idempotent_id = "";
        CreateVoipRequestBody.prototype.v_type = 0;
        CreateVoipRequestBody.prototype.con_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        CreateVoipRequestBody.prototype.srv_msg_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        CreateVoipRequestBody.prototype.ref_channel_id = "";
        CreateVoipRequestBody.prototype.voip_mode = 0;

        CreateVoipRequestBody.create = function create(properties) {
            return new CreateVoipRequestBody(properties);
        };

        CreateVoipRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.idempotent_id != null && Object.hasOwnProperty.call(m, "idempotent_id"))
                w.uint32(10).string(m.idempotent_id);
            if (m.v_type != null && Object.hasOwnProperty.call(m, "v_type"))
                w.uint32(16).int32(m.v_type);
            if (m.con_short_id != null && Object.hasOwnProperty.call(m, "con_short_id"))
                w.uint32(24).int64(m.con_short_id);
            if (m.srv_msg_id != null && Object.hasOwnProperty.call(m, "srv_msg_id"))
                w.uint32(32).int64(m.srv_msg_id);
            if (m.ref_channel_id != null && Object.hasOwnProperty.call(m, "ref_channel_id"))
                w.uint32(42).string(m.ref_channel_id);
            if (m.voip_mode != null && Object.hasOwnProperty.call(m, "voip_mode"))
                w.uint32(48).int32(m.voip_mode);
            return w;
        };

        CreateVoipRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.CreateVoipRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.idempotent_id = r.string();
                    break;
                case 2:
                    m.v_type = r.int32();
                    break;
                case 3:
                    m.con_short_id = r.int64();
                    break;
                case 4:
                    m.srv_msg_id = r.int64();
                    break;
                case 5:
                    m.ref_channel_id = r.string();
                    break;
                case 6:
                    m.voip_mode = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateVoipRequestBody;
    })();

    im_proto.CreateVoipResponseBody = (function() {

        function CreateVoipResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CreateVoipResponseBody.prototype.info = null;
        CreateVoipResponseBody.prototype.status_code = 0;
        CreateVoipResponseBody.prototype.voip_mode = 0;

        CreateVoipResponseBody.create = function create(properties) {
            return new CreateVoipResponseBody(properties);
        };

        CreateVoipResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.info != null && Object.hasOwnProperty.call(m, "info"))
                $root.im_proto.VoipInfo.encode(m.info, w.uint32(10).fork()).ldelim();
            if (m.status_code != null && Object.hasOwnProperty.call(m, "status_code"))
                w.uint32(16).int32(m.status_code);
            if (m.voip_mode != null && Object.hasOwnProperty.call(m, "voip_mode"))
                w.uint32(24).int32(m.voip_mode);
            return w;
        };

        CreateVoipResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.CreateVoipResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.info = $root.im_proto.VoipInfo.decode(r, r.uint32());
                    break;
                case 2:
                    m.status_code = r.int32();
                    break;
                case 3:
                    m.voip_mode = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreateVoipResponseBody;
    })();

    im_proto.CallVoipRequestBody = (function() {

        function CallVoipRequestBody(p) {
            this.callee_ids = [];
            this.ext = {};
            this.ref_channel_users = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CallVoipRequestBody.prototype.callee_ids = $util.emptyArray;
        CallVoipRequestBody.prototype.channel_id = "";
        CallVoipRequestBody.prototype.v_type = 0;
        CallVoipRequestBody.prototype.ext = $util.emptyObject;
        CallVoipRequestBody.prototype.ref_channel_users = $util.emptyArray;
        CallVoipRequestBody.prototype.con_id = "";

        CallVoipRequestBody.create = function create(properties) {
            return new CallVoipRequestBody(properties);
        };

        CallVoipRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.callee_ids != null && m.callee_ids.length) {
                for (var i = 0; i < m.callee_ids.length; ++i)
                    w.uint32(8).int64(m.callee_ids[i]);
            }
            if (m.channel_id != null && Object.hasOwnProperty.call(m, "channel_id"))
                w.uint32(18).string(m.channel_id);
            if (m.v_type != null && Object.hasOwnProperty.call(m, "v_type"))
                w.uint32(24).int32(m.v_type);
            if (m.ext != null && Object.hasOwnProperty.call(m, "ext")) {
                for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
                    w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
                }
            }
            if (m.ref_channel_users != null && m.ref_channel_users.length) {
                for (var i = 0; i < m.ref_channel_users.length; ++i)
                    w.uint32(40).int64(m.ref_channel_users[i]);
            }
            if (m.con_id != null && Object.hasOwnProperty.call(m, "con_id"))
                w.uint32(50).string(m.con_id);
            return w;
        };

        CallVoipRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.CallVoipRequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.callee_ids && m.callee_ids.length))
                        m.callee_ids = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.callee_ids.push(r.int64());
                    } else
                        m.callee_ids.push(r.int64());
                    break;
                case 2:
                    m.channel_id = r.string();
                    break;
                case 3:
                    m.v_type = r.int32();
                    break;
                case 4:
                    if (m.ext === $util.emptyObject)
                        m.ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.ext[k] = value;
                    break;
                case 5:
                    if (!(m.ref_channel_users && m.ref_channel_users.length))
                        m.ref_channel_users = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.ref_channel_users.push(r.int64());
                    } else
                        m.ref_channel_users.push(r.int64());
                    break;
                case 6:
                    m.con_id = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CallVoipRequestBody;
    })();

    im_proto.CallVoipResponseBody = (function() {

        function CallVoipResponseBody(p) {
            this.callee_ids = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CallVoipResponseBody.prototype.info = null;
        CallVoipResponseBody.prototype.callee_ids = $util.emptyArray;
        CallVoipResponseBody.prototype.status = 0;
        CallVoipResponseBody.prototype.extra_info = "";
        CallVoipResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        CallVoipResponseBody.prototype.check_message = "";
        CallVoipResponseBody.prototype.ref_channel_id = "";
        CallVoipResponseBody.prototype.voip_mode = 0;

        CallVoipResponseBody.create = function create(properties) {
            return new CallVoipResponseBody(properties);
        };

        CallVoipResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.info != null && Object.hasOwnProperty.call(m, "info"))
                $root.im_proto.VoipInfo.encode(m.info, w.uint32(10).fork()).ldelim();
            if (m.callee_ids != null && m.callee_ids.length) {
                for (var i = 0; i < m.callee_ids.length; ++i)
                    w.uint32(16).int64(m.callee_ids[i]);
            }
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(24).int32(m.status);
            if (m.extra_info != null && Object.hasOwnProperty.call(m, "extra_info"))
                w.uint32(34).string(m.extra_info);
            if (m.check_code != null && Object.hasOwnProperty.call(m, "check_code"))
                w.uint32(40).int64(m.check_code);
            if (m.check_message != null && Object.hasOwnProperty.call(m, "check_message"))
                w.uint32(50).string(m.check_message);
            if (m.ref_channel_id != null && Object.hasOwnProperty.call(m, "ref_channel_id"))
                w.uint32(58).string(m.ref_channel_id);
            if (m.voip_mode != null && Object.hasOwnProperty.call(m, "voip_mode"))
                w.uint32(64).int32(m.voip_mode);
            return w;
        };

        CallVoipResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.CallVoipResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.info = $root.im_proto.VoipInfo.decode(r, r.uint32());
                    break;
                case 2:
                    if (!(m.callee_ids && m.callee_ids.length))
                        m.callee_ids = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.callee_ids.push(r.int64());
                    } else
                        m.callee_ids.push(r.int64());
                    break;
                case 3:
                    m.status = r.int32();
                    break;
                case 4:
                    m.extra_info = r.string();
                    break;
                case 5:
                    m.check_code = r.int64();
                    break;
                case 6:
                    m.check_message = r.string();
                    break;
                case 7:
                    m.ref_channel_id = r.string();
                    break;
                case 8:
                    m.voip_mode = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CallVoipResponseBody;
    })();

    im_proto.UpdateVoipRequestBody = (function() {

        function UpdateVoipRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UpdateVoipRequestBody.prototype.channel_id = "";
        UpdateVoipRequestBody.prototype.status = 0;
        UpdateVoipRequestBody.prototype.v_type = 0;

        UpdateVoipRequestBody.create = function create(properties) {
            return new UpdateVoipRequestBody(properties);
        };

        UpdateVoipRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.channel_id != null && Object.hasOwnProperty.call(m, "channel_id"))
                w.uint32(10).string(m.channel_id);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(16).int32(m.status);
            if (m.v_type != null && Object.hasOwnProperty.call(m, "v_type"))
                w.uint32(24).int32(m.v_type);
            return w;
        };

        UpdateVoipRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.UpdateVoipRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.channel_id = r.string();
                    break;
                case 2:
                    m.status = r.int32();
                    break;
                case 3:
                    m.v_type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateVoipRequestBody;
    })();

    im_proto.UpdateVoipResponseBody = (function() {

        function UpdateVoipResponseBody(p) {
            this.callees = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UpdateVoipResponseBody.prototype.info = null;
        UpdateVoipResponseBody.prototype.status_code = 0;
        UpdateVoipResponseBody.prototype.voip_mode = 0;
        UpdateVoipResponseBody.prototype.callees = $util.emptyArray;

        UpdateVoipResponseBody.create = function create(properties) {
            return new UpdateVoipResponseBody(properties);
        };

        UpdateVoipResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.info != null && Object.hasOwnProperty.call(m, "info"))
                $root.im_proto.VoipInfo.encode(m.info, w.uint32(10).fork()).ldelim();
            if (m.status_code != null && Object.hasOwnProperty.call(m, "status_code"))
                w.uint32(16).int32(m.status_code);
            if (m.voip_mode != null && Object.hasOwnProperty.call(m, "voip_mode"))
                w.uint32(24).int32(m.voip_mode);
            if (m.callees != null && m.callees.length) {
                for (var i = 0; i < m.callees.length; ++i)
                    w.uint32(32).int64(m.callees[i]);
            }
            return w;
        };

        UpdateVoipResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.UpdateVoipResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.info = $root.im_proto.VoipInfo.decode(r, r.uint32());
                    break;
                case 2:
                    m.status_code = r.int32();
                    break;
                case 3:
                    m.voip_mode = r.int32();
                    break;
                case 4:
                    if (!(m.callees && m.callees.length))
                        m.callees = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.callees.push(r.int64());
                    } else
                        m.callees.push(r.int64());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateVoipResponseBody;
    })();

    im_proto.ChannelStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CHANNEL_STATUS_NOT_USED"] = 0;
        values[valuesById[1] = "ONLINE"] = 1;
        values[valuesById[2] = "OFFLINE"] = 2;
        return values;
    })();

    im_proto.ChannelHeartBeatRequestBody = (function() {

        function ChannelHeartBeatRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ChannelHeartBeatRequestBody.prototype.channel_id = "";

        ChannelHeartBeatRequestBody.create = function create(properties) {
            return new ChannelHeartBeatRequestBody(properties);
        };

        ChannelHeartBeatRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.channel_id != null && Object.hasOwnProperty.call(m, "channel_id"))
                w.uint32(10).string(m.channel_id);
            return w;
        };

        ChannelHeartBeatRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ChannelHeartBeatRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.channel_id = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ChannelHeartBeatRequestBody;
    })();

    im_proto.Profile = (function() {

        function Profile(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Profile.prototype.nick_name = "";
        Profile.prototype.protrait = "";
        Profile.prototype.basic_ext_info = "";
        Profile.prototype.detail_ext_info = "";

        Profile.create = function create(properties) {
            return new Profile(properties);
        };

        Profile.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.nick_name != null && Object.hasOwnProperty.call(m, "nick_name"))
                w.uint32(10).string(m.nick_name);
            if (m.protrait != null && Object.hasOwnProperty.call(m, "protrait"))
                w.uint32(18).string(m.protrait);
            if (m.basic_ext_info != null && Object.hasOwnProperty.call(m, "basic_ext_info"))
                w.uint32(26).string(m.basic_ext_info);
            if (m.detail_ext_info != null && Object.hasOwnProperty.call(m, "detail_ext_info"))
                w.uint32(34).string(m.detail_ext_info);
            return w;
        };

        Profile.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.Profile();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.nick_name = r.string();
                    break;
                case 2:
                    m.protrait = r.string();
                    break;
                case 3:
                    m.basic_ext_info = r.string();
                    break;
                case 4:
                    m.detail_ext_info = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Profile;
    })();

    im_proto.ProfileGetInfoRequestBody = (function() {

        function ProfileGetInfoRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ProfileGetInfoRequestBody.prototype.userid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        ProfileGetInfoRequestBody.create = function create(properties) {
            return new ProfileGetInfoRequestBody(properties);
        };

        ProfileGetInfoRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            w.uint32(8).int64(m.userid);
            return w;
        };

        ProfileGetInfoRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ProfileGetInfoRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.userid = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            if (!m.hasOwnProperty("userid"))
                throw $util.ProtocolError("missing required 'userid'", { instance: m });
            return m;
        };

        return ProfileGetInfoRequestBody;
    })();

    im_proto.ProfileGetInfoResponseBody = (function() {

        function ProfileGetInfoResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ProfileGetInfoResponseBody.prototype.profile = null;

        ProfileGetInfoResponseBody.create = function create(properties) {
            return new ProfileGetInfoResponseBody(properties);
        };

        ProfileGetInfoResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.profile != null && Object.hasOwnProperty.call(m, "profile"))
                $root.im_proto.Profile.encode(m.profile, w.uint32(10).fork()).ldelim();
            return w;
        };

        ProfileGetInfoResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ProfileGetInfoResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.profile = $root.im_proto.Profile.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ProfileGetInfoResponseBody;
    })();

    im_proto.ClientMetricType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "COUNTER"] = 0;
        values[valuesById[1] = "TIMER"] = 1;
        return values;
    })();

    im_proto.ClientMetric = (function() {

        function ClientMetric(p) {
            this.tags = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ClientMetric.prototype.metric_type = 0;
        ClientMetric.prototype.k = "";
        ClientMetric.prototype.v = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ClientMetric.prototype.tags = $util.emptyObject;

        ClientMetric.create = function create(properties) {
            return new ClientMetric(properties);
        };

        ClientMetric.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.metric_type != null && Object.hasOwnProperty.call(m, "metric_type"))
                w.uint32(8).int32(m.metric_type);
            if (m.k != null && Object.hasOwnProperty.call(m, "k"))
                w.uint32(18).string(m.k);
            if (m.v != null && Object.hasOwnProperty.call(m, "v"))
                w.uint32(24).int64(m.v);
            if (m.tags != null && Object.hasOwnProperty.call(m, "tags")) {
                for (var ks = Object.keys(m.tags), i = 0; i < ks.length; ++i) {
                    w.uint32(34).fork().uint32(10).string(ks[i]).uint32(18).string(m.tags[ks[i]]).ldelim();
                }
            }
            return w;
        };

        ClientMetric.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ClientMetric(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.metric_type = r.int32();
                    break;
                case 2:
                    m.k = r.string();
                    break;
                case 3:
                    m.v = r.int64();
                    break;
                case 4:
                    if (m.tags === $util.emptyObject)
                        m.tags = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.tags[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ClientMetric;
    })();

    im_proto.ReportClientMetricsRequestBody = (function() {

        function ReportClientMetricsRequestBody(p) {
            this.report_metrics_list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ReportClientMetricsRequestBody.prototype.report_metrics_list = $util.emptyArray;

        ReportClientMetricsRequestBody.create = function create(properties) {
            return new ReportClientMetricsRequestBody(properties);
        };

        ReportClientMetricsRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.report_metrics_list != null && m.report_metrics_list.length) {
                for (var i = 0; i < m.report_metrics_list.length; ++i)
                    $root.im_proto.ClientMetric.encode(m.report_metrics_list[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        ReportClientMetricsRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ReportClientMetricsRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.report_metrics_list && m.report_metrics_list.length))
                        m.report_metrics_list = [];
                    m.report_metrics_list.push($root.im_proto.ClientMetric.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ReportClientMetricsRequestBody;
    })();

    im_proto.GetConfigsRequestBody = (function() {

        function GetConfigsRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetConfigsRequestBody.create = function create(properties) {
            return new GetConfigsRequestBody(properties);
        };

        GetConfigsRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            return w;
        };

        GetConfigsRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetConfigsRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetConfigsRequestBody;
    })();

    im_proto.GetConfigsResponseBody = (function() {

        function GetConfigsResponseBody(p) {
            this.configs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetConfigsResponseBody.prototype.version = 0;
        GetConfigsResponseBody.prototype.configs = $util.emptyArray;

        GetConfigsResponseBody.create = function create(properties) {
            return new GetConfigsResponseBody(properties);
        };

        GetConfigsResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.version != null && Object.hasOwnProperty.call(m, "version"))
                w.uint32(8).int32(m.version);
            if (m.configs != null && m.configs.length) {
                for (var i = 0; i < m.configs.length; ++i)
                    $root.im_proto.Config.encode(m.configs[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        GetConfigsResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetConfigsResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.version = r.int32();
                    break;
                case 2:
                    if (!(m.configs && m.configs.length))
                        m.configs = [];
                    m.configs.push($root.im_proto.Config.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetConfigsResponseBody;
    })();

    im_proto.Config = (function() {

        function Config(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Config.prototype.conf_name = "";
        Config.prototype.conf_value = "";

        Config.create = function create(properties) {
            return new Config(properties);
        };

        Config.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conf_name != null && Object.hasOwnProperty.call(m, "conf_name"))
                w.uint32(10).string(m.conf_name);
            if (m.conf_value != null && Object.hasOwnProperty.call(m, "conf_value"))
                w.uint32(18).string(m.conf_value);
            return w;
        };

        Config.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.Config();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conf_name = r.string();
                    break;
                case 2:
                    m.conf_value = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Config;
    })();

    im_proto.SendMessageP2PRequestBody = (function() {

        function SendMessageP2PRequestBody(p) {
            this.visible_user = [];
            this.invisible_user = [];
            this.ext = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SendMessageP2PRequestBody.prototype.send_type = 0;
        SendMessageP2PRequestBody.prototype.conversation_id = "";
        SendMessageP2PRequestBody.prototype.conversation_type = 0;
        SendMessageP2PRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        SendMessageP2PRequestBody.prototype.visible_user = $util.emptyArray;
        SendMessageP2PRequestBody.prototype.invisible_user = $util.emptyArray;
        SendMessageP2PRequestBody.prototype.message_type = 0;
        SendMessageP2PRequestBody.prototype.content = "";
        SendMessageP2PRequestBody.prototype.ext = $util.emptyObject;
        SendMessageP2PRequestBody.prototype.client_message_id = "";

        SendMessageP2PRequestBody.create = function create(properties) {
            return new SendMessageP2PRequestBody(properties);
        };

        SendMessageP2PRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.send_type != null && Object.hasOwnProperty.call(m, "send_type"))
                w.uint32(8).int32(m.send_type);
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(18).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(32).int64(m.conversation_short_id);
            if (m.visible_user != null && m.visible_user.length) {
                for (var i = 0; i < m.visible_user.length; ++i)
                    w.uint32(40).int64(m.visible_user[i]);
            }
            if (m.invisible_user != null && m.invisible_user.length) {
                for (var i = 0; i < m.invisible_user.length; ++i)
                    w.uint32(48).int64(m.invisible_user[i]);
            }
            if (m.message_type != null && Object.hasOwnProperty.call(m, "message_type"))
                w.uint32(56).int32(m.message_type);
            if (m.content != null && Object.hasOwnProperty.call(m, "content"))
                w.uint32(66).string(m.content);
            if (m.ext != null && Object.hasOwnProperty.call(m, "ext")) {
                for (var ks = Object.keys(m.ext), i = 0; i < ks.length; ++i) {
                    w.uint32(74).fork().uint32(10).string(ks[i]).uint32(18).string(m.ext[ks[i]]).ldelim();
                }
            }
            if (m.client_message_id != null && Object.hasOwnProperty.call(m, "client_message_id"))
                w.uint32(82).string(m.client_message_id);
            return w;
        };

        SendMessageP2PRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.SendMessageP2PRequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.send_type = r.int32();
                    break;
                case 2:
                    m.conversation_id = r.string();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    m.conversation_short_id = r.int64();
                    break;
                case 5:
                    if (!(m.visible_user && m.visible_user.length))
                        m.visible_user = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.visible_user.push(r.int64());
                    } else
                        m.visible_user.push(r.int64());
                    break;
                case 6:
                    if (!(m.invisible_user && m.invisible_user.length))
                        m.invisible_user = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.invisible_user.push(r.int64());
                    } else
                        m.invisible_user.push(r.int64());
                    break;
                case 7:
                    m.message_type = r.int32();
                    break;
                case 8:
                    m.content = r.string();
                    break;
                case 9:
                    if (m.ext === $util.emptyObject)
                        m.ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.ext[k] = value;
                    break;
                case 10:
                    m.client_message_id = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SendMessageP2PRequestBody;
    })();

    im_proto.SendMessageP2PResponseBody = (function() {

        function SendMessageP2PResponseBody(p) {
            this.failed_user = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SendMessageP2PResponseBody.prototype.failed_user = $util.emptyArray;

        SendMessageP2PResponseBody.create = function create(properties) {
            return new SendMessageP2PResponseBody(properties);
        };

        SendMessageP2PResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.failed_user != null && m.failed_user.length) {
                for (var i = 0; i < m.failed_user.length; ++i)
                    w.uint32(8).int64(m.failed_user[i]);
            }
            return w;
        };

        SendMessageP2PResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.SendMessageP2PResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.failed_user && m.failed_user.length))
                        m.failed_user = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.failed_user.push(r.int64());
                    } else
                        m.failed_user.push(r.int64());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SendMessageP2PResponseBody;
    })();

    im_proto.ConvCountReport = (function() {

        function ConvCountReport(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConvCountReport.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConvCountReport.prototype.unread_count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConvCountReport.prototype.conversation_type = 1;

        ConvCountReport.create = function create(properties) {
            return new ConvCountReport(properties);
        };

        ConvCountReport.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conv_short_id != null && Object.hasOwnProperty.call(m, "conv_short_id"))
                w.uint32(8).int64(m.conv_short_id);
            if (m.unread_count != null && Object.hasOwnProperty.call(m, "unread_count"))
                w.uint32(16).int64(m.unread_count);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            return w;
        };

        ConvCountReport.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConvCountReport();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conv_short_id = r.int64();
                    break;
                case 2:
                    m.unread_count = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ConvCountReport;
    })();

    im_proto.UnReadCountReportRequestBody = (function() {

        function UnReadCountReportRequestBody(p) {
            this.conv_unread_count = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UnReadCountReportRequestBody.prototype.total_unread_count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        UnReadCountReportRequestBody.prototype.conv_unread_count = $util.emptyArray;

        UnReadCountReportRequestBody.create = function create(properties) {
            return new UnReadCountReportRequestBody(properties);
        };

        UnReadCountReportRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.total_unread_count != null && Object.hasOwnProperty.call(m, "total_unread_count"))
                w.uint32(8).int64(m.total_unread_count);
            if (m.conv_unread_count != null && m.conv_unread_count.length) {
                for (var i = 0; i < m.conv_unread_count.length; ++i)
                    $root.im_proto.ConvCountReport.encode(m.conv_unread_count[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        UnReadCountReportRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.UnReadCountReportRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.total_unread_count = r.int64();
                    break;
                case 2:
                    if (!(m.conv_unread_count && m.conv_unread_count.length))
                        m.conv_unread_count = [];
                    m.conv_unread_count.push($root.im_proto.ConvCountReport.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UnReadCountReportRequestBody;
    })();

    im_proto.UnReadCountReportResponseBody = (function() {

        function UnReadCountReportResponseBody(p) {
            this.failed_conv_list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UnReadCountReportResponseBody.prototype.set_total_status = false;
        UnReadCountReportResponseBody.prototype.failed_conv_list = $util.emptyArray;

        UnReadCountReportResponseBody.create = function create(properties) {
            return new UnReadCountReportResponseBody(properties);
        };

        UnReadCountReportResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            w.uint32(8).bool(m.set_total_status);
            if (m.failed_conv_list != null && m.failed_conv_list.length) {
                for (var i = 0; i < m.failed_conv_list.length; ++i)
                    w.uint32(16).int64(m.failed_conv_list[i]);
            }
            return w;
        };

        UnReadCountReportResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.UnReadCountReportResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.set_total_status = r.bool();
                    break;
                case 2:
                    if (!(m.failed_conv_list && m.failed_conv_list.length))
                        m.failed_conv_list = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.failed_conv_list.push(r.int64());
                    } else
                        m.failed_conv_list.push(r.int64());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            if (!m.hasOwnProperty("set_total_status"))
                throw $util.ProtocolError("missing required 'set_total_status'", { instance: m });
            return m;
        };

        return UnReadCountReportResponseBody;
    })();

    im_proto.GetUnreadCountRequestBody = (function() {

        function GetUnreadCountRequestBody(p) {
            this.conv_short_id = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetUnreadCountRequestBody.prototype.get_total = false;
        GetUnreadCountRequestBody.prototype.conv_short_id = $util.emptyArray;

        GetUnreadCountRequestBody.create = function create(properties) {
            return new GetUnreadCountRequestBody(properties);
        };

        GetUnreadCountRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.get_total != null && Object.hasOwnProperty.call(m, "get_total"))
                w.uint32(8).bool(m.get_total);
            if (m.conv_short_id != null && m.conv_short_id.length) {
                for (var i = 0; i < m.conv_short_id.length; ++i)
                    w.uint32(16).int64(m.conv_short_id[i]);
            }
            return w;
        };

        GetUnreadCountRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetUnreadCountRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.get_total = r.bool();
                    break;
                case 2:
                    if (!(m.conv_short_id && m.conv_short_id.length))
                        m.conv_short_id = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.conv_short_id.push(r.int64());
                    } else
                        m.conv_short_id.push(r.int64());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetUnreadCountRequestBody;
    })();

    im_proto.GetUnreadCountResponseBody = (function() {

        function GetUnreadCountResponseBody(p) {
            this.conv_unread_count = {};
            this.failed_conv_list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetUnreadCountResponseBody.prototype.total_unread_count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetUnreadCountResponseBody.prototype.conv_unread_count = $util.emptyObject;
        GetUnreadCountResponseBody.prototype.failed_conv_list = $util.emptyArray;

        GetUnreadCountResponseBody.create = function create(properties) {
            return new GetUnreadCountResponseBody(properties);
        };

        GetUnreadCountResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.total_unread_count != null && Object.hasOwnProperty.call(m, "total_unread_count"))
                w.uint32(8).int64(m.total_unread_count);
            if (m.conv_unread_count != null && Object.hasOwnProperty.call(m, "conv_unread_count")) {
                for (var ks = Object.keys(m.conv_unread_count), i = 0; i < ks.length; ++i) {
                    w.uint32(18).fork().uint32(8).int64(ks[i]).uint32(16).int64(m.conv_unread_count[ks[i]]).ldelim();
                }
            }
            if (m.failed_conv_list != null && m.failed_conv_list.length) {
                for (var i = 0; i < m.failed_conv_list.length; ++i)
                    w.uint32(24).int64(m.failed_conv_list[i]);
            }
            return w;
        };

        GetUnreadCountResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetUnreadCountResponseBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.total_unread_count = r.int64();
                    break;
                case 2:
                    if (m.conv_unread_count === $util.emptyObject)
                        m.conv_unread_count = {};
                    var c2 = r.uint32() + r.pos;
                    k = 0;
                    value = 0;
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.int64();
                            break;
                        case 2:
                            value = r.int64();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.conv_unread_count[typeof k === "object" ? $util.longToHash(k) : k] = value;
                    break;
                case 3:
                    if (!(m.failed_conv_list && m.failed_conv_list.length))
                        m.failed_conv_list = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.failed_conv_list.push(r.int64());
                    } else
                        m.failed_conv_list.push(r.int64());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetUnreadCountResponseBody;
    })();

    im_proto.GetBlockListRequestBody = (function() {

        function GetBlockListRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetBlockListRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetBlockListRequestBody.prototype.limit = 0;

        GetBlockListRequestBody.create = function create(properties) {
            return new GetBlockListRequestBody(properties);
        };

        GetBlockListRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.cursor != null && Object.hasOwnProperty.call(m, "cursor"))
                w.uint32(8).int64(m.cursor);
            if (m.limit != null && Object.hasOwnProperty.call(m, "limit"))
                w.uint32(16).int32(m.limit);
            return w;
        };

        GetBlockListRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetBlockListRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.cursor = r.int64();
                    break;
                case 2:
                    m.limit = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetBlockListRequestBody;
    })();

    im_proto.BlockUserInfo = (function() {

        function BlockUserInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BlockUserInfo.prototype.user_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        BlockUserInfo.prototype.create_time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        BlockUserInfo.create = function create(properties) {
            return new BlockUserInfo(properties);
        };

        BlockUserInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.user_id != null && Object.hasOwnProperty.call(m, "user_id"))
                w.uint32(8).int64(m.user_id);
            if (m.create_time != null && Object.hasOwnProperty.call(m, "create_time"))
                w.uint32(16).int64(m.create_time);
            return w;
        };

        BlockUserInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.BlockUserInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.user_id = r.int64();
                    break;
                case 2:
                    m.create_time = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BlockUserInfo;
    })();

    im_proto.GetBlockListResponseBody = (function() {

        function GetBlockListResponseBody(p) {
            this.user_info = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetBlockListResponseBody.prototype.user_info = $util.emptyArray;
        GetBlockListResponseBody.prototype.has_more = false;
        GetBlockListResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        GetBlockListResponseBody.create = function create(properties) {
            return new GetBlockListResponseBody(properties);
        };

        GetBlockListResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.user_info != null && m.user_info.length) {
                for (var i = 0; i < m.user_info.length; ++i)
                    $root.im_proto.BlockUserInfo.encode(m.user_info[i], w.uint32(10).fork()).ldelim();
            }
            if (m.has_more != null && Object.hasOwnProperty.call(m, "has_more"))
                w.uint32(16).bool(m.has_more);
            if (m.next_cursor != null && Object.hasOwnProperty.call(m, "next_cursor"))
                w.uint32(24).int64(m.next_cursor);
            return w;
        };

        GetBlockListResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetBlockListResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.user_info && m.user_info.length))
                        m.user_info = [];
                    m.user_info.push($root.im_proto.BlockUserInfo.decode(r, r.uint32()));
                    break;
                case 2:
                    m.has_more = r.bool();
                    break;
                case 3:
                    m.next_cursor = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetBlockListResponseBody;
    })();

    im_proto.SetBlocklistRequestBody = (function() {

        function SetBlocklistRequestBody(p) {
            this.blocklist = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SetBlocklistRequestBody.prototype.set_block_list = false;
        SetBlocklistRequestBody.prototype.blocklist = $util.emptyArray;

        SetBlocklistRequestBody.create = function create(properties) {
            return new SetBlocklistRequestBody(properties);
        };

        SetBlocklistRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.set_block_list != null && Object.hasOwnProperty.call(m, "set_block_list"))
                w.uint32(8).bool(m.set_block_list);
            if (m.blocklist != null && m.blocklist.length) {
                for (var i = 0; i < m.blocklist.length; ++i)
                    w.uint32(16).int64(m.blocklist[i]);
            }
            return w;
        };

        SetBlocklistRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.SetBlocklistRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.set_block_list = r.bool();
                    break;
                case 2:
                    if (!(m.blocklist && m.blocklist.length))
                        m.blocklist = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.blocklist.push(r.int64());
                    } else
                        m.blocklist.push(r.int64());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SetBlocklistRequestBody;
    })();

    im_proto.SetBlocklistResponseBody = (function() {

        function SetBlocklistResponseBody(p) {
            this.failed_list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SetBlocklistResponseBody.prototype.failed_list = $util.emptyArray;

        SetBlocklistResponseBody.create = function create(properties) {
            return new SetBlocklistResponseBody(properties);
        };

        SetBlocklistResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.failed_list != null && m.failed_list.length) {
                for (var i = 0; i < m.failed_list.length; ++i)
                    w.uint32(8).int64(m.failed_list[i]);
            }
            return w;
        };

        SetBlocklistResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.SetBlocklistResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.failed_list && m.failed_list.length))
                        m.failed_list = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.failed_list.push(r.int64());
                    } else
                        m.failed_list.push(r.int64());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SetBlocklistResponseBody;
    })();

    im_proto.CheckInBlockListRequestBody = (function() {

        function CheckInBlockListRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CheckInBlockListRequestBody.prototype.user_to_check = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        CheckInBlockListRequestBody.create = function create(properties) {
            return new CheckInBlockListRequestBody(properties);
        };

        CheckInBlockListRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.user_to_check != null && Object.hasOwnProperty.call(m, "user_to_check"))
                w.uint32(8).int64(m.user_to_check);
            return w;
        };

        CheckInBlockListRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.CheckInBlockListRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.user_to_check = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CheckInBlockListRequestBody;
    })();

    im_proto.CheckInBlockListResponseBody = (function() {

        function CheckInBlockListResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CheckInBlockListResponseBody.prototype.in_blocklist = false;

        CheckInBlockListResponseBody.create = function create(properties) {
            return new CheckInBlockListResponseBody(properties);
        };

        CheckInBlockListResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.in_blocklist != null && Object.hasOwnProperty.call(m, "in_blocklist"))
                w.uint32(8).bool(m.in_blocklist);
            return w;
        };

        CheckInBlockListResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.CheckInBlockListResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.in_blocklist = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CheckInBlockListResponseBody;
    })();

    im_proto.BlockStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNBLOCK"] = 0;
        values[valuesById[1] = "BLOCK"] = 1;
        return values;
    })();

    im_proto.BlockMembersRequestBody = (function() {

        function BlockMembersRequestBody(p) {
            this.block_time = {};
            this.biz_ext = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BlockMembersRequestBody.prototype.block_status = 0;
        BlockMembersRequestBody.prototype.block_time = $util.emptyObject;
        BlockMembersRequestBody.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        BlockMembersRequestBody.prototype.conversation_type = 0;
        BlockMembersRequestBody.prototype.conversation_id = "";
        BlockMembersRequestBody.prototype.biz_ext = $util.emptyObject;

        BlockMembersRequestBody.create = function create(properties) {
            return new BlockMembersRequestBody(properties);
        };

        BlockMembersRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.block_status != null && Object.hasOwnProperty.call(m, "block_status"))
                w.uint32(8).int32(m.block_status);
            if (m.block_time != null && Object.hasOwnProperty.call(m, "block_time")) {
                for (var ks = Object.keys(m.block_time), i = 0; i < ks.length; ++i) {
                    w.uint32(18).fork().uint32(8).int64(ks[i]).uint32(16).int64(m.block_time[ks[i]]).ldelim();
                }
            }
            if (m.conv_short_id != null && Object.hasOwnProperty.call(m, "conv_short_id"))
                w.uint32(24).int64(m.conv_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(32).int32(m.conversation_type);
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(42).string(m.conversation_id);
            if (m.biz_ext != null && Object.hasOwnProperty.call(m, "biz_ext")) {
                for (var ks = Object.keys(m.biz_ext), i = 0; i < ks.length; ++i) {
                    w.uint32(90).fork().uint32(10).string(ks[i]).uint32(18).string(m.biz_ext[ks[i]]).ldelim();
                }
            }
            return w;
        };

        BlockMembersRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.BlockMembersRequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.block_status = r.int32();
                    break;
                case 2:
                    if (m.block_time === $util.emptyObject)
                        m.block_time = {};
                    var c2 = r.uint32() + r.pos;
                    k = 0;
                    value = 0;
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.int64();
                            break;
                        case 2:
                            value = r.int64();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.block_time[typeof k === "object" ? $util.longToHash(k) : k] = value;
                    break;
                case 3:
                    m.conv_short_id = r.int64();
                    break;
                case 4:
                    m.conversation_type = r.int32();
                    break;
                case 5:
                    m.conversation_id = r.string();
                    break;
                case 11:
                    if (m.biz_ext === $util.emptyObject)
                        m.biz_ext = {};
                    var c2 = r.uint32() + r.pos;
                    k = "";
                    value = "";
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.string();
                            break;
                        case 2:
                            value = r.string();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.biz_ext[k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BlockMembersRequestBody;
    })();

    im_proto.BlockMembersResponseBody = (function() {

        function BlockMembersResponseBody(p) {
            this.failed_members = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BlockMembersResponseBody.prototype.failed_members = $util.emptyArray;

        BlockMembersResponseBody.create = function create(properties) {
            return new BlockMembersResponseBody(properties);
        };

        BlockMembersResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.failed_members != null && m.failed_members.length) {
                for (var i = 0; i < m.failed_members.length; ++i)
                    w.uint32(8).int64(m.failed_members[i]);
            }
            return w;
        };

        BlockMembersResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.BlockMembersResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.failed_members && m.failed_members.length))
                        m.failed_members = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.failed_members.push(r.int64());
                    } else
                        m.failed_members.push(r.int64());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BlockMembersResponseBody;
    })();

    im_proto.BlockConversationRequestBody = (function() {

        function BlockConversationRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BlockConversationRequestBody.prototype.conversation_id = "";
        BlockConversationRequestBody.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        BlockConversationRequestBody.prototype.conversation_type = 0;
        BlockConversationRequestBody.prototype.block_status = 0;
        BlockConversationRequestBody.prototype.block_normal_only = false;

        BlockConversationRequestBody.create = function create(properties) {
            return new BlockConversationRequestBody(properties);
        };

        BlockConversationRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conv_short_id != null && Object.hasOwnProperty.call(m, "conv_short_id"))
                w.uint32(16).int64(m.conv_short_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            if (m.block_status != null && Object.hasOwnProperty.call(m, "block_status"))
                w.uint32(32).int32(m.block_status);
            if (m.block_normal_only != null && Object.hasOwnProperty.call(m, "block_normal_only"))
                w.uint32(40).bool(m.block_normal_only);
            return w;
        };

        BlockConversationRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.BlockConversationRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conv_short_id = r.int64();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                case 4:
                    m.block_status = r.int32();
                    break;
                case 5:
                    m.block_normal_only = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BlockConversationRequestBody;
    })();

    im_proto.GetMessagesCheckInfoInConversationRequestBody = (function() {

        function GetMessagesCheckInfoInConversationRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetMessagesCheckInfoInConversationRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetMessagesCheckInfoInConversationRequestBody.prototype.conversation_id = "";
        GetMessagesCheckInfoInConversationRequestBody.prototype.conversation_type = 0;
        GetMessagesCheckInfoInConversationRequestBody.prototype.cursor_reverse_begin = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetMessagesCheckInfoInConversationRequestBody.prototype.cursor_reverse_end = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        GetMessagesCheckInfoInConversationRequestBody.prototype.expect_msg_total_count = 0;

        GetMessagesCheckInfoInConversationRequestBody.create = function create(properties) {
            return new GetMessagesCheckInfoInConversationRequestBody(properties);
        };

        GetMessagesCheckInfoInConversationRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(16).int64(m.conversation_short_id);
            if (m.cursor_reverse_begin != null && Object.hasOwnProperty.call(m, "cursor_reverse_begin"))
                w.uint32(24).int64(m.cursor_reverse_begin);
            if (m.expect_msg_total_count != null && Object.hasOwnProperty.call(m, "expect_msg_total_count"))
                w.uint32(32).int32(m.expect_msg_total_count);
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(42).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(48).int32(m.conversation_type);
            if (m.cursor_reverse_end != null && Object.hasOwnProperty.call(m, "cursor_reverse_end"))
                w.uint32(56).int64(m.cursor_reverse_end);
            return w;
        };

        GetMessagesCheckInfoInConversationRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetMessagesCheckInfoInConversationRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 2:
                    m.conversation_short_id = r.int64();
                    break;
                case 5:
                    m.conversation_id = r.string();
                    break;
                case 6:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.cursor_reverse_begin = r.int64();
                    break;
                case 7:
                    m.cursor_reverse_end = r.int64();
                    break;
                case 4:
                    m.expect_msg_total_count = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetMessagesCheckInfoInConversationRequestBody;
    })();

    im_proto.MessagesCheckInfo = (function() {

        function MessagesCheckInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MessagesCheckInfo.prototype.head_msg_index = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessagesCheckInfo.prototype.tail_msg_index = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessagesCheckInfo.prototype.msg_count = 0;
        MessagesCheckInfo.prototype.indexes_checksum = 0;

        MessagesCheckInfo.create = function create(properties) {
            return new MessagesCheckInfo(properties);
        };

        MessagesCheckInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.head_msg_index != null && Object.hasOwnProperty.call(m, "head_msg_index"))
                w.uint32(8).int64(m.head_msg_index);
            if (m.tail_msg_index != null && Object.hasOwnProperty.call(m, "tail_msg_index"))
                w.uint32(16).int64(m.tail_msg_index);
            if (m.msg_count != null && Object.hasOwnProperty.call(m, "msg_count"))
                w.uint32(24).int32(m.msg_count);
            if (m.indexes_checksum != null && Object.hasOwnProperty.call(m, "indexes_checksum"))
                w.uint32(32).uint32(m.indexes_checksum);
            return w;
        };

        MessagesCheckInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MessagesCheckInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.head_msg_index = r.int64();
                    break;
                case 2:
                    m.tail_msg_index = r.int64();
                    break;
                case 3:
                    m.msg_count = r.int32();
                    break;
                case 4:
                    m.indexes_checksum = r.uint32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MessagesCheckInfo;
    })();

    im_proto.GetMessagesCheckInfoInConversationResponseBody = (function() {

        function GetMessagesCheckInfoInConversationResponseBody(p) {
            this.msgs_checkinfo_list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetMessagesCheckInfoInConversationResponseBody.prototype.msgs_checkinfo_list = $util.emptyArray;
        GetMessagesCheckInfoInConversationResponseBody.prototype.real_msg_total_count = 0;
        GetMessagesCheckInfoInConversationResponseBody.prototype.cursor_reverse_next = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        GetMessagesCheckInfoInConversationResponseBody.create = function create(properties) {
            return new GetMessagesCheckInfoInConversationResponseBody(properties);
        };

        GetMessagesCheckInfoInConversationResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgs_checkinfo_list != null && m.msgs_checkinfo_list.length) {
                for (var i = 0; i < m.msgs_checkinfo_list.length; ++i)
                    $root.im_proto.MessagesCheckInfo.encode(m.msgs_checkinfo_list[i], w.uint32(10).fork()).ldelim();
            }
            if (m.real_msg_total_count != null && Object.hasOwnProperty.call(m, "real_msg_total_count"))
                w.uint32(16).int32(m.real_msg_total_count);
            if (m.cursor_reverse_next != null && Object.hasOwnProperty.call(m, "cursor_reverse_next"))
                w.uint32(32).int64(m.cursor_reverse_next);
            return w;
        };

        GetMessagesCheckInfoInConversationResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetMessagesCheckInfoInConversationResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.msgs_checkinfo_list && m.msgs_checkinfo_list.length))
                        m.msgs_checkinfo_list = [];
                    m.msgs_checkinfo_list.push($root.im_proto.MessagesCheckInfo.decode(r, r.uint32()));
                    break;
                case 2:
                    m.real_msg_total_count = r.int32();
                    break;
                case 4:
                    m.cursor_reverse_next = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetMessagesCheckInfoInConversationResponseBody;
    })();

    im_proto.ConversationCheckInfo = (function() {

        function ConversationCheckInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationCheckInfo.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        ConversationCheckInfo.prototype.conversation_id = "";
        ConversationCheckInfo.prototype.conversation_type = 0;

        ConversationCheckInfo.create = function create(properties) {
            return new ConversationCheckInfo(properties);
        };

        ConversationCheckInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(8).int64(m.conversation_short_id);
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(18).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(24).int32(m.conversation_type);
            return w;
        };

        ConversationCheckInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationCheckInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_short_id = r.int64();
                    break;
                case 2:
                    m.conversation_id = r.string();
                    break;
                case 3:
                    m.conversation_type = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ConversationCheckInfo;
    })();

    im_proto.GetConversationsCheckInfoResponseBody = (function() {

        function GetConversationsCheckInfoResponseBody(p) {
            this.conversation_checkinfo_list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetConversationsCheckInfoResponseBody.prototype.conversation_checkinfo_list = $util.emptyArray;

        GetConversationsCheckInfoResponseBody.create = function create(properties) {
            return new GetConversationsCheckInfoResponseBody(properties);
        };

        GetConversationsCheckInfoResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_checkinfo_list != null && m.conversation_checkinfo_list.length) {
                for (var i = 0; i < m.conversation_checkinfo_list.length; ++i)
                    $root.im_proto.ConversationCheckInfo.encode(m.conversation_checkinfo_list[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        GetConversationsCheckInfoResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.GetConversationsCheckInfoResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.conversation_checkinfo_list && m.conversation_checkinfo_list.length))
                        m.conversation_checkinfo_list = [];
                    m.conversation_checkinfo_list.push($root.im_proto.ConversationCheckInfo.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetConversationsCheckInfoResponseBody;
    })();

    im_proto.ActionType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_ACTION"] = 0;
        values[valuesById[1] = "FAVORITE"] = 1;
        values[valuesById[2] = "PIN"] = 2;
        values[valuesById[3] = "UNREAD"] = 3;
        return values;
    })();

    im_proto.MarkMessageRequestBody = (function() {

        function MarkMessageRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MarkMessageRequestBody.prototype.conversation_id = "";
        MarkMessageRequestBody.prototype.conversation_type = 0;
        MarkMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MarkMessageRequestBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MarkMessageRequestBody.prototype.do_action = false;
        MarkMessageRequestBody.prototype.action_type = 0;
        MarkMessageRequestBody.prototype.sort_time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MarkMessageRequestBody.prototype.tag = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        MarkMessageRequestBody.create = function create(properties) {
            return new MarkMessageRequestBody(properties);
        };

        MarkMessageRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(24).int64(m.conversation_short_id);
            if (m.server_message_id != null && Object.hasOwnProperty.call(m, "server_message_id"))
                w.uint32(32).int64(m.server_message_id);
            if (m.do_action != null && Object.hasOwnProperty.call(m, "do_action"))
                w.uint32(40).bool(m.do_action);
            if (m.action_type != null && Object.hasOwnProperty.call(m, "action_type"))
                w.uint32(48).int32(m.action_type);
            if (m.sort_time != null && Object.hasOwnProperty.call(m, "sort_time"))
                w.uint32(56).int64(m.sort_time);
            if (m.tag != null && Object.hasOwnProperty.call(m, "tag"))
                w.uint32(64).int64(m.tag);
            return w;
        };

        MarkMessageRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MarkMessageRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.conversation_short_id = r.int64();
                    break;
                case 4:
                    m.server_message_id = r.int64();
                    break;
                case 5:
                    m.do_action = r.bool();
                    break;
                case 6:
                    m.action_type = r.int32();
                    break;
                case 7:
                    m.sort_time = r.int64();
                    break;
                case 8:
                    m.tag = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MarkMessageRequestBody;
    })();

    im_proto.MarkMessageResponseBody = (function() {

        function MarkMessageResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MarkMessageResponseBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MarkMessageResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MarkMessageResponseBody.prototype.check_message = "";
        MarkMessageResponseBody.prototype.status = 0;

        MarkMessageResponseBody.create = function create(properties) {
            return new MarkMessageResponseBody(properties);
        };

        MarkMessageResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.server_message_id != null && Object.hasOwnProperty.call(m, "server_message_id"))
                w.uint32(8).int64(m.server_message_id);
            if (m.check_code != null && Object.hasOwnProperty.call(m, "check_code"))
                w.uint32(16).int64(m.check_code);
            if (m.check_message != null && Object.hasOwnProperty.call(m, "check_message"))
                w.uint32(26).string(m.check_message);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(32).int32(m.status);
            return w;
        };

        MarkMessageResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MarkMessageResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.server_message_id = r.int64();
                    break;
                case 2:
                    m.check_code = r.int64();
                    break;
                case 3:
                    m.check_message = r.string();
                    break;
                case 4:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MarkMessageResponseBody;
    })();

    im_proto.PullMarkMessageRequestBody = (function() {

        function PullMarkMessageRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PullMarkMessageRequestBody.prototype.conversation_id = "";
        PullMarkMessageRequestBody.prototype.conversation_type = 0;
        PullMarkMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        PullMarkMessageRequestBody.prototype.cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        PullMarkMessageRequestBody.prototype.limit = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        PullMarkMessageRequestBody.prototype.asc = false;
        PullMarkMessageRequestBody.prototype.action_type = 0;
        PullMarkMessageRequestBody.prototype.tag = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        PullMarkMessageRequestBody.prototype.clear_unread_count = false;

        PullMarkMessageRequestBody.create = function create(properties) {
            return new PullMarkMessageRequestBody(properties);
        };

        PullMarkMessageRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(24).int64(m.conversation_short_id);
            if (m.cursor != null && Object.hasOwnProperty.call(m, "cursor"))
                w.uint32(32).int64(m.cursor);
            if (m.limit != null && Object.hasOwnProperty.call(m, "limit"))
                w.uint32(40).int64(m.limit);
            if (m.asc != null && Object.hasOwnProperty.call(m, "asc"))
                w.uint32(48).bool(m.asc);
            if (m.action_type != null && Object.hasOwnProperty.call(m, "action_type"))
                w.uint32(56).int32(m.action_type);
            if (m.tag != null && Object.hasOwnProperty.call(m, "tag"))
                w.uint32(64).int64(m.tag);
            if (m.clear_unread_count != null && Object.hasOwnProperty.call(m, "clear_unread_count"))
                w.uint32(72).bool(m.clear_unread_count);
            return w;
        };

        PullMarkMessageRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.PullMarkMessageRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.conversation_short_id = r.int64();
                    break;
                case 4:
                    m.cursor = r.int64();
                    break;
                case 5:
                    m.limit = r.int64();
                    break;
                case 6:
                    m.asc = r.bool();
                    break;
                case 7:
                    m.action_type = r.int32();
                    break;
                case 8:
                    m.tag = r.int64();
                    break;
                case 9:
                    m.clear_unread_count = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PullMarkMessageRequestBody;
    })();

    im_proto.PullMarkMessageResponseBody = (function() {

        function PullMarkMessageResponseBody(p) {
            this.messages = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PullMarkMessageResponseBody.prototype.messages = $util.emptyArray;
        PullMarkMessageResponseBody.prototype.has_more = false;
        PullMarkMessageResponseBody.prototype.next_cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        PullMarkMessageResponseBody.create = function create(properties) {
            return new PullMarkMessageResponseBody(properties);
        };

        PullMarkMessageResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.messages != null && m.messages.length) {
                for (var i = 0; i < m.messages.length; ++i)
                    $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(10).fork()).ldelim();
            }
            if (m.has_more != null && Object.hasOwnProperty.call(m, "has_more"))
                w.uint32(16).bool(m.has_more);
            if (m.next_cursor != null && Object.hasOwnProperty.call(m, "next_cursor"))
                w.uint32(24).int64(m.next_cursor);
            return w;
        };

        PullMarkMessageResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.PullMarkMessageResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.messages && m.messages.length))
                        m.messages = [];
                    m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
                    break;
                case 2:
                    m.has_more = r.bool();
                    break;
                case 3:
                    m.next_cursor = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PullMarkMessageResponseBody;
    })();

    im_proto.MessageByInitRequestBody = (function() {

        function MessageByInitRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MessageByInitRequestBody.prototype.version = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessageByInitRequestBody.prototype.page = 0;
        MessageByInitRequestBody.prototype.conv_limit = 0;
        MessageByInitRequestBody.prototype.msg_limit = 0;

        MessageByInitRequestBody.create = function create(properties) {
            return new MessageByInitRequestBody(properties);
        };

        MessageByInitRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.version != null && Object.hasOwnProperty.call(m, "version"))
                w.uint32(8).int64(m.version);
            if (m.page != null && Object.hasOwnProperty.call(m, "page"))
                w.uint32(16).int32(m.page);
            if (m.conv_limit != null && Object.hasOwnProperty.call(m, "conv_limit"))
                w.uint32(24).int32(m.conv_limit);
            if (m.msg_limit != null && Object.hasOwnProperty.call(m, "msg_limit"))
                w.uint32(32).int32(m.msg_limit);
            return w;
        };

        MessageByInitRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MessageByInitRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.version = r.int64();
                    break;
                case 2:
                    m.page = r.int32();
                    break;
                case 3:
                    m.conv_limit = r.int32();
                    break;
                case 4:
                    m.msg_limit = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MessageByInitRequestBody;
    })();

    im_proto.MessageByInitResponseBody = (function() {

        function MessageByInitResponseBody(p) {
            this.messages = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MessageByInitResponseBody.prototype.messages = $util.emptyArray;
        MessageByInitResponseBody.prototype.has_more = false;
        MessageByInitResponseBody.prototype.next_init_version = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessageByInitResponseBody.prototype.version = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessageByInitResponseBody.prototype.user_cursor = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessageByInitResponseBody.prototype.cmd_index = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MessageByInitResponseBody.prototype.readconv_version = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        MessageByInitResponseBody.create = function create(properties) {
            return new MessageByInitResponseBody(properties);
        };

        MessageByInitResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.messages != null && m.messages.length) {
                for (var i = 0; i < m.messages.length; ++i)
                    $root.im_proto.ConversationMessage.encode(m.messages[i], w.uint32(10).fork()).ldelim();
            }
            w.uint32(16).bool(m.has_more);
            w.uint32(24).int64(m.next_init_version);
            if (m.version != null && Object.hasOwnProperty.call(m, "version"))
                w.uint32(32).int64(m.version);
            if (m.user_cursor != null && Object.hasOwnProperty.call(m, "user_cursor"))
                w.uint32(40).int64(m.user_cursor);
            if (m.cmd_index != null && Object.hasOwnProperty.call(m, "cmd_index"))
                w.uint32(48).int64(m.cmd_index);
            if (m.readconv_version != null && Object.hasOwnProperty.call(m, "readconv_version"))
                w.uint32(56).int64(m.readconv_version);
            return w;
        };

        MessageByInitResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MessageByInitResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.messages && m.messages.length))
                        m.messages = [];
                    m.messages.push($root.im_proto.ConversationMessage.decode(r, r.uint32()));
                    break;
                case 2:
                    m.has_more = r.bool();
                    break;
                case 3:
                    m.next_init_version = r.int64();
                    break;
                case 4:
                    m.version = r.int64();
                    break;
                case 5:
                    m.user_cursor = r.int64();
                    break;
                case 6:
                    m.cmd_index = r.int64();
                    break;
                case 7:
                    m.readconv_version = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            if (!m.hasOwnProperty("has_more"))
                throw $util.ProtocolError("missing required 'has_more'", { instance: m });
            if (!m.hasOwnProperty("next_init_version"))
                throw $util.ProtocolError("missing required 'next_init_version'", { instance: m });
            return m;
        };

        return MessageByInitResponseBody;
    })();

    im_proto.ConversationMessage = (function() {

        function ConversationMessage(p) {
            this.messages = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ConversationMessage.prototype.conversations = null;
        ConversationMessage.prototype.messages = $util.emptyArray;

        ConversationMessage.create = function create(properties) {
            return new ConversationMessage(properties);
        };

        ConversationMessage.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            $root.im_proto.ConversationInfoV2.encode(m.conversations, w.uint32(10).fork()).ldelim();
            if (m.messages != null && m.messages.length) {
                for (var i = 0; i < m.messages.length; ++i)
                    $root.im_proto.MessageBody.encode(m.messages[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        ConversationMessage.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.ConversationMessage();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversations = $root.im_proto.ConversationInfoV2.decode(r, r.uint32());
                    break;
                case 2:
                    if (!(m.messages && m.messages.length))
                        m.messages = [];
                    m.messages.push($root.im_proto.MessageBody.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            if (!m.hasOwnProperty("conversations"))
                throw $util.ProtocolError("missing required 'conversations'", { instance: m });
            return m;
        };

        return ConversationMessage;
    })();

    im_proto.MessageStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "AVAILABLE"] = 0;
        values[valuesById[1] = "NOT_EXIST"] = 1;
        values[valuesById[2] = "INVISIBLE"] = 2;
        values[valuesById[3] = "RECALLED"] = 3;
        values[valuesById[4] = "DELETED"] = 4;
        return values;
    })();

    im_proto.BatchUnmarkMessageRequestBody = (function() {

        function BatchUnmarkMessageRequestBody(p) {
            this.server_message_ids = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BatchUnmarkMessageRequestBody.prototype.conversation_id = "";
        BatchUnmarkMessageRequestBody.prototype.conversation_type = 0;
        BatchUnmarkMessageRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        BatchUnmarkMessageRequestBody.prototype.server_message_ids = $util.emptyArray;
        BatchUnmarkMessageRequestBody.prototype.action_type = 0;
        BatchUnmarkMessageRequestBody.prototype.tag = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        BatchUnmarkMessageRequestBody.create = function create(properties) {
            return new BatchUnmarkMessageRequestBody(properties);
        };

        BatchUnmarkMessageRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(24).int64(m.conversation_short_id);
            if (m.server_message_ids != null && m.server_message_ids.length) {
                for (var i = 0; i < m.server_message_ids.length; ++i)
                    w.uint32(32).int64(m.server_message_ids[i]);
            }
            if (m.action_type != null && Object.hasOwnProperty.call(m, "action_type"))
                w.uint32(40).int32(m.action_type);
            if (m.tag != null && Object.hasOwnProperty.call(m, "tag"))
                w.uint32(48).int64(m.tag);
            return w;
        };

        BatchUnmarkMessageRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.BatchUnmarkMessageRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.conversation_short_id = r.int64();
                    break;
                case 4:
                    if (!(m.server_message_ids && m.server_message_ids.length))
                        m.server_message_ids = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.server_message_ids.push(r.int64());
                    } else
                        m.server_message_ids.push(r.int64());
                    break;
                case 5:
                    m.action_type = r.int32();
                    break;
                case 6:
                    m.tag = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BatchUnmarkMessageRequestBody;
    })();

    im_proto.BatchUnmarkMessageResponseBody = (function() {

        function BatchUnmarkMessageResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BatchUnmarkMessageResponseBody.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        BatchUnmarkMessageResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        BatchUnmarkMessageResponseBody.prototype.check_message = "";
        BatchUnmarkMessageResponseBody.prototype.status = 0;

        BatchUnmarkMessageResponseBody.create = function create(properties) {
            return new BatchUnmarkMessageResponseBody(properties);
        };

        BatchUnmarkMessageResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.server_message_id != null && Object.hasOwnProperty.call(m, "server_message_id"))
                w.uint32(8).int64(m.server_message_id);
            if (m.check_code != null && Object.hasOwnProperty.call(m, "check_code"))
                w.uint32(16).int64(m.check_code);
            if (m.check_message != null && Object.hasOwnProperty.call(m, "check_message"))
                w.uint32(26).string(m.check_message);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(32).int32(m.status);
            return w;
        };

        BatchUnmarkMessageResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.BatchUnmarkMessageResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.server_message_id = r.int64();
                    break;
                case 2:
                    m.check_code = r.int64();
                    break;
                case 3:
                    m.check_message = r.string();
                    break;
                case 4:
                    m.status = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return BatchUnmarkMessageResponseBody;
    })();

    im_proto.MarkMsgUnreadCountReportRequestBody = (function() {

        function MarkMsgUnreadCountReportRequestBody(p) {
            this.tag_unread_count = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MarkMsgUnreadCountReportRequestBody.prototype.conversation_id = "";
        MarkMsgUnreadCountReportRequestBody.prototype.conversation_type = 0;
        MarkMsgUnreadCountReportRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MarkMsgUnreadCountReportRequestBody.prototype.total_unread_count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MarkMsgUnreadCountReportRequestBody.prototype.tag_unread_count = $util.emptyObject;

        MarkMsgUnreadCountReportRequestBody.create = function create(properties) {
            return new MarkMsgUnreadCountReportRequestBody(properties);
        };

        MarkMsgUnreadCountReportRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(24).int64(m.conversation_short_id);
            if (m.total_unread_count != null && Object.hasOwnProperty.call(m, "total_unread_count"))
                w.uint32(32).int64(m.total_unread_count);
            if (m.tag_unread_count != null && Object.hasOwnProperty.call(m, "tag_unread_count")) {
                for (var ks = Object.keys(m.tag_unread_count), i = 0; i < ks.length; ++i) {
                    w.uint32(42).fork().uint32(8).int64(ks[i]).uint32(16).int64(m.tag_unread_count[ks[i]]).ldelim();
                }
            }
            return w;
        };

        MarkMsgUnreadCountReportRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MarkMsgUnreadCountReportRequestBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.conversation_short_id = r.int64();
                    break;
                case 4:
                    m.total_unread_count = r.int64();
                    break;
                case 5:
                    if (m.tag_unread_count === $util.emptyObject)
                        m.tag_unread_count = {};
                    var c2 = r.uint32() + r.pos;
                    k = 0;
                    value = 0;
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.int64();
                            break;
                        case 2:
                            value = r.int64();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.tag_unread_count[typeof k === "object" ? $util.longToHash(k) : k] = value;
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MarkMsgUnreadCountReportRequestBody;
    })();

    im_proto.MarkMsgUnreadCountReportResponseBody = (function() {

        function MarkMsgUnreadCountReportResponseBody(p) {
            this.failed_tag_list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MarkMsgUnreadCountReportResponseBody.prototype.set_total_status = false;
        MarkMsgUnreadCountReportResponseBody.prototype.failed_tag_list = $util.emptyArray;

        MarkMsgUnreadCountReportResponseBody.create = function create(properties) {
            return new MarkMsgUnreadCountReportResponseBody(properties);
        };

        MarkMsgUnreadCountReportResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.set_total_status != null && Object.hasOwnProperty.call(m, "set_total_status"))
                w.uint32(8).bool(m.set_total_status);
            if (m.failed_tag_list != null && m.failed_tag_list.length) {
                for (var i = 0; i < m.failed_tag_list.length; ++i)
                    w.uint32(16).int64(m.failed_tag_list[i]);
            }
            return w;
        };

        MarkMsgUnreadCountReportResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MarkMsgUnreadCountReportResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.set_total_status = r.bool();
                    break;
                case 2:
                    if (!(m.failed_tag_list && m.failed_tag_list.length))
                        m.failed_tag_list = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.failed_tag_list.push(r.int64());
                    } else
                        m.failed_tag_list.push(r.int64());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MarkMsgUnreadCountReportResponseBody;
    })();

    im_proto.MarkMsgGetUnreadCountRequestBody = (function() {

        function MarkMsgGetUnreadCountRequestBody(p) {
            this.tags = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MarkMsgGetUnreadCountRequestBody.prototype.conversation_id = "";
        MarkMsgGetUnreadCountRequestBody.prototype.conversation_type = 0;
        MarkMsgGetUnreadCountRequestBody.prototype.conversation_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MarkMsgGetUnreadCountRequestBody.prototype.get_total = false;
        MarkMsgGetUnreadCountRequestBody.prototype.tags = $util.emptyArray;

        MarkMsgGetUnreadCountRequestBody.create = function create(properties) {
            return new MarkMsgGetUnreadCountRequestBody(properties);
        };

        MarkMsgGetUnreadCountRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.conversation_id != null && Object.hasOwnProperty.call(m, "conversation_id"))
                w.uint32(10).string(m.conversation_id);
            if (m.conversation_type != null && Object.hasOwnProperty.call(m, "conversation_type"))
                w.uint32(16).int32(m.conversation_type);
            if (m.conversation_short_id != null && Object.hasOwnProperty.call(m, "conversation_short_id"))
                w.uint32(24).int64(m.conversation_short_id);
            if (m.get_total != null && Object.hasOwnProperty.call(m, "get_total"))
                w.uint32(32).bool(m.get_total);
            if (m.tags != null && m.tags.length) {
                for (var i = 0; i < m.tags.length; ++i)
                    w.uint32(40).int64(m.tags[i]);
            }
            return w;
        };

        MarkMsgGetUnreadCountRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MarkMsgGetUnreadCountRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.conversation_id = r.string();
                    break;
                case 2:
                    m.conversation_type = r.int32();
                    break;
                case 3:
                    m.conversation_short_id = r.int64();
                    break;
                case 4:
                    m.get_total = r.bool();
                    break;
                case 5:
                    if (!(m.tags && m.tags.length))
                        m.tags = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.tags.push(r.int64());
                    } else
                        m.tags.push(r.int64());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MarkMsgGetUnreadCountRequestBody;
    })();

    im_proto.MarkMsgGetUnreadCountResponseBody = (function() {

        function MarkMsgGetUnreadCountResponseBody(p) {
            this.tag_unread_count = {};
            this.failed_tag_list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        MarkMsgGetUnreadCountResponseBody.prototype.total_count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        MarkMsgGetUnreadCountResponseBody.prototype.tag_unread_count = $util.emptyObject;
        MarkMsgGetUnreadCountResponseBody.prototype.failed_tag_list = $util.emptyArray;

        MarkMsgGetUnreadCountResponseBody.create = function create(properties) {
            return new MarkMsgGetUnreadCountResponseBody(properties);
        };

        MarkMsgGetUnreadCountResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.total_count != null && Object.hasOwnProperty.call(m, "total_count"))
                w.uint32(8).int64(m.total_count);
            if (m.tag_unread_count != null && Object.hasOwnProperty.call(m, "tag_unread_count")) {
                for (var ks = Object.keys(m.tag_unread_count), i = 0; i < ks.length; ++i) {
                    w.uint32(18).fork().uint32(8).int64(ks[i]).uint32(16).int64(m.tag_unread_count[ks[i]]).ldelim();
                }
            }
            if (m.failed_tag_list != null && m.failed_tag_list.length) {
                for (var i = 0; i < m.failed_tag_list.length; ++i)
                    w.uint32(24).int64(m.failed_tag_list[i]);
            }
            return w;
        };

        MarkMsgGetUnreadCountResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.MarkMsgGetUnreadCountResponseBody(), k, value;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.total_count = r.int64();
                    break;
                case 2:
                    if (m.tag_unread_count === $util.emptyObject)
                        m.tag_unread_count = {};
                    var c2 = r.uint32() + r.pos;
                    k = 0;
                    value = 0;
                    while (r.pos < c2) {
                        var tag2 = r.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            k = r.int64();
                            break;
                        case 2:
                            value = r.int64();
                            break;
                        default:
                            r.skipType(tag2 & 7);
                            break;
                        }
                    }
                    m.tag_unread_count[typeof k === "object" ? $util.longToHash(k) : k] = value;
                    break;
                case 3:
                    if (!(m.failed_tag_list && m.failed_tag_list.length))
                        m.failed_tag_list = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.failed_tag_list.push(r.int64());
                    } else
                        m.failed_tag_list.push(r.int64());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return MarkMsgGetUnreadCountResponseBody;
    })();

    im_proto.AudioRecognitionRequestInfo = (function() {

        function AudioRecognitionRequestInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        AudioRecognitionRequestInfo.prototype.content = "";
        AudioRecognitionRequestInfo.prototype.uid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        AudioRecognitionRequestInfo.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        AudioRecognitionRequestInfo.prototype.audio_option = null;
        AudioRecognitionRequestInfo.prototype.conv_short_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        AudioRecognitionRequestInfo.create = function create(properties) {
            return new AudioRecognitionRequestInfo(properties);
        };

        AudioRecognitionRequestInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            w.uint32(10).string(m.content);
            w.uint32(16).int64(m.uid);
            w.uint32(24).int64(m.server_message_id);
            $root.im_proto.AudioOption.encode(m.audio_option, w.uint32(42).fork()).ldelim();
            w.uint32(48).int64(m.conv_short_id);
            return w;
        };

        AudioRecognitionRequestInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.AudioRecognitionRequestInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.content = r.string();
                    break;
                case 2:
                    m.uid = r.int64();
                    break;
                case 3:
                    m.server_message_id = r.int64();
                    break;
                case 5:
                    m.audio_option = $root.im_proto.AudioOption.decode(r, r.uint32());
                    break;
                case 6:
                    m.conv_short_id = r.int64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            if (!m.hasOwnProperty("content"))
                throw $util.ProtocolError("missing required 'content'", { instance: m });
            if (!m.hasOwnProperty("uid"))
                throw $util.ProtocolError("missing required 'uid'", { instance: m });
            if (!m.hasOwnProperty("server_message_id"))
                throw $util.ProtocolError("missing required 'server_message_id'", { instance: m });
            if (!m.hasOwnProperty("audio_option"))
                throw $util.ProtocolError("missing required 'audio_option'", { instance: m });
            if (!m.hasOwnProperty("conv_short_id"))
                throw $util.ProtocolError("missing required 'conv_short_id'", { instance: m });
            return m;
        };

        return AudioRecognitionRequestInfo;
    })();

    im_proto.AudioRecognitionRequestBody = (function() {

        function AudioRecognitionRequestBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        AudioRecognitionRequestBody.prototype.audio = null;

        AudioRecognitionRequestBody.create = function create(properties) {
            return new AudioRecognitionRequestBody(properties);
        };

        AudioRecognitionRequestBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            $root.im_proto.AudioRecognitionRequestInfo.encode(m.audio, w.uint32(10).fork()).ldelim();
            return w;
        };

        AudioRecognitionRequestBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.AudioRecognitionRequestBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.audio = $root.im_proto.AudioRecognitionRequestInfo.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            if (!m.hasOwnProperty("audio"))
                throw $util.ProtocolError("missing required 'audio'", { instance: m });
            return m;
        };

        return AudioRecognitionRequestBody;
    })();

    im_proto.AudioRecognitionResponseInfo = (function() {

        function AudioRecognitionResponseInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        AudioRecognitionResponseInfo.prototype.uid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        AudioRecognitionResponseInfo.prototype.server_message_id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        AudioRecognitionResponseInfo.prototype.audio_text = "";
        AudioRecognitionResponseInfo.prototype.content = "";

        AudioRecognitionResponseInfo.create = function create(properties) {
            return new AudioRecognitionResponseInfo(properties);
        };

        AudioRecognitionResponseInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            w.uint32(8).int64(m.uid);
            w.uint32(16).int64(m.server_message_id);
            w.uint32(26).string(m.audio_text);
            w.uint32(34).string(m.content);
            return w;
        };

        AudioRecognitionResponseInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.AudioRecognitionResponseInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.uid = r.int64();
                    break;
                case 2:
                    m.server_message_id = r.int64();
                    break;
                case 3:
                    m.audio_text = r.string();
                    break;
                case 4:
                    m.content = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            if (!m.hasOwnProperty("uid"))
                throw $util.ProtocolError("missing required 'uid'", { instance: m });
            if (!m.hasOwnProperty("server_message_id"))
                throw $util.ProtocolError("missing required 'server_message_id'", { instance: m });
            if (!m.hasOwnProperty("audio_text"))
                throw $util.ProtocolError("missing required 'audio_text'", { instance: m });
            if (!m.hasOwnProperty("content"))
                throw $util.ProtocolError("missing required 'content'", { instance: m });
            return m;
        };

        return AudioRecognitionResponseInfo;
    })();

    im_proto.AudioRecognitionResponseBody = (function() {

        function AudioRecognitionResponseBody(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        AudioRecognitionResponseBody.prototype.check_code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
        AudioRecognitionResponseBody.prototype.check_message = "";
        AudioRecognitionResponseBody.prototype.audio = null;

        AudioRecognitionResponseBody.create = function create(properties) {
            return new AudioRecognitionResponseBody(properties);
        };

        AudioRecognitionResponseBody.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.check_code != null && Object.hasOwnProperty.call(m, "check_code"))
                w.uint32(8).int64(m.check_code);
            if (m.check_message != null && Object.hasOwnProperty.call(m, "check_message"))
                w.uint32(18).string(m.check_message);
            $root.im_proto.AudioRecognitionResponseInfo.encode(m.audio, w.uint32(26).fork()).ldelim();
            return w;
        };

        AudioRecognitionResponseBody.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.im_proto.AudioRecognitionResponseBody();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.check_code = r.int64();
                    break;
                case 2:
                    m.check_message = r.string();
                    break;
                case 3:
                    m.audio = $root.im_proto.AudioRecognitionResponseInfo.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            if (!m.hasOwnProperty("audio"))
                throw $util.ProtocolError("missing required 'audio'", { instance: m });
            return m;
        };

        return AudioRecognitionResponseBody;
    })();

    return im_proto;
})();

export { $root as default, im_proto };
//# sourceMappingURL=index.js.map
